var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source2, exclude) => {
  var target = {};
  for (var prop in source2)
    if (__hasOwnProp.call(source2, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source2[prop];
  if (source2 != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source2)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source2, prop))
        target[prop] = source2[prop];
    }
  return target;
};
import api, { v1Url, v3Url, pagination } from "@teamwork/fetcher";
import { provide, inject, shallowRef, computed, onUnmounted, watch, triggerRef, getCurrentScope, getCurrentInstance, onScopeDispose, createApp, reactive, toRefs, ref, unref, effectScope } from "vue-demi";
import { useDebounceFn, useEventListener, isObject as isObject$1, pausableWatch, useIntersectionObserver } from "@vueuse/core";
import moment from "moment";
import lscache from "lscache";
const AxiosSymbol = Symbol("Axios instance");
function provideAxios(axios2) {
  provide(AxiosSymbol, axios2);
}
function useAxios() {
  return inject(AxiosSymbol, api);
}
const brandingSymbol = Symbol("branding");
function provideBranding(branding) {
  provide(brandingSymbol, branding);
}
function useBranding() {
  return inject(brandingSymbol);
}
const currentAccountSymbol = Symbol("currentAccount");
function provideCurrentAccount(currentAccount) {
  provide(currentAccountSymbol, currentAccount);
}
function useCurrentAccount() {
  return inject(currentAccountSymbol);
}
const currentUserSymbol = Symbol("currentUser");
function provideCurrentUser(currentUser) {
  provide(currentUserSymbol, currentUser);
}
function useCurrentUser() {
  return inject(currentUserSymbol);
}
const useRealTimeUpdatesSymbol = Symbol("realTimeUpdates");
function normalizeRawEvent(rawEvent) {
  const eventInfo = rawEvent.eventInfo || {};
  const extraInfo = eventInfo.extraInfo || {};
  let data2 = extraInfo.data || {};
  if (typeof data2 === "string") {
    try {
      data2 = JSON.parse(data2);
    } catch {
      console.warn(`Failed to parse twimEvent.eventInfo.extraInfo.data: ${data2}`);
      data2 = {};
    }
  }
  return __spreadProps(__spreadValues({}, rawEvent), {
    eventInfo: __spreadProps(__spreadValues({}, eventInfo), {
      extraInfo: __spreadProps(__spreadValues({}, extraInfo), {
        data: __spreadValues({}, data2)
      })
    })
  });
}
function toId(value) {
  return Number(value) || null;
}
function toCategoryType(categoryType) {
  switch (categoryType) {
    case "projects":
      return "project";
    case "files":
      return "file";
    case "notebooks":
      return "notebook";
    case "messages":
      return "message";
    case "links":
      return "link";
    default:
      return categoryType;
  }
}
function toFileId(link) {
  if (typeof link !== "string") {
    return null;
  }
  const match2 = /^files\/(\d+)/.exec(link);
  if (!match2) {
    return null;
  }
  return Number(match2[1]);
}
function normalize({ eventInfo: event }) {
  const { extraInfo } = event;
  switch (event.itemType) {
    case "task":
      return {
        type: "task",
        action: event.actionType,
        detail: event.event,
        projectId: toId(event.projectId),
        taskListId: toId(extraInfo.taskListId),
        previousTaskListId: toId(extraInfo.data.oldTaskListId),
        parentTaskId: toId(extraInfo.parentTaskId),
        taskId: toId(event.itemId),
        milestoneId: toId(extraInfo.data.milestoneId || extraInfo.data.newMilestoneId),
        previousMilestoneId: toId(extraInfo.data.oldMilestoneId)
      };
    case "tasklist":
    case "taskList":
      return {
        type: "taskList",
        action: event.actionType,
        detail: event.event,
        projectId: toId(event.projectId),
        taskListId: toId(event.itemId)
      };
    case "tasklistTasks":
    case "taskListTasks":
      return {
        type: "taskListTasks",
        action: event.actionType,
        detail: event.event,
        projectId: toId(event.projectId),
        taskListId: toId(event.itemId)
      };
    case "projectTasks":
      return {
        type: "projectTasks",
        action: event.actionType,
        detail: event.event,
        projectId: toId(event.projectId)
      };
    case "file_comment":
    case "task_comment": {
      const hasFile = extraInfo.objectType === "file";
      const hasTask = extraInfo.objectType === "task";
      return {
        type: "comment",
        action: event.actionType,
        detail: event.event,
        projectId: toId(event.projectId),
        fileId: toFileId(hasFile && (event.extraLink || event.itemLink)),
        fileVersionId: toId(hasFile && extraInfo.objectId),
        taskListId: toId(hasTask && extraInfo.taskListId),
        parentTaskId: toId(hasTask && extraInfo.parentTaskId),
        taskId: toId(hasTask && extraInfo.objectId),
        commentId: toId(event.itemId)
      };
    }
    case "milestone":
      return {
        type: "milestone",
        action: event.actionType,
        detail: event.event,
        projectId: toId(event.projectId),
        milestoneId: toId(event.itemId)
      };
    case "event":
      return {
        type: "event",
        action: event.actionType,
        detail: event.event,
        eventId: toId(event.itemId)
      };
    case "time": {
      const hasTask = extraInfo.objectType === "task";
      return {
        type: "time",
        action: event.actionType,
        detail: event.event,
        projectId: toId(event.projectId),
        taskListId: toId(hasTask && (extraInfo.taskListId || extraInfo.data.oldTaskListId)),
        parentTaskId: toId(hasTask && (extraInfo.parentTaskId || extraInfo.data.oldParentTaskId)),
        taskId: toId(hasTask && (extraInfo.objectId || extraInfo.data.oldTaskId)),
        timeId: toId(event.itemId)
      };
    }
    case "file":
      return {
        type: "file",
        action: event.actionType,
        detail: event.event,
        projectId: toId(event.projectId),
        fileId: toFileId(event.itemLink),
        fileVersionId: toId(event.itemId)
      };
    case "project":
      return {
        type: "project",
        action: event.actionType,
        detail: event.event,
        projectId: toId(event.projectId),
        userId: toId(extraInfo.data.userId),
        categoryChanged: Boolean(extraInfo.data.categoryChanged)
      };
    case "budget":
      return {
        type: "budget",
        action: event.actionType,
        detail: event.event,
        projectId: toId(event.projectId),
        budgetId: toId(event.itemId)
      };
    case "tasklistBudget":
      return {
        type: "tasklistBudget",
        action: event.actionType,
        detail: event.event,
        tasklistId: toId(event.tasklistId),
        projectBudgetId: toId(event.projectBudgetId),
        tasklistBudgetId: toId(event.itemId)
      };
    case "budgetExpense":
      return {
        type: "budgetExpense",
        action: event.actionType,
        detail: event.event,
        projectBudgetId: toId(event.projectBudgetId),
        budgetExpenseId: toId(event.itemId)
      };
    case "category":
      return {
        type: "category",
        action: event.actionType,
        detail: event.event,
        projectId: toId(event.projectId),
        categoryId: toId(event.itemId),
        categoryType: toCategoryType(extraInfo.data.categoryType || extraInfo.data.catgoryType)
      };
    case "person":
      return {
        type: "person",
        action: event.actionType,
        detail: event.event,
        userId: toId(event.itemId)
      };
    case "installation":
      return {
        type: "installation",
        action: event.actionType,
        detail: event.event,
        installationId: toId(event.installationId)
      };
    case "reminder": {
      const hasTask = extraInfo.objectType === "task";
      return {
        type: "reminder",
        action: event.actionType,
        detail: event.event,
        projectId: toId(event.projectId),
        taskListId: toId(hasTask && extraInfo.taskListId),
        taskId: toId(hasTask && extraInfo.objectId),
        parentTaskId: toId(hasTask && extraInfo.parentTaskId),
        reminderId: toId(event.itemId)
      };
    }
    case "custom_type":
      return {
        type: "customfield",
        action: event.actionType,
        detail: event.event,
        projectId: toId(event.projectId),
        customfieldId: toId(event.itemId)
      };
    case "account":
      return {
        type: "account",
        action: event.actionType,
        detail: event.event,
        accountId: toId(event.itemId)
      };
    case "inboxItem":
      return {
        type: "inboxItem",
        action: event.event,
        entity: event.entity,
        inboxItemId: toId(event.id)
      };
    case "customreport":
      return {
        type: "customReport",
        action: event.actionType,
        customReportId: toId(event.itemId),
        detail: event.event
      };
    case "report":
      return {
        type: "report",
        action: event.actionType,
        reportId: toId(event.itemId),
        detail: event.event
      };
    default:
      return {
        type: void 0,
        action: event.actionType,
        detail: event.event
      };
  }
}
function provideRealTimeUpdates() {
  const handlingEventFromSocket = shallowRef(false);
  const sockets = shallowRef([]);
  const socketId = computed(() => {
    for (let i2 = 0; i2 < sockets.value.length; i2 += 1) {
      const socket2 = sockets.value[i2].value;
      if (socket2)
        return `@teamwork/use:${socket2.id}`;
    }
    return void 0;
  });
  let listeners = [];
  let emitting = 0;
  let pendingEvents = [];
  function on2(listener) {
    assertHasScope();
    if (emitting > 0)
      listeners = listeners.slice();
    listeners.push(listener);
    onUnmounted(() => {
      if (emitting > 0)
        listeners = listeners.slice();
      listeners.splice(listeners.lastIndexOf(listener), 1);
    });
  }
  function emit(event, rawEvent) {
    try {
      emitting += 1;
      if (rawEvent) {
        handlingEventFromSocket.value = true;
      }
      const fixedListeners = listeners;
      for (let i2 = 0; i2 < fixedListeners.length; i2 += 1) {
        try {
          fixedListeners[i2](event, rawEvent);
        } catch (error) {
          console.error("useRealTimeUpdates: Error in an event listener", error);
        }
      }
    } finally {
      if (rawEvent) {
        handlingEventFromSocket.value = false;
      }
      emitting -= 1;
    }
  }
  function emitPendingEvents() {
    if (pendingEvents.length > 0 && document.visibilityState === "visible") {
      const events = pendingEvents;
      pendingEvents = [];
      events.forEach(({ event, rawEvent }) => emit(event, rawEvent));
    }
  }
  const emitPendingEventsDebounced = useDebounceFn(emitPendingEvents, 1e3, {
    maxWait: 5e3
  });
  function onEventNotice(rawEvent) {
    rawEvent = normalizeRawEvent(rawEvent);
    const isForLocalAction = rawEvent.eventInfo.socketId != null && rawEvent.eventInfo.socketId === socketId.value;
    const isAsync = rawEvent.eventInfo.extraInfo.data.threadedLoopback || false;
    if (isForLocalAction && !isAsync) {
      return;
    }
    const event = normalize(rawEvent);
    pendingEvents.push({ event, rawEvent });
    emitPendingEventsDebounced();
  }
  function emitFromSocket(socket2) {
    assertHasScope();
    watch(socket2, () => socket2.value && socket2.value.on("eventNotice", onEventNotice), { immediate: true });
    onUnmounted(() => socket2.value && socket2.value.off("eventNotice", onEventNotice));
    sockets.value.push(socket2);
    triggerRef(sockets);
    onUnmounted(() => {
      sockets.value.splice(sockets.value.lastIndexOf(socket2), 1);
      triggerRef(sockets);
    });
  }
  useEventListener(document, "visibilitychange", emitPendingEvents, false);
  provide(useRealTimeUpdatesSymbol, {
    emit,
    emitFromSocket,
    on: on2,
    socketId,
    handlingEventFromSocket
  });
}
function useRealTimeUpdates(listener) {
  const realTimeUpdates = inject(useRealTimeUpdatesSymbol);
  if (listener)
    realTimeUpdates.on(listener);
  return realTimeUpdates;
}
function useDataViewActions() {
  const api2 = useAxios();
  const { socketId } = useRealTimeUpdates();
  function config() {
    return {
      headers: {
        "Socket-ID": socketId.value,
        "Triggered-By": "user",
        "Sent-By": "composable"
      }
    };
  }
  return {
    createDataView(dataView) {
      return api2.post(v1Url("me/dataviews"), { dataView, get: "" }, config());
    }
  };
}
const assertHasScope = (message = "Expected to have an active scope.") => {
  if (!getCurrentScope()) {
    throw new Error(message);
  }
};
const useOptimisticUpdatesSymbol = Symbol("optimisticUpdates");
function provideOptimisticUpdates() {
  let listeners = [];
  let emitting = 0;
  function on2(listener) {
    assertHasScope();
    if (emitting > 0)
      listeners = listeners.slice();
    listeners.push(listener);
    onUnmounted(() => {
      if (emitting > 0)
        listeners = listeners.slice();
      listeners.splice(listeners.lastIndexOf(listener), 1);
    });
  }
  function emit(event) {
    try {
      emitting += 1;
      const fixedListeners = listeners;
      for (let i2 = 0; i2 < fixedListeners.length; i2 += 1) {
        try {
          fixedListeners[i2](event);
        } catch (error) {
          console.error("useOptimisticUpdates: Error in an event listener", error);
        }
      }
    } finally {
      emitting -= 1;
    }
  }
  provide(useOptimisticUpdatesSymbol, { emit, on: on2 });
}
function useOptimisticUpdates(listener) {
  const optimisticUpdates = inject(useOptimisticUpdatesSymbol);
  if (listener)
    optimisticUpdates.on(listener);
  return optimisticUpdates;
}
function useFileActions() {
  const api2 = useAxios();
  const { emit: emitOptimisticUpdate } = useOptimisticUpdates();
  const { emit: emitRealTimeUpdate, socketId } = useRealTimeUpdates();
  function config() {
    return {
      headers: {
        "Socket-ID": socketId.value,
        "Triggered-By": "user",
        "Sent-By": "composable"
      }
    };
  }
  return {
    deleteFile(file) {
      const promise = api2.delete(v3Url(`files/${file.id}`), config()).then(() => emitRealTimeUpdate({
        type: "file",
        action: "updated",
        projectId: file.projectId,
        fileId: file.id
      }));
      emitOptimisticUpdate({
        promise,
        type: "file",
        action: "update",
        file
      });
      return promise;
    },
    restoreFile(file) {
      const promise = api2.put(v1Url(`trashcan/files/${file.id}/restore`), null, config()).then(() => emitRealTimeUpdate({
        type: "file",
        action: "reopened",
        projectId: file.projectId,
        fileId: file.id
      }));
      return promise;
    }
  };
}
const newMilestoneId = (() => {
  let id = 0;
  return () => {
    id -= 1;
    return id;
  };
})();
function useMilestoneActions() {
  const api2 = useAxios();
  const { emit: _emitOptimisticUpdate } = useOptimisticUpdates();
  const { emit: _emitRealTimeUpdate, socketId } = useRealTimeUpdates();
  function emitOptimisticUpdate(promise, action, milestone) {
    _emitOptimisticUpdate({ promise, type: "milestone", action, milestone });
  }
  function emitRealTimeUpdate(action, newMilestone, oldMilestone) {
    const milestoneId = newMilestone.id || oldMilestone.id;
    _emitRealTimeUpdate({
      type: "milestone",
      action,
      milestoneId,
      projectId: newMilestone.projectId
    });
  }
  function config() {
    return {
      headers: {
        "Socket-ID": socketId.value,
        "Triggered-By": "user",
        "Sent-By": "composable"
      }
    };
  }
  return {
    createMilestone(newMilestone) {
      const promise = api2.post(v1Url(`projects/${newMilestone.milestoneListId}/milestones`), config()).then(({ data: { id } }) => emitRealTimeUpdate("new", __spreadProps(__spreadValues({}, newMilestone), { id: Number(id) }), {}));
      emitOptimisticUpdate(promise, "create", __spreadProps(__spreadValues({}, newMilestone), {
        id: newMilestoneId()
      }));
      return promise;
    },
    updateMilestone(updatedMilestone, milestone, options) {
      const promise = api2.put(v1Url(`milestones/${updatedMilestone.id}`), __spreadValues({
        milestone: updatedMilestone
      }, options), config()).then(({
        data: {
          "affected-milestones": affectedMilestones,
          "affects-other-milestones": affectsOtherMilestones,
          isOffset
        }
      }) => {
        emitRealTimeUpdate("edited", updatedMilestone, milestone || {});
        return {
          affectedMilestones,
          affectsOtherMilestones,
          isOffset
        };
      });
      emitOptimisticUpdate(promise, "update", updatedMilestone);
      return promise;
    },
    deleteMilestone(milestone) {
      const deletedMilestone = { id: milestone.id };
      const promise = api2.delete(v1Url(`milestones/${deletedMilestone.id}`), config()).then(() => emitRealTimeUpdate("deleted", deletedMilestone, milestone));
      emitOptimisticUpdate(promise, "delete", deletedMilestone);
      return promise;
    },
    completeMilestone(milestone) {
      const updatedMilestone = {
        id: milestone.id,
        progress: 100,
        status: "completed"
      };
      const promise = api2.put(v1Url(`milestones/${updatedMilestone.id}/complete`), null, config()).then(() => emitRealTimeUpdate("completed", updatedMilestone, milestone));
      emitOptimisticUpdate(promise, "update", updatedMilestone);
      return promise;
    },
    uncompleteMilestone(milestone) {
      const updatedMilestone = {
        id: milestone.id,
        progress: 0,
        status: "reopened"
      };
      const promise = api2.put(v1Url(`milestones/${updatedMilestone.id}/uncomplete`), null, config()).then(() => emitRealTimeUpdate("reopened", updatedMilestone, milestone));
      emitOptimisticUpdate(promise, "update", updatedMilestone);
      return promise;
    }
  };
}
function usePortfolioActions() {
  const api2 = useAxios();
  const { emit: emitOptimisticUpdate } = useOptimisticUpdates();
  const { emit: emitRealTimeUpdate, socketId } = useRealTimeUpdates();
  function config() {
    return {
      headers: {
        "Socket-ID": socketId.value,
        "Triggered-By": "user",
        "Sent-By": "composable"
      }
    };
  }
  return {
    movePortfolioCard(portfolioCard) {
      const { column, project } = portfolioCard;
      const promise = api2.put(v1Url(`portfolio/cards/${portfolioCard.id}/move`), { columnId: column.id }, config()).then(() => emitRealTimeUpdate({
        type: "project",
        action: "updated",
        projectId: project.id,
        categoryChanged: false
      }));
      emitOptimisticUpdate({
        promise,
        type: "project",
        action: "update",
        project: {
          id: project.id,
          portfolioCards: project.portfolioCards.map((card) => card.id === portfolioCard.id ? portfolioCard : card)
        }
      });
      return promise;
    },
    deletePortfolioCard(portfolioCard) {
      const { project } = portfolioCard;
      const promise = api2.delete(v1Url(`portfolio/cards/${portfolioCard.id}`), config()).then(() => emitRealTimeUpdate({
        type: "project",
        action: "updated",
        projectId: project.id,
        categoryChanged: false
      }));
      emitOptimisticUpdate({
        promise,
        type: "project",
        action: "update",
        project: {
          id: project.id,
          portfolioCards: project.portfolioCards.filter((card) => card.id !== portfolioCard.id)
        }
      });
      return promise;
    }
  };
}
const { hasOwnProperty: hasOwnProperty$5 } = Object.prototype;
function toApiProject(project) {
  const apiProject = {};
  apiProject.id = project.id;
  if (hasOwnProperty$5.call(project, "description")) {
    apiProject.description = project.description;
  }
  if (hasOwnProperty$5.call(project, "categoryId")) {
    apiProject["category-id"] = Number(project.categoryId);
  } else if (hasOwnProperty$5.call(project, "category")) {
    apiProject["category-id"] = Number(project.category.id);
  }
  if (hasOwnProperty$5.call(project, "customFieldValues")) {
    apiProject.customFields = project.customFieldValues.map(({ customFieldId, value, urlTextToDisplay }) => ({
      customFieldId,
      value,
      urlTextToDisplay
    }));
  }
  if (hasOwnProperty$5.call(project, "tags")) {
    apiProject.tagIds = project.tags.map((tag) => tag.id).join(",");
  }
  return apiProject;
}
function hasCategoryChange(updatedProject) {
  return hasOwnProperty$5.call(updatedProject, "categoryId") || hasOwnProperty$5.call(updatedProject, "category");
}
function useProjectActions() {
  const api2 = useAxios();
  const { emit: emitOptimisticUpdate } = useOptimisticUpdates();
  const { emit: emitRealTimeUpdate, socketId } = useRealTimeUpdates();
  function config() {
    return {
      headers: {
        "Socket-ID": socketId.value,
        "Triggered-By": "user",
        "Sent-By": "composable"
      }
    };
  }
  return {
    starProject(project) {
      const updatedProject = { id: project.id, isStarred: true };
      const promise = api2.put(v1Url(`projects/${updatedProject.id}/star`), null, config()).then(() => emitRealTimeUpdate({
        type: "project",
        action: "starred",
        projectId: updatedProject.id,
        categoryChanged: false
      }));
      emitOptimisticUpdate({
        promise,
        type: "project",
        action: "update",
        project: updatedProject
      });
      return promise;
    },
    unstarProject(project) {
      const updatedProject = { id: project.id, isStarred: false };
      const promise = api2.put(v1Url(`projects/${updatedProject.id}/unstar`), null, config()).then(() => emitRealTimeUpdate({
        type: "project",
        action: "unstarred",
        projectId: updatedProject.id,
        categoryChanged: false
      }));
      emitOptimisticUpdate({
        promise,
        type: "project",
        action: "update",
        project: updatedProject
      });
      return promise;
    },
    updateProject(updatedProject) {
      const promise = api2.put(v1Url(`projects/${updatedProject.id}`), { project: toApiProject(updatedProject) }, config()).then(() => emitRealTimeUpdate({
        type: "project",
        action: "edited",
        projectId: updatedProject.id,
        categoryChanged: hasCategoryChange(updatedProject)
      }));
      emitOptimisticUpdate({
        promise,
        type: "project",
        action: "update",
        project: updatedProject
      });
      return promise;
    }
  };
}
const { hasOwnProperty: hasOwnProperty$4 } = Object.prototype;
const newProjectBudgetId = (() => {
  let id = 0;
  return () => {
    id -= 1;
    return id;
  };
})();
function handleProjectBudgetConflictError(_error) {
  var _a, _b, _c;
  const error = (_c = (_b = (_a = _error == null ? void 0 : _error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.errors) == null ? void 0 : _c[0];
  if (!error || !error.code.startsWith("PBC")) {
    return _error;
  }
  const {
    code,
    meta: { budget: conflictingBudget }
  } = error;
  const customError = new Error("Failed to upsert budget");
  customError.name = "ProjectBudgetConflictError";
  customError.code = code;
  customError.conflictingBudget = conflictingBudget;
  return customError;
}
function createBudgetPayload(budget) {
  const budgetPayload = {};
  if (hasOwnProperty$4.call(budget, "id")) {
    budgetPayload.id = Number(budget.id);
  }
  if (hasOwnProperty$4.call(budget, "capacity")) {
    budgetPayload.capacity = Number(budget.capacity);
  }
  if (hasOwnProperty$4.call(budget, "completedAt")) {
    budgetPayload.completedAt = budget.completedAt;
  }
  if (hasOwnProperty$4.call(budget, "endDateTime")) {
    budgetPayload.endDateTime = budget.endDateTime;
  }
  if (hasOwnProperty$4.call(budget, "isRepeating")) {
    budgetPayload.isRepeating = Boolean(budget.isRepeating);
  }
  if (hasOwnProperty$4.call(budget, "notifications")) {
    budgetPayload.notifications = budget.notifications.map((notification) => {
      var _a, _b, _c, _d, _e, _f;
      return {
        notificationMedium: notification.notificationMedium.toUpperCase(),
        capacityThreshold: notification.capacityThreshold,
        userIds: (_b = (_a = notification.users) == null ? void 0 : _a.map((user) => Number(user.id))) != null ? _b : [],
        teamIds: (_d = (_c = notification.teams) == null ? void 0 : _c.map((team) => Number(team.id))) != null ? _d : [],
        companyIds: (_f = (_e = notification.companies) == null ? void 0 : _e.map((company) => Number(company.id))) != null ? _f : []
      };
    });
  }
  if (hasOwnProperty$4.call(budget, "projectId")) {
    budgetPayload.projectId = Number(budget.projectId);
  }
  if (hasOwnProperty$4.call(budget, "repeatPeriod") && Number(budget.repeatPeriod) > 0) {
    budgetPayload.repeatPeriod = Number(budget.repeatPeriod);
  }
  if (hasOwnProperty$4.call(budget, "repeatUnit") && Boolean(budget.repeatUnit)) {
    budgetPayload.repeatUnit = budget.repeatUnit.toUpperCase();
  }
  if (hasOwnProperty$4.call(budget, "startDateTime")) {
    budgetPayload.startDateTime = budget.startDateTime;
  }
  if (hasOwnProperty$4.call(budget, "status")) {
    budgetPayload.status = budget.status.toUpperCase();
  }
  if (hasOwnProperty$4.call(budget, "type")) {
    budgetPayload.type = budget.type.toUpperCase();
  }
  if (hasOwnProperty$4.call(budget, "timelogType")) {
    budgetPayload.timelogType = budget.timelogType.toUpperCase();
  }
  return budgetPayload;
}
function useProjectBudgetActions() {
  const api2 = useAxios();
  const { emit: _emitOptimisticUpdate } = useOptimisticUpdates();
  const { emit: _emitRealTimeUpdate, socketId } = useRealTimeUpdates();
  const config = () => ({
    headers: {
      "Socket-ID": socketId.value,
      "Triggered-By": "user",
      "Sent-By": "composable"
    }
  });
  function emitOptimisticUpdate(promise, action, budget) {
    _emitOptimisticUpdate({
      promise,
      type: "budget",
      action,
      budget
    });
  }
  function emitRealTimeUpdate(action, budget, oldBudget) {
    var _a, _b;
    _emitRealTimeUpdate({
      type: "budget",
      action,
      budgetId: (_a = budget.id) != null ? _a : oldBudget.id,
      projectId: (_b = budget.projectId) != null ? _b : oldBudget.projectId
    });
  }
  function createProjectBudget(budget) {
    const promise = api2.post(v3Url(`projects/budgets`), { budget: createBudgetPayload(budget) }, config()).then(({ data: { budget: createdBudget } }) => {
      emitRealTimeUpdate("new", createdBudget);
      return createdBudget;
    }).catch((error) => {
      if (error.response.status === 409) {
        throw handleProjectBudgetConflictError(error);
      }
      throw error;
    });
    emitOptimisticUpdate(promise, "create", __spreadProps(__spreadValues({}, budget), {
      id: newProjectBudgetId(),
      capacityUsed: 0
    }));
    return promise;
  }
  function updateProjectBudget(budget, oldBudget) {
    const promise = api2.patch(v3Url(`projects/budgets/${budget.id}`), { budget: createBudgetPayload(budget) }, config()).then(({ data: { budget: updatedBudget } }) => {
      emitRealTimeUpdate("edited", updatedBudget, oldBudget);
      return updatedBudget;
    }).catch((error) => {
      if (error.response.status === 409) {
        throw handleProjectBudgetConflictError(error);
      }
      throw error;
    });
    emitOptimisticUpdate(promise, "update", budget);
    return promise;
  }
  function deleteProjectBudget(budget) {
    const promise = api2.delete(v3Url(`projects/budgets/${budget.id}`), null, config()).then(() => {
      emitRealTimeUpdate("deleted", budget);
    });
    emitOptimisticUpdate(promise, "delete", budget);
    return promise;
  }
  return {
    createProjectBudget,
    updateProjectBudget,
    deleteProjectBudget
  };
}
const { hasOwnProperty: hasOwnProperty$3 } = Object.prototype;
const newProjectBudgetExpenseId = (() => {
  let id = 0;
  return () => {
    id -= 1;
    return id;
  };
})();
function createProjectBudgetExpensePayload(budgetExpense) {
  const budgetExpensePayload = {};
  if (hasOwnProperty$3.call(budgetExpense, "projectBugdetId")) {
    budgetExpensePayload.projectBudgetId = Number(budgetExpense.projectBudgetId);
  }
  if (hasOwnProperty$3.call(budgetExpense, "cost")) {
    budgetExpensePayload.cost = Number(budgetExpense.cost);
  }
  if (hasOwnProperty$3.call(budgetExpense, "description")) {
    budgetExpensePayload.description = budgetExpense.description;
  }
  return budgetExpensePayload;
}
function useProjectBudgetExpenseActions() {
  const api2 = useAxios();
  const { emit: _emitOptimisticUpdate } = useOptimisticUpdates();
  const { emit: _emitRealTimeUpdate, socketId } = useRealTimeUpdates();
  const config = () => ({
    headers: {
      "Socket-ID": socketId.value,
      "Triggered-By": "user",
      "Sent-By": "composable"
    }
  });
  function emitOptimisticUpdate(promise, action, budgetExpense) {
    _emitOptimisticUpdate({
      promise,
      type: "budgetExpense",
      action,
      budgetExpense
    });
  }
  function emitRealTimeUpdate(action, budgetExpense, oldBudgetExpense) {
    var _a, _b;
    _emitRealTimeUpdate({
      type: "budgetExpense",
      action,
      budgetExpenseId: (_a = budgetExpense.id) != null ? _a : oldBudgetExpense.id,
      projectBudgetId: (_b = budgetExpense.projectBudgetId) != null ? _b : oldBudgetExpense.projectBudgetId
    });
  }
  function createProjectBudgetExpense(projectBudgetId, budgetExpense) {
    const url2 = v3Url(`projects/budgets/${projectBudgetId}/expenses`);
    const promise = api2.post(url2, {
      budgetExpense: createProjectBudgetExpensePayload(budgetExpense)
    }, config()).then(({ data: { budgetExpense: createdBudgetExpense } }) => {
      emitRealTimeUpdate("new", createdBudgetExpense);
      return createdBudgetExpense;
    });
    emitOptimisticUpdate(promise, "create", __spreadProps(__spreadValues({}, budgetExpense), {
      id: newProjectBudgetExpenseId()
    }));
    return promise;
  }
  function updateProjectBudgetExpense(budgetExpense, oldBudgetExpense) {
    const url2 = v3Url(`projects/budgets/expenses/${budgetExpense.id}`);
    const promise = api2.patch(url2, { budgetExpense: createProjectBudgetExpensePayload(budgetExpense) }, config()).then(({ data: { budgetExpense: updatedBudgetExpense } }) => {
      emitRealTimeUpdate("edited", updatedBudgetExpense, oldBudgetExpense);
      return updatedBudgetExpense;
    });
    emitOptimisticUpdate(promise, "update", budgetExpense);
    return promise;
  }
  function deleteProjectBudgetExpense(budgetExpense) {
    const url2 = v3Url(`projects/budgets/expenses/${budgetExpense.id}`);
    const promise = api2.delete(url2, null, config()).then(() => {
      emitRealTimeUpdate("deleted", budgetExpense);
    });
    emitOptimisticUpdate(promise, "delete", budgetExpense);
    return promise;
  }
  return {
    createProjectBudgetExpense,
    updateProjectBudgetExpense,
    deleteProjectBudgetExpense
  };
}
const { hasOwnProperty: hasOwnProperty$2 } = Object.prototype;
const newTaskId = (() => {
  let id = 0;
  return () => {
    id -= 1;
    return id;
  };
})();
function createToDoItem(task) {
  const toDoItem = {
    id: task.id
  };
  if (hasOwnProperty$2.call(task, "name")) {
    toDoItem.content = task.name;
  }
  if (hasOwnProperty$2.call(task, "startDate")) {
    toDoItem["start-date"] = moment.isMoment(task.startDate) && task.startDate.isValid() ? task.startDate.format("YYYYMMDD") : "";
  }
  if (hasOwnProperty$2.call(task, "dueDate")) {
    toDoItem["due-date"] = moment.isMoment(task.dueDate) && task.dueDate.isValid() ? task.dueDate.format("YYYYMMDD") : "";
  }
  if (hasOwnProperty$2.call(task, "originalDueDate")) {
    toDoItem["original-due-date"] = moment.isMoment(task.originalDueDate) && task.originalDueDate.isValid() ? task.originalDueDate.format("YYYYMMDD") : "";
  }
  if (hasOwnProperty$2.call(task, "pushSubtasks")) {
    toDoItem["push-subtasks"] = task.pushSubtasks;
  }
  if (hasOwnProperty$2.call(task, "pushDependents")) {
    toDoItem["push-dependents"] = task.pushDependents;
  }
  if (hasOwnProperty$2.call(task, "notify")) {
    toDoItem.notify = task.notify;
  }
  if (hasOwnProperty$2.call(task, "progress")) {
    toDoItem.progress = task.progress;
  }
  if (hasOwnProperty$2.call(task, "numEstMins")) {
    toDoItem["estimated-minutes"] = task.numEstMins;
  }
  if (hasOwnProperty$2.call(task, "priority")) {
    toDoItem.priority = task.priority;
  }
  if (hasOwnProperty$2.call(task, "description")) {
    toDoItem.description = task.description;
  }
  if (hasOwnProperty$2.call(task, "boardColumn")) {
    toDoItem.columnId = task.boardColumn ? task.boardColumn.id : 0;
  }
  if (hasOwnProperty$2.call(task, "customFields")) {
    toDoItem.customFields = task.customFields;
  }
  if (hasOwnProperty$2.call(task, "tags")) {
    toDoItem.tagIds = task.tags.map((tag) => tag.id).join(",");
  }
  if (hasOwnProperty$2.call(task, "taskListId")) {
    toDoItem.taskListId = task.taskListId;
  }
  if (hasOwnProperty$2.call(task, "positionAfterTaskId")) {
    toDoItem.positionAfterTask = task.positionAfterTaskId;
  }
  if (hasOwnProperty$2.call(task, "assignedTo") || hasOwnProperty$2.call(task, "assignedToCompanies") || hasOwnProperty$2.call(task, "assignedToTeams")) {
    toDoItem["responsible-party-id"] = [
      ...(task.assignedTo || []).map((m2) => m2.id),
      ...(task.assignedToCompanies || []).map((m2) => `c${m2.companyId || m2.id}`),
      ...(task.assignedToTeams || []).map((m2) => `t${m2.teamId || m2.id}`)
    ].join(",");
  }
  if (hasOwnProperty$2.call(task, "parentTaskId")) {
    toDoItem.parentTaskId = task.parentTaskId;
  }
  if (hasOwnProperty$2.call(task, "changeFollowers")) {
    toDoItem.changeFollowerIds = task.changeFollowers.map((followers) => followers.id).join(",");
  }
  if (hasOwnProperty$2.call(task, "commentFollowers")) {
    toDoItem.commentFollowerIds = task.commentFollowers.map((followers) => followers.id).join(",");
  }
  if (hasOwnProperty$2.call(task, "repeatOptions")) {
    toDoItem.repeatOptions = task.repeatOptions;
  }
  if (hasOwnProperty$2.call(task, "predecessors")) {
    toDoItem.predecessors = task.predecessors;
  }
  return toDoItem;
}
function useTaskActions() {
  const api2 = useAxios();
  const { emit: _emitOptimisticUpdate } = useOptimisticUpdates();
  const { emit: _emitRealTimeUpdate, socketId } = useRealTimeUpdates();
  function emitOptimisticUpdate(promise, action, task) {
    var _b;
    const _a = task, {
      tasklist,
      project,
      taskList,
      taskListId
    } = _a, normalizedTask = __objRest(_a, [
      "tasklist",
      "project",
      "taskList",
      "taskListId"
    ]);
    (_b = normalizedTask.tasklistId) != null ? _b : normalizedTask.tasklistId = taskListId;
    normalizedTask.taskListId = normalizedTask.tasklistId;
    _emitOptimisticUpdate({
      promise,
      type: "task",
      action,
      task: normalizedTask
    });
  }
  function emitRealTimeUpdate(action, newTask, oldTask) {
    var _a, _b, _c, _d;
    const taskId = (_a = newTask.id) != null ? _a : oldTask.id;
    _emitRealTimeUpdate({
      type: "task",
      action,
      taskId,
      parentTaskId: (_b = newTask.parentTaskId) != null ? _b : oldTask.parentTaskId,
      previousParentTaskId: oldTask.parentTaskId,
      taskListId: (_c = newTask.taskListId) != null ? _c : oldTask.taskListId,
      previousTaskListId: oldTask.taskListId,
      projectId: (_d = newTask.projectId) != null ? _d : oldTask.projectId,
      previousProjectId: oldTask.projectId
    });
  }
  function config() {
    return {
      headers: {
        "Socket-ID": socketId.value,
        "Triggered-By": "user",
        "Sent-By": "composable"
      }
    };
  }
  return {
    createTask(newTask) {
      const promise = api2.post(v1Url(`tasklists/${newTask.taskListId}/tasks`), {
        "todo-item": createToDoItem(newTask)
      }, config()).then(({ data: { id } }) => emitRealTimeUpdate("new", __spreadProps(__spreadValues({}, newTask), { id: Number(id) }), {}));
      emitOptimisticUpdate(promise, "create", __spreadProps(__spreadValues({}, newTask), { id: newTaskId() }));
      return promise;
    },
    updateTask(updatedTask, task = {}, options) {
      const promise = api2.put(v1Url(`tasks/${updatedTask.id}`), __spreadProps(__spreadValues({}, options), {
        "todo-item": createToDoItem(updatedTask)
      }), config()).then(() => emitRealTimeUpdate("edited", updatedTask, task));
      emitOptimisticUpdate(promise, "update", __spreadValues(__spreadValues({}, task), updatedTask));
      return promise;
    },
    deleteTask(task) {
      const promise = api2.delete(v1Url(`tasks/${task.id}`), config()).then(() => emitRealTimeUpdate("deleted", task, task));
      emitOptimisticUpdate(promise, "delete", task);
      return promise;
    },
    completeTask(task) {
      const promise = api2.put(v1Url(`tasks/${task.id}/complete`), null, config()).then(() => emitRealTimeUpdate("completed", task, task));
      emitOptimisticUpdate(promise, "update", __spreadProps(__spreadValues({}, task), {
        progress: 100,
        status: "completed"
      }));
      return promise;
    },
    uncompleteTask(task) {
      const promise = api2.put(v1Url(`tasks/${task.id}/uncomplete`), null, config()).then(() => emitRealTimeUpdate("reopened", task, task));
      emitOptimisticUpdate(promise, "update", __spreadProps(__spreadValues({}, task), {
        progress: 0,
        status: "reopened"
      }));
      return promise;
    },
    moveTask(updatedTask, task = {}) {
      const { id, parentTaskId, taskListId, projectId, positionAfterTaskId } = updatedTask;
      const promise = api2.put(v1Url(`tasks/${id}`), {
        "todo-item": createToDoItem({
          id,
          parentTaskId,
          taskListId,
          projectId,
          positionAfterTaskId
        })
      }, config()).then(() => emitRealTimeUpdate("edited", updatedTask, task));
      emitOptimisticUpdate(promise, "update", __spreadProps(__spreadValues(__spreadValues({}, task), updatedTask), {
        previousParentTaskId: task.parentTaskId,
        previousTaskListId: task.taskListId,
        previousProjectId: task.projectId
      }));
      return promise;
    },
    updateTaskProgress(updatedTask, task = {}) {
      const promise = api2.put(v1Url(`tasks/${updatedTask.id}/progress`), {
        progress: updatedTask.progress
      }, config()).then(() => emitRealTimeUpdate("edited", updatedTask, task));
      emitOptimisticUpdate(promise, "update", __spreadValues(__spreadValues({}, task), updatedTask));
      return promise;
    }
  };
}
const { hasOwnProperty: hasOwnProperty$1 } = Object.prototype;
function createTasklistBudgetPayload(tasklistBudget) {
  const budgetPayload = {};
  if (hasOwnProperty$1.call(tasklistBudget, "id")) {
    budgetPayload.id = Number(tasklistBudget.id);
  } else if (hasOwnProperty$1.call(tasklistBudget, "tasklist")) {
    budgetPayload.tasklist = tasklistBudget.tasklist;
  }
  if (hasOwnProperty$1.call(tasklistBudget, "capacity")) {
    budgetPayload.capacity = Number(tasklistBudget.capacity);
  }
  if (hasOwnProperty$1.call(tasklistBudget, "notifications") && tasklistBudget.notifications.length) {
    budgetPayload.notifications = tasklistBudget.notifications.map((notification) => {
      var _a, _b, _c;
      return {
        notificationMedium: notification.notificationMedium.toUpperCase(),
        capacityThreshold: notification.capacityThreshold,
        users: (_a = notification.users) == null ? void 0 : _a.map((user) => ({
          id: Number(user.id),
          type: "users"
        })),
        teams: (_b = notification.teams) == null ? void 0 : _b.map((team) => ({
          id: Number(team.id),
          type: "teams"
        })),
        companies: (_c = notification.companies) == null ? void 0 : _c.map((company) => ({
          id: Number(company.id),
          type: "companies"
        }))
      };
    });
  }
  if (hasOwnProperty$1.call(tasklistBudget, "taskListId")) {
    budgetPayload.tasklist = {
      id: Number(tasklistBudget.taskListId),
      type: "tasklists"
    };
  }
  return budgetPayload;
}
function useTasklistBudgetActions() {
  const api2 = useAxios();
  const { emit: _emitOptimisticUpdate } = useOptimisticUpdates();
  const { emit: _emitRealTimeUpdate, socketId } = useRealTimeUpdates();
  const config = () => ({
    headers: {
      "Socket-ID": socketId.value,
      "Triggered-By": "user",
      "Sent-By": "composable"
    }
  });
  function emitOptimisticUpdate(promise, action, tasklistBudget) {
    _emitOptimisticUpdate({
      promise,
      type: "tasklistBudget",
      action,
      tasklistBudget
    });
  }
  function emitRealTimeUpdate(action, tasklistBudget, oldTasklistBudget) {
    var _a, _b, _c;
    _emitRealTimeUpdate({
      type: "tasklistBudget",
      action,
      tasklistBudgetId: (_a = tasklistBudget.id) != null ? _a : oldTasklistBudget.id,
      projectBudgetId: (_b = tasklistBudget.projectBudgetId) != null ? _b : oldTasklistBudget.projectBudgetId,
      tasklistId: (_c = tasklistBudget.tasklistId) != null ? _c : oldTasklistBudget.tasklistId
    });
  }
  function createTasklistBudgets(projectBudgetId, tasklistBudgets) {
    const url2 = v3Url(`projects/budgets/${projectBudgetId}/tasklists/budgets/bulk/add`);
    const promise = api2.post(url2, { tasklistBudgets: tasklistBudgets.map(createTasklistBudgetPayload) }, config());
    return promise.then((response) => response.data.tasklistBudgets);
  }
  function updateTasklistBudget(tasklistBudget, oldTasklistBudget) {
    const url2 = v3Url(`projects/budgets/tasklists/budgets/${tasklistBudget.id}`);
    const payload = {
      tasklistBudget: createTasklistBudgetPayload(tasklistBudget)
    };
    const promise = api2.patch(url2, payload, config()).then(({ data: { tasklistBudget: updatedTasklistBudget } }) => {
      emitRealTimeUpdate("edited", updatedTasklistBudget, oldTasklistBudget);
      return updatedTasklistBudget;
    });
    emitOptimisticUpdate(promise, "update", tasklistBudget);
    return promise;
  }
  function updateTasklistBudgets(projectBudgetId, tasklistBudgets) {
    const url2 = v3Url(`projects/budgets/${projectBudgetId}/tasklists/budgets`);
    const promise = api2.put(url2, { tasklistBudgets: tasklistBudgets.map(createTasklistBudgetPayload) }, config()).then(({ data: { tasklistBudgets: newTasklistBudgets } }) => {
      _emitRealTimeUpdate({
        type: "tasklistBudget",
        action: "bulkCreated",
        tasklistBudgets: newTasklistBudgets,
        projectBudgetId
      });
      return newTasklistBudgets;
    });
    return promise;
  }
  function deleteTasklistBudget(tasklistBudget) {
    const url2 = v3Url(`projects/budgets/tasklists/budgets/${tasklistBudget.id}`);
    const promise = api2.delete(url2, null, config()).then(() => {
      emitRealTimeUpdate("deleted", tasklistBudget);
    });
    emitOptimisticUpdate(promise, "delete", tasklistBudget);
    return promise;
  }
  function restoreTasklistBudget(tasklistBudget) {
    const url2 = v3Url(`/projects/budgets/tasklists/budgets/${tasklistBudget.id}/undelete`);
    const promise = api2.put(url2, null, config()).then(() => {
      emitRealTimeUpdate("undelete", tasklistBudget);
    });
    emitOptimisticUpdate(promise, "undelete", tasklistBudget);
    return promise;
  }
  return {
    createTasklistBudgets,
    updateTasklistBudget,
    updateTasklistBudgets,
    deleteTasklistBudget,
    restoreTasklistBudget
  };
}
const { hasOwnProperty } = Object.prototype;
function toApiTimelog(timelogPayload) {
  const timelog = {};
  const tags = [];
  const timelogOptions = {};
  if (hasOwnProperty.call(timelogPayload, "date")) {
    timelog.date = String(timelogPayload.date);
  }
  if (hasOwnProperty.call(timelogPayload, "description")) {
    timelog.description = timelogPayload.description;
  }
  if (hasOwnProperty.call(timelogPayload, "hasStartTime")) {
    timelog.hasStartTime = Boolean(timelogPayload.hasStartTime);
  }
  if (hasOwnProperty.call(timelogPayload, "hours")) {
    timelog.hours = Number(timelogPayload.hours);
  }
  if (hasOwnProperty.call(timelogPayload, "isBillable")) {
    timelog.isBillable = Boolean(timelogPayload.isBillable);
  } else if (hasOwnProperty.call(timelogPayload, "billable")) {
    timelog.isBillable = Boolean(timelogPayload.billable);
  }
  if (hasOwnProperty.call(timelogPayload, "isUtc")) {
    timelog.isUtc = Boolean(timelogPayload.isUtc);
  }
  if (hasOwnProperty.call(timelogPayload, "minutes")) {
    timelog.minutes = Number(timelogPayload.minutes);
  }
  if (hasOwnProperty.call(timelogPayload, "projectId")) {
    timelog.projectId = Number(timelogPayload.projectId);
  }
  if (hasOwnProperty.call(timelogPayload, "taskId")) {
    timelog.taskId = Number(timelogPayload.taskId);
  }
  if (hasOwnProperty.call(timelogPayload, "time")) {
    timelog.time = String(timelogPayload.time);
  }
  if (hasOwnProperty.call(timelogPayload, "userId")) {
    timelog.userId = Number(timelogPayload.userId);
  }
  if (hasOwnProperty.call(timelogPayload, "tags")) {
    const tagIds = [];
    timelogPayload.tags.forEach((tag) => {
      tagIds.push(tag.id);
      tags.push({
        color: tag.color,
        name: tag.name,
        projectId: tag.projectId
      });
    });
    timelog.tagIds = tagIds;
  }
  if (hasOwnProperty.call(timelogPayload, "fireWebhook")) {
    timelogOptions.fireWebhook = Boolean(timelogPayload.fireWebhook);
  }
  if (hasOwnProperty.call(timelogPayload, "logActivity")) {
    timelogOptions.logActivity = Boolean(timelogPayload.logActivity);
  }
  if (hasOwnProperty.call(timelogPayload, "markTaskComplete")) {
    timelogOptions.markTaskComplete = Boolean(timelogPayload.markTaskComplete);
  }
  if (hasOwnProperty.call(timelogPayload, "parseInlineTags")) {
    timelogOptions.parseInlineTags = Boolean(timelogPayload.parseInlineTags);
  }
  if (hasOwnProperty.call(timelogPayload, "useNotifyViaTWIM")) {
    timelogOptions.useNotifyViaTWIM = Boolean(timelogPayload.useNotifyViaTWIM);
  }
  return {
    timelog,
    tags,
    timelogOptions
  };
}
function useTimelogActions() {
  const api2 = useAxios();
  const { emit: _emitOptimisticUpdate } = useOptimisticUpdates();
  const { emit: _emitRealTimeUpdate, socketId } = useRealTimeUpdates();
  function emitOptimisticUpdate(promise, action, timelog) {
    _emitOptimisticUpdate({ promise, type: "time", action, timelog });
  }
  function emitRealTimeUpdate(action, newTimelog, oldTimelog) {
    var _a, _b, _c;
    _emitRealTimeUpdate({
      type: "time",
      action,
      timeId: (_a = newTimelog.id) != null ? _a : oldTimelog.id,
      projectId: (_b = newTimelog.projectId) != null ? _b : oldTimelog.projectId,
      taskId: (_c = newTimelog.taskId) != null ? _c : oldTimelog.taskId
    });
  }
  function config() {
    return {
      headers: {
        "Socket-ID": socketId.value,
        "Triggered-By": "user",
        "Sent-By": "composable"
      }
    };
  }
  return {
    createTimelog(timelog) {
      let url2;
      if (timelog.taskId) {
        url2 = v3Url(`tasks/${timelog.taskId}/time`);
      } else if (timelog.projectId) {
        url2 = v3Url(`projects/${timelog.projectId}/time`);
      } else {
        throw new Error("Missing taskId or projectId on timelog");
      }
      const promise = api2.post(url2, toApiTimelog(timelog), config()).then((response) => {
        const createdTimelog = response.data.timelog;
        emitRealTimeUpdate("created", createdTimelog);
        return createdTimelog;
      });
      emitOptimisticUpdate(promise, "create", timelog);
      return promise;
    },
    updateTimelog(timelog, oldTimelog) {
      const url2 = v3Url(`/time/${timelog.id}`);
      const promise = api2.patch(url2, toApiTimelog(timelog), config()).then((response) => {
        const updatedTimelog = response.data.timelog;
        emitRealTimeUpdate("updated", updatedTimelog, oldTimelog);
        return updatedTimelog;
      });
      emitOptimisticUpdate(promise, "update", timelog);
      return promise;
    },
    deleteTimelog(timelog) {
      const url2 = v3Url(`/time/${timelog.id}`);
      const promise = api2.delete(url2, config()).then(() => {
        emitRealTimeUpdate("delete", timelog);
      });
      emitOptimisticUpdate(promise, "delete", timelog);
      return promise;
    }
  };
}
function useUserRateActions() {
  const api2 = useAxios();
  function updateInstallationUserRates({ userRate, userIds } = {}) {
    return api2.put("/projects/api/v3/rates/installation/users/bulk/update.json", {
      userRate,
      all: false,
      ids: userIds
    });
  }
  function updateProjectUserRates({
    userRates,
    projectId,
    projectRate = void 0
  } = {}) {
    return api2.put(`/projects/api/v3/rates/projects/${projectId}/actions/update.json`, __spreadProps(__spreadValues({}, userRates.length && { userRates }), {
      projectRate
    }));
  }
  return {
    updateInstallationUserRates,
    updateProjectUserRates
  };
}
function getAugmentedNamespace(n) {
  if (n.__esModule)
    return n;
  var a = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d2 = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var axios$2 = { exports: {} };
var bind$5 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i2 = 0; i2 < args.length; i2++) {
      args[i2] = arguments[i2];
    }
    return fn.apply(thisArg, args);
  };
};
var bind$4 = bind$5;
var toString$3 = Object.prototype.toString;
function isArray$6(val) {
  return toString$3.call(val) === "[object Array]";
}
function isUndefined(val) {
  return typeof val === "undefined";
}
function isBuffer$2(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString$3.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return typeof FormData !== "undefined" && val instanceof FormData;
}
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}
function isString$1(val) {
  return typeof val === "string";
}
function isNumber$1(val) {
  return typeof val === "number";
}
function isObject(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject(val) {
  if (toString$3.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate$1(val) {
  return toString$3.call(val) === "[object Date]";
}
function isFile(val) {
  return toString$3.call(val) === "[object File]";
}
function isBlob(val) {
  return toString$3.call(val) === "[object Blob]";
}
function isFunction(val) {
  return toString$3.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isURLSearchParams(val) {
  return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach(obj, fn) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray$6(obj)) {
    for (var i2 = 0, l = obj.length; i2 < l; i2++) {
      fn.call(null, obj[i2], i2, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge$1() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge$1(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge$1({}, val);
    } else if (isArray$6(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i2 = 0, l = arguments.length; i2 < l; i2++) {
    forEach(arguments[i2], assignValue);
  }
  return result;
}
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a[key] = bind$4(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$g = {
  isArray: isArray$6,
  isArrayBuffer,
  isBuffer: isBuffer$2,
  isFormData,
  isArrayBufferView,
  isString: isString$1,
  isNumber: isNumber$1,
  isObject,
  isPlainObject,
  isUndefined,
  isDate: isDate$1,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge: merge$1,
  extend,
  trim,
  stripBOM
};
var utils$f = utils$g;
function encode$2(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$2 = function buildURL(url2, params, paramsSerializer) {
  if (!params) {
    return url2;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$f.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts2 = [];
    utils$f.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$f.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$f.forEach(val, function parseValue(v) {
        if (utils$f.isDate(v)) {
          v = v.toISOString();
        } else if (utils$f.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts2.push(encode$2(key) + "=" + encode$2(v));
      });
    });
    serializedParams = parts2.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url2.indexOf("#");
    if (hashmarkIndex !== -1) {
      url2 = url2.slice(0, hashmarkIndex);
    }
    url2 += (url2.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url2;
};
var utils$e = utils$g;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach2(fn) {
  utils$e.forEach(this.handlers, function forEachHandler(h2) {
    if (h2 !== null) {
      fn(h2);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$d = utils$g;
var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$d.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
var enhanceError$2 = function enhanceError(error, config, code, request2, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request2;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};
var enhanceError$1 = enhanceError$2;
var createError$2 = function createError(message, config, code, request2, response) {
  var error = new Error(message);
  return enhanceError$1(error, config, code, request2, response);
};
var createError$1 = createError$2;
var settle$1 = function settle(resolve, reject, response) {
  var validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(createError$1("Request failed with status code " + response.status, response.config, null, response.request, response));
  }
};
var utils$c = utils$g;
var cookies$1 = utils$c.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + "=" + encodeURIComponent(value));
      if (utils$c.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$c.isString(path)) {
        cookie.push("path=" + path);
      }
      if (utils$c.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read(name) {
      var match2 = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match2 ? decodeURIComponent(match2[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write() {
    },
    read: function read() {
      return null;
    },
    remove: function remove() {
    }
  };
}();
var isAbsoluteURL$1 = function isAbsoluteURL(url2) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url2);
};
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL2 = isAbsoluteURL$1;
var combineURLs2 = combineURLs$1;
var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL2(requestedURL)) {
    return combineURLs2(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$b = utils$g;
var ignoreDuplicateOf = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i2;
  if (!headers) {
    return parsed;
  }
  utils$b.forEach(headers.split("\n"), function parser2(line) {
    i2 = line.indexOf(":");
    key = utils$b.trim(line.substr(0, i2)).toLowerCase();
    val = utils$b.trim(line.substr(i2 + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$a = utils$g;
var isURLSameOrigin$1 = utils$a.isStandardBrowserEnv() ? function standardBrowserEnv2() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url2) {
    var href = url2;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$a.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv2() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
function Cancel$3(message) {
  this.message = message;
}
Cancel$3.prototype.toString = function toString() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$3.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel$3;
var utils$9 = utils$g;
var settle2 = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath2 = buildFullPath$1;
var parseHeaders2 = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError2 = createError$2;
var defaults$6 = defaults_1;
var Cancel$2 = Cancel_1;
var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils$9.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request2 = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath2(config.baseURL, config.url);
    request2.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
    request2.timeout = config.timeout;
    function onloadend() {
      if (!request2) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders2(request2.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response;
      var response = {
        data: responseData,
        status: request2.status,
        statusText: request2.statusText,
        headers: responseHeaders,
        config,
        request: request2
      };
      settle2(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request2 = null;
    }
    if ("onloadend" in request2) {
      request2.onloadend = onloadend;
    } else {
      request2.onreadystatechange = function handleLoad() {
        if (!request2 || request2.readyState !== 4) {
          return;
        }
        if (request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request2.onabort = function handleAbort() {
      if (!request2) {
        return;
      }
      reject(createError2("Request aborted", config, "ECONNABORTED", request2));
      request2 = null;
    };
    request2.onerror = function handleError() {
      reject(createError2("Network Error", config, null, request2));
      request2 = null;
    };
    request2.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      var transitional2 = config.transitional || defaults$6.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError2(timeoutErrorMessage, config, transitional2.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request2));
      request2 = null;
    };
    if (utils$9.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request2) {
      utils$9.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request2.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$9.isUndefined(config.withCredentials)) {
      request2.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request2.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request2.addEventListener("progress", config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === "function" && request2.upload) {
      request2.upload.addEventListener("progress", config.onUploadProgress);
    }
    if (config.cancelToken || config.signal) {
      onCanceled = function(cancel) {
        if (!request2) {
          return;
        }
        reject(!cancel || cancel && cancel.type ? new Cancel$2("canceled") : cancel);
        request2.abort();
        request2 = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    if (!requestData) {
      requestData = null;
    }
    request2.send(requestData);
  });
};
var utils$8 = utils$g;
var normalizeHeaderName2 = normalizeHeaderName$1;
var enhanceError2 = enhanceError$2;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$8.isUndefined(headers) && utils$8.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr;
  }
  return adapter;
}
function stringifySafely(rawValue, parser2, encoder) {
  if (utils$8.isString(rawValue)) {
    try {
      (parser2 || JSON.parse)(rawValue);
      return utils$8.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$5 = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data2, headers) {
    normalizeHeaderName2(headers, "Accept");
    normalizeHeaderName2(headers, "Content-Type");
    if (utils$8.isFormData(data2) || utils$8.isArrayBuffer(data2) || utils$8.isBuffer(data2) || utils$8.isStream(data2) || utils$8.isFile(data2) || utils$8.isBlob(data2)) {
      return data2;
    }
    if (utils$8.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$8.isURLSearchParams(data2)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    if (utils$8.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    var transitional2 = this.transitional || defaults$5.transitional;
    var silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
    var forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$8.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw enhanceError2(e, this, "E_JSON_PARSE");
          }
          throw e;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$8.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$5.headers[method] = {};
});
utils$8.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$5.headers[method] = utils$8.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$5;
var utils$7 = utils$g;
var defaults$4 = defaults_1;
var transformData$1 = function transformData(data2, headers, fns) {
  var context = this || defaults$4;
  utils$7.forEach(fns, function transform(fn) {
    data2 = fn.call(context, data2, headers);
  });
  return data2;
};
var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};
var utils$6 = utils$g;
var transformData2 = transformData$1;
var isCancel2 = isCancel$1;
var defaults$3 = defaults_1;
var Cancel$1 = Cancel_1;
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new Cancel$1("canceled");
  }
}
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = config.headers || {};
  config.data = transformData2.call(config, config.data, config.headers, config.transformRequest);
  config.headers = utils$6.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$6.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults$3.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData2.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel2(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData2.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};
var utils$5 = utils$g;
var mergeConfig$2 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  function getMergedValue(target, source2) {
    if (utils$5.isPlainObject(target) && utils$5.isPlainObject(source2)) {
      return utils$5.merge(target, source2);
    } else if (utils$5.isPlainObject(source2)) {
      return utils$5.merge({}, source2);
    } else if (utils$5.isArray(source2)) {
      return source2.slice();
    }
    return source2;
  }
  function mergeDeepProperties(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$5.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$5.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$5.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge3 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge3(prop);
    utils$5.isUndefined(configValue) && merge3 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};
var data = {
  "version": "0.24.0"
};
var VERSION = data.version;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i2) {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
    }
    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys3 = Object.keys(options);
  var i2 = keys3.length;
  while (i2-- > 0) {
    var opt = keys3[i2];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
};
var utils$4 = utils$g;
var buildURL2 = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest2 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request(config) {
  if (typeof config === "string") {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }
  config = mergeConfig$1(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }
  var transitional2 = config.transitional;
  if (transitional2 !== void 0) {
    validator.assertOptions(transitional2, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest2, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }
  try {
    promise = dispatchRequest2(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL2(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
utils$4.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$1.prototype[method] = function(url2, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url: url2,
      data: (config || {}).data
    }));
  };
});
utils$4.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  Axios$1.prototype[method] = function(url2, data2, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url: url2,
      data: data2
    }));
  };
});
var Axios_1 = Axios$1;
var Cancel = Cancel_1;
function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  this.promise.then(function(cancel) {
    if (!token._listeners)
      return;
    var i2;
    var l = token._listeners.length;
    for (i2 = 0; i2 < l; i2++) {
      token._listeners[i2](cancel);
    }
    token._listeners = null;
  });
  this.promise.then = function(onfulfilled) {
    var _resolve;
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);
    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };
    return promise;
  };
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }
  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index2 = this._listeners.indexOf(listener);
  if (index2 !== -1) {
    this._listeners.splice(index2, 1);
  }
};
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token,
    cancel
  };
};
var CancelToken_1 = CancelToken;
var spread = function spread2(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
var isAxiosError = function isAxiosError2(payload) {
  return typeof payload === "object" && payload.isAxiosError === true;
};
var utils$3 = utils$g;
var bind$3 = bind$5;
var Axios = Axios_1;
var mergeConfig2 = mergeConfig$2;
var defaults$2 = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind$3(Axios.prototype.request, context);
  utils$3.extend(instance, Axios.prototype, context);
  utils$3.extend(instance, context);
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig2(defaultConfig, instanceConfig));
  };
  return instance;
}
var axios$1 = createInstance(defaults$2);
axios$1.Axios = Axios;
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;
axios$1.isAxiosError = isAxiosError;
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
var axios = axios$2.exports;
const assertInComponent = (message = "Expected to be called in a Vue component's `setup` or life-cycle hook function.") => {
  if (!getCurrentInstance()) {
    throw new Error(message);
  }
};
const exponentialBackOff = ({ minDelay = 1e3, maxDelay = 5 * 60 * 1e3, delayFactor = 2 } = {}) => (retryAttempt) => Math.max(minDelay, Math.min(maxDelay, Math.floor(minDelay * delayFactor ** retryAttempt)));
const useAxiosRequestInterceptor = (fulfilled, rejected) => {
  assertHasScope();
  const axios2 = useAxios();
  const id = axios2.interceptors.request.use(fulfilled, rejected);
  const stop = () => axios2.interceptors.request.eject(id);
  onScopeDispose(stop);
  return stop;
};
const useAxiosResponseInterceptor = (fulfilled, rejected) => {
  assertHasScope();
  const axios2 = useAxios();
  const id = axios2.interceptors.response.use(fulfilled, rejected);
  const stop = () => axios2.interceptors.response.eject(id);
  onScopeDispose(stop);
  return stop;
};
const raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame;
const rafCallback = (callback) => (...params) => {
  const frame = raf(() => callback(...params));
  return () => window.cancelAnimationFrame(frame);
};
const fileTypeGroups = {
  document: [
    ".pdf",
    ".doc",
    ".txt",
    ".docx",
    ".odt",
    ".msg",
    ".ppt",
    ".pptx",
    ".rtf",
    ".html",
    ".xml",
    ".eml",
    ".dxf",
    ".key",
    ".pages",
    ".vsdx",
    ".step",
    ".stp",
    ".dotx",
    ".sdlxliff",
    ".stl",
    ".htm",
    ".mpp",
    ".ics",
    ".oft",
    ".strings",
    ".log",
    ".pub",
    ".d3l",
    ".x_t",
    ".enriched",
    ".docx_",
    ".docm",
    ".wpd",
    ".wps"
  ],
  spreadsheet: [
    ".xlsx",
    ".xls",
    ".xlsm",
    ".csv",
    ".ods",
    ".numbers",
    ".xlsb",
    ".def",
    ".xll",
    ".xltm",
    ".sxc",
    ".nb",
    ".ots",
    ".rdf",
    ".xar",
    ".pmd",
    ".nmbtemplate",
    ".xltx",
    ".gsheet",
    ".uos"
  ],
  image: [
    ".jpg",
    ".jpeg",
    ".png",
    ".svg",
    ".gif",
    ".tiff",
    ".ai",
    ".psd",
    ".dwg",
    ".eps",
    ".ttf",
    ".otf",
    ".bmp",
    ".webp",
    ".indd",
    ".vsd",
    ".heic",
    ".xd",
    ".plt",
    ".sldprt",
    ".sketch",
    ".cdr",
    ".spl7",
    ".jfif",
    ".easm",
    ".swf",
    ".3dm",
    ".tif",
    ".dds",
    ".tga",
    ".thm"
  ],
  displayableImage: [
    ".jpg",
    ".jpeg",
    ".png",
    ".apng",
    ".gif",
    ".webp",
    ".svg",
    ".avif"
  ],
  audio: [
    ".mp3",
    ".wav",
    ".m4a",
    ".opus",
    ".flac",
    ".wma",
    ".aac",
    ".aif",
    ".iff",
    ".m3u",
    ".mid",
    ".mpa",
    ".ogg"
  ],
  video: [
    ".mp4",
    ".mov",
    ".webm",
    ".m4v",
    ".wmv",
    ".avi",
    ".f4v",
    ".qt",
    ".3gp",
    ".asf",
    ".flv",
    ".mpg",
    ".srt",
    ".vob"
  ],
  data: [".json", ".mdb", ".apk", ".dll", ".db", ".exe", ".hex", ".sdltm"],
  code: [".html", ".xml", ".sql", ".json", ".scss", ".css", ".php", ".js"],
  compressed: [".zip", ".7z", ".rar", ".gz", ".xmind", ".kmz"]
};
function setup(callback) {
  let value;
  const container = document.createElement("div");
  const app = createApp({
    setup() {
      value = callback();
    },
    render: () => null
  });
  app.mount(container);
  return {
    unmount: () => app.unmount(container),
    value
  };
}
function testInComponent(testFunction) {
  return function testFunctionWrapper(...args) {
    const context = this;
    const { unmount, value: promise } = setup(async () => testFunction.apply(context, ...args));
    promise.finally(unmount);
    return promise;
  };
}
function until(refToWatch, expected) {
  return new Promise((resolve) => {
    const unwatch = watch(refToWatch, (value) => {
      if (typeof expected === "undefined" || typeof expected === "function" && expected(value) || expected === value) {
        unwatch();
        resolve();
      }
    });
  });
}
const createFilterState = (defaultState = {}) => {
  const state = reactive(__spreadValues({}, defaultState));
  const stateRefs = toRefs(state);
  const $set = (key, value = null) => {
    if (typeof defaultState[key] === "undefined") {
      return;
    }
    state[key] = value;
  };
  const $patch = (partialState) => {
    if (!isObject$1(partialState)) {
      return;
    }
    Object.keys(partialState).forEach((key) => {
      $set(key, partialState[key]);
    });
  };
  const $setd = useDebounceFn($set, 250);
  const $patchd = useDebounceFn($patch, 250);
  const $refs = () => stateRefs;
  const $reset = () => $patch(defaultState);
  return __spreadValues({
    state,
    $refs,
    $reset,
    $set,
    $setd,
    $patch,
    $patchd
  }, stateRefs);
};
function useBackOff({
  retryDelay = exponentialBackOff()
} = {}) {
  assertHasScope();
  const handle = shallowRef(void 0);
  const retryAttempt = ref(-1);
  function stop() {
    if (handle.value !== void 0) {
      clearTimeout(handle.value);
      handle.value = void 0;
    }
  }
  function start() {
    stop();
    retryAttempt.value += 1;
    handle.value = setTimeout(stop, retryDelay(retryAttempt.value));
  }
  function reset() {
    stop();
    retryAttempt.value = -1;
  }
  onUnmounted(stop);
  return {
    start,
    reset,
    active: computed(() => handle.value !== void 0),
    retryAttempt
  };
}
const useConvertCentValue = (decimalPoints) => {
  const convertToCentValue = (value) => {
    if (!value && value !== 0) {
      return null;
    }
    const centValue = value * 10 ** decimalPoints;
    return Number(`${Math.round(`${centValue}e${decimalPoints}`)}e-${decimalPoints}`);
  };
  const convertFromCentValue = (value) => {
    if (!value && value !== 0) {
      return null;
    }
    const singleCentValue = 10 ** (decimalPoints * -1);
    const zeroDecimalString = `.${"0".repeat(decimalPoints)}`;
    return (value * singleCentValue).toFixed(decimalPoints).replace(zeroDecimalString, "");
  };
  return {
    convertFromCentValue,
    convertToCentValue
  };
};
function useDelayLoader(state, delayTimeMs = 500) {
  const isList = Boolean(state.items.value);
  let timeout;
  const items = isList ? shallowRef(state.items.value) : void 0;
  const totalCount = isList ? shallowRef(state.totalCount.value) : void 0;
  const itemInSync = state.itemInSync;
  const item = !isList ? shallowRef(state.item.value) : void 0;
  const inSync = shallowRef(state.inSync.value);
  const loading = shallowRef(state.loading.value);
  const meta = shallowRef(state.meta.value);
  const response = shallowRef(state.response.value);
  const error = shallowRef(state.error.value);
  function updateState() {
    clearTimeout(timeout);
    if (isList) {
      items.value = state.items.value;
      totalCount.value = state.totalCount.value;
    } else {
      item.value = state.item.value;
    }
    inSync.value = state.inSync.value;
    loading.value = state.loading.value;
    meta.value = state.meta.value;
    response.value = state.response.value;
    error.value = state.error.value;
  }
  function isLoadingNow() {
    const hasSuccess = isList ? totalCount.value !== void 0 : item.value !== void 0;
    const hasError = error.value && (!error.value.config || error.value.config.cache !== "only-if-cached");
    return !hasSuccess && !hasError;
  }
  function isLoadingNext() {
    const hasSuccess = isList ? state.totalCount.value !== void 0 : state.item.value !== void 0;
    const hasError = state.error.value && (!state.error.value.config || state.error.value.config.cache !== "only-if-cached");
    return !hasSuccess && !hasError;
  }
  const watchList = [
    isList && state.items,
    isList && state.totalCount,
    !isList && state.item,
    state.inSync,
    state.loading,
    state.meta,
    state.response,
    state.error
  ].filter(Boolean);
  watch(watchList, () => {
    if (!isLoadingNow() && isLoadingNext()) {
      timeout = setTimeout(updateState, delayTimeMs);
    } else {
      updateState();
    }
  });
  return {
    items,
    totalCount,
    itemInSync,
    item,
    inSync,
    loading,
    meta,
    response,
    error
  };
}
const useFilters = (_filterKey, defaultState = {}) => {
  const filterKey = ref(_filterKey);
  const filters = createFilterState(defaultState);
  const watchState = pausableWatch(filters.state, (current) => {
    lscache.set(filterKey.value, current);
  }, {
    deep: true,
    flush: "post"
  });
  const stopWatchKey = watch(filterKey, (key) => {
    watchState.pause();
    filters.$patch(lscache.get(key) || defaultState);
    watchState.resume();
  }, {
    flush: "sync",
    immediate: true
  });
  const $stop = () => {
    stopWatchKey();
    watchState.stop();
  };
  return __spreadValues({
    filterKey,
    $stop
  }, filters);
};
const useIntersectionRef = (callback, options) => {
  const target = ref(null);
  useIntersectionObserver(target, callback, options);
  return target;
};
const useLocalRef = (_key, initialState = null, { bucket = "", timeout = void 0 } = {}) => {
  const key = ref(_key);
  const prefixedKey = computed(() => bucket + key.value);
  const previousValue = lscache.get(prefixedKey.value);
  const currentValue = ref(typeof previousValue === "undefined" ? initialState : previousValue);
  watch(currentValue, (next) => {
    lscache.set(prefixedKey.value, next, timeout);
  });
  return currentValue;
};
var shams = function hasSymbols() {
  if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
    return false;
  }
  if (typeof Symbol.iterator === "symbol") {
    return true;
  }
  var obj = {};
  var sym = Symbol("test");
  var symObj = Object(sym);
  if (typeof sym === "string") {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
    return false;
  }
  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  }
  if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === "function") {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = shams;
var hasSymbols$1 = function hasNativeSymbols() {
  if (typeof origSymbol !== "function") {
    return false;
  }
  if (typeof Symbol !== "function") {
    return false;
  }
  if (typeof origSymbol("foo") !== "symbol") {
    return false;
  }
  if (typeof Symbol("bar") !== "symbol") {
    return false;
  }
  return hasSymbolSham();
};
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var slice$1 = Array.prototype.slice;
var toStr$1 = Object.prototype.toString;
var funcType = "[object Function]";
var implementation$1 = function bind2(that) {
  var target = this;
  if (typeof target !== "function" || toStr$1.call(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slice$1.call(arguments, 1);
  var bound;
  var binder = function() {
    if (this instanceof bound) {
      var result = target.apply(this, args.concat(slice$1.call(arguments)));
      if (Object(result) === result) {
        return result;
      }
      return this;
    } else {
      return target.apply(that, args.concat(slice$1.call(arguments)));
    }
  };
  var boundLength = Math.max(0, target.length - args.length);
  var boundArgs = [];
  for (var i2 = 0; i2 < boundLength; i2++) {
    boundArgs.push("$" + i2);
  }
  bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
  if (target.prototype) {
    var Empty = function Empty2() {
    };
    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound;
};
var implementation = implementation$1;
var functionBind = Function.prototype.bind || implementation;
var bind$2 = functionBind;
var src = bind$2.call(Function.call, Object.prototype.hasOwnProperty);
var undefined$1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$1 = TypeError;
var getEvalledConstructor = function(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
  } catch (e) {
  }
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
  try {
    $gOPD({}, "");
  } catch (e) {
    $gOPD = null;
  }
}
var throwTypeError = function() {
  throw new $TypeError$1();
};
var ThrowTypeError = $gOPD ? function() {
  try {
    arguments.callee;
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      return $gOPD(arguments, "callee").get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols2 = hasSymbols$1();
var getProto = Object.getPrototypeOf || function(x) {
  return x.__proto__;
};
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" ? undefined$1 : getProto(Uint8Array);
var INTRINSICS = {
  "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols2 ? getProto([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols2 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
  "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols2 ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols2 ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols2 ? getProto(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols2 ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$1,
  "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
};
var doEval = function doEval2(name) {
  var value;
  if (name === "%AsyncFunction%") {
    value = getEvalledConstructor("async function () {}");
  } else if (name === "%GeneratorFunction%") {
    value = getEvalledConstructor("function* () {}");
  } else if (name === "%AsyncGeneratorFunction%") {
    value = getEvalledConstructor("async function* () {}");
  } else if (name === "%AsyncGenerator%") {
    var fn = doEval2("%AsyncGeneratorFunction%");
    if (fn) {
      value = fn.prototype;
    }
  } else if (name === "%AsyncIteratorPrototype%") {
    var gen = doEval2("%AsyncGenerator%");
    if (gen) {
      value = getProto(gen.prototype);
    }
  }
  INTRINSICS[name] = value;
  return value;
};
var LEGACY_ALIASES = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
};
var bind$1 = functionBind;
var hasOwn$1 = src;
var $concat = bind$1.call(Function.call, Array.prototype.concat);
var $spliceApply = bind$1.call(Function.apply, Array.prototype.splice);
var $replace = bind$1.call(Function.call, String.prototype.replace);
var $strSlice = bind$1.call(Function.call, String.prototype.slice);
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = function stringToPath2(string) {
  var first = $strSlice(string, 0, 1);
  var last = $strSlice(string, -1);
  if (first === "%" && last !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
  } else if (last === "%" && first !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
  }
  var result = [];
  $replace(string, rePropName, function(match2, number, quote2, subString) {
    result[result.length] = quote2 ? $replace(subString, reEscapeChar, "$1") : number || match2;
  });
  return result;
};
var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
  var intrinsicName = name;
  var alias;
  if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = "%" + alias[0] + "%";
  }
  if (hasOwn$1(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];
    if (value === needsEval) {
      value = doEval(intrinsicName);
    }
    if (typeof value === "undefined" && !allowMissing) {
      throw new $TypeError$1("intrinsic " + name + " exists, but is not available. Please file an issue!");
    }
    return {
      alias,
      name: intrinsicName,
      value
    };
  }
  throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
var getIntrinsic = function GetIntrinsic(name, allowMissing) {
  if (typeof name !== "string" || name.length === 0) {
    throw new $TypeError$1("intrinsic name must be a non-empty string");
  }
  if (arguments.length > 1 && typeof allowMissing !== "boolean") {
    throw new $TypeError$1('"allowMissing" argument must be a boolean');
  }
  var parts2 = stringToPath(name);
  var intrinsicBaseName = parts2.length > 0 ? parts2[0] : "";
  var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts2, $concat([0, 1], alias));
  }
  for (var i2 = 1, isOwn = true; i2 < parts2.length; i2 += 1) {
    var part = parts2[i2];
    var first = $strSlice(part, 0, 1);
    var last = $strSlice(part, -1);
    if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
      throw new $SyntaxError("property names with quotes must have matching quotes");
    }
    if (part === "constructor" || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += "." + part;
    intrinsicRealName = "%" + intrinsicBaseName + "%";
    if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError$1("base intrinsic for " + name + " exists, but the property is not available.");
        }
        return void 0;
      }
      if ($gOPD && i2 + 1 >= parts2.length) {
        var desc = $gOPD(value, part);
        isOwn = !!desc;
        if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn$1(value, part);
        value = value[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }
  return value;
};
var callBind$1 = { exports: {} };
(function(module) {
  var bind4 = functionBind;
  var GetIntrinsic3 = getIntrinsic;
  var $apply = GetIntrinsic3("%Function.prototype.apply%");
  var $call = GetIntrinsic3("%Function.prototype.call%");
  var $reflectApply = GetIntrinsic3("%Reflect.apply%", true) || bind4.call($call, $apply);
  var $gOPD2 = GetIntrinsic3("%Object.getOwnPropertyDescriptor%", true);
  var $defineProperty = GetIntrinsic3("%Object.defineProperty%", true);
  var $max = GetIntrinsic3("%Math.max%");
  if ($defineProperty) {
    try {
      $defineProperty({}, "a", { value: 1 });
    } catch (e) {
      $defineProperty = null;
    }
  }
  module.exports = function callBind2(originalFunction) {
    var func = $reflectApply(bind4, $call, arguments);
    if ($gOPD2 && $defineProperty) {
      var desc = $gOPD2(func, "length");
      if (desc.configurable) {
        $defineProperty(func, "length", { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) });
      }
    }
    return func;
  };
  var applyBind = function applyBind2() {
    return $reflectApply(bind4, $apply, arguments);
  };
  if ($defineProperty) {
    $defineProperty(module.exports, "apply", { value: applyBind });
  } else {
    module.exports.apply = applyBind;
  }
})(callBind$1);
var GetIntrinsic$1 = getIntrinsic;
var callBind = callBind$1.exports;
var $indexOf = callBind(GetIntrinsic$1("String.prototype.indexOf"));
var callBound$1 = function callBoundIntrinsic(name, allowMissing) {
  var intrinsic = GetIntrinsic$1(name, !!allowMissing);
  if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
    return callBind(intrinsic);
  }
  return intrinsic;
};
var __viteBrowserExternal = {};
var __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": __viteBrowserExternal
});
var require$$6 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasMap = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var match = String.prototype.match;
var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
  return O.__proto__;
} : null);
var inspectCustom = require$$6.custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;
var toStringTag = typeof Symbol === "function" && typeof Symbol.toStringTag !== "undefined" ? Symbol.toStringTag : null;
var objectInspect = function inspect_(obj, options, depth, seen) {
  var opts = options || {};
  if (has$4(opts, "quoteStyle") && (opts.quoteStyle !== "single" && opts.quoteStyle !== "double")) {
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  }
  if (has$4(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  }
  var customInspect = has$4(opts, "customInspect") ? opts.customInspect : true;
  if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  }
  if (has$4(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
    throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
  }
  if (typeof obj === "undefined") {
    return "undefined";
  }
  if (obj === null) {
    return "null";
  }
  if (typeof obj === "boolean") {
    return obj ? "true" : "false";
  }
  if (typeof obj === "string") {
    return inspectString(obj, opts);
  }
  if (typeof obj === "number") {
    if (obj === 0) {
      return Infinity / obj > 0 ? "0" : "-0";
    }
    return String(obj);
  }
  if (typeof obj === "bigint") {
    return String(obj) + "n";
  }
  var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
  if (typeof depth === "undefined") {
    depth = 0;
  }
  if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") {
    return isArray$5(obj) ? "[Array]" : "[Object]";
  }
  var indent = getIndent(opts, depth);
  if (typeof seen === "undefined") {
    seen = [];
  } else if (indexOf$2(seen, obj) >= 0) {
    return "[Circular]";
  }
  function inspect2(value, from, noIndent) {
    if (from) {
      seen = seen.slice();
      seen.push(from);
    }
    if (noIndent) {
      var newOpts = {
        depth: opts.depth
      };
      if (has$4(opts, "quoteStyle")) {
        newOpts.quoteStyle = opts.quoteStyle;
      }
      return inspect_(value, newOpts, depth + 1, seen);
    }
    return inspect_(value, opts, depth + 1, seen);
  }
  if (typeof obj === "function") {
    var name = nameOf(obj);
    var keys3 = arrObjKeys(obj, inspect2);
    return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys3.length > 0 ? " { " + keys3.join(", ") + " }" : "");
  }
  if (isSymbol(obj)) {
    var symString = hasShammedSymbols ? String(obj).replace(/^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
    return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
  }
  if (isElement(obj)) {
    var s2 = "<" + String(obj.nodeName).toLowerCase();
    var attrs = obj.attributes || [];
    for (var i2 = 0; i2 < attrs.length; i2++) {
      s2 += " " + attrs[i2].name + "=" + wrapQuotes(quote(attrs[i2].value), "double", opts);
    }
    s2 += ">";
    if (obj.childNodes && obj.childNodes.length) {
      s2 += "...";
    }
    s2 += "</" + String(obj.nodeName).toLowerCase() + ">";
    return s2;
  }
  if (isArray$5(obj)) {
    if (obj.length === 0) {
      return "[]";
    }
    var xs = arrObjKeys(obj, inspect2);
    if (indent && !singleLineValues(xs)) {
      return "[" + indentedJoin(xs, indent) + "]";
    }
    return "[ " + xs.join(", ") + " ]";
  }
  if (isError(obj)) {
    var parts2 = arrObjKeys(obj, inspect2);
    if (parts2.length === 0) {
      return "[" + String(obj) + "]";
    }
    return "{ [" + String(obj) + "] " + parts2.join(", ") + " }";
  }
  if (typeof obj === "object" && customInspect) {
    if (inspectSymbol && typeof obj[inspectSymbol] === "function") {
      return obj[inspectSymbol]();
    } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
      return obj.inspect();
    }
  }
  if (isMap(obj)) {
    var mapParts = [];
    mapForEach.call(obj, function(value, key) {
      mapParts.push(inspect2(key, obj, true) + " => " + inspect2(value, obj));
    });
    return collectionOf("Map", mapSize.call(obj), mapParts, indent);
  }
  if (isSet(obj)) {
    var setParts = [];
    setForEach.call(obj, function(value) {
      setParts.push(inspect2(value, obj));
    });
    return collectionOf("Set", setSize.call(obj), setParts, indent);
  }
  if (isWeakMap(obj)) {
    return weakCollectionOf("WeakMap");
  }
  if (isWeakSet(obj)) {
    return weakCollectionOf("WeakSet");
  }
  if (isWeakRef(obj)) {
    return weakCollectionOf("WeakRef");
  }
  if (isNumber(obj)) {
    return markBoxed(inspect2(Number(obj)));
  }
  if (isBigInt(obj)) {
    return markBoxed(inspect2(bigIntValueOf.call(obj)));
  }
  if (isBoolean(obj)) {
    return markBoxed(booleanValueOf.call(obj));
  }
  if (isString(obj)) {
    return markBoxed(inspect2(String(obj)));
  }
  if (!isDate(obj) && !isRegExp$1(obj)) {
    var ys = arrObjKeys(obj, inspect2);
    var isPlainObject2 = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
    var protoTag = obj instanceof Object ? "" : "null prototype";
    var stringTag = !isPlainObject2 && toStringTag && Object(obj) === obj && toStringTag in obj ? toStr(obj).slice(8, -1) : protoTag ? "Object" : "";
    var constructorTag = isPlainObject2 || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
    var tag = constructorTag + (stringTag || protoTag ? "[" + [].concat(stringTag || [], protoTag || []).join(": ") + "] " : "");
    if (ys.length === 0) {
      return tag + "{}";
    }
    if (indent) {
      return tag + "{" + indentedJoin(ys, indent) + "}";
    }
    return tag + "{ " + ys.join(", ") + " }";
  }
  return String(obj);
};
function wrapQuotes(s2, defaultStyle, opts) {
  var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
  return quoteChar + s2 + quoteChar;
}
function quote(s2) {
  return String(s2).replace(/"/g, "&quot;");
}
function isArray$5(obj) {
  return toStr(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isDate(obj) {
  return toStr(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isRegExp$1(obj) {
  return toStr(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isError(obj) {
  return toStr(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isString(obj) {
  return toStr(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isNumber(obj) {
  return toStr(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isBoolean(obj) {
  return toStr(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isSymbol(obj) {
  if (hasShammedSymbols) {
    return obj && typeof obj === "object" && obj instanceof Symbol;
  }
  if (typeof obj === "symbol") {
    return true;
  }
  if (!obj || typeof obj !== "object" || !symToString) {
    return false;
  }
  try {
    symToString.call(obj);
    return true;
  } catch (e) {
  }
  return false;
}
function isBigInt(obj) {
  if (!obj || typeof obj !== "object" || !bigIntValueOf) {
    return false;
  }
  try {
    bigIntValueOf.call(obj);
    return true;
  } catch (e) {
  }
  return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
  return key in this;
};
function has$4(obj, key) {
  return hasOwn.call(obj, key);
}
function toStr(obj) {
  return objectToString.call(obj);
}
function nameOf(f) {
  if (f.name) {
    return f.name;
  }
  var m2 = match.call(functionToString.call(f), /^function\s*([\w$]+)/);
  if (m2) {
    return m2[1];
  }
  return null;
}
function indexOf$2(xs, x) {
  if (xs.indexOf) {
    return xs.indexOf(x);
  }
  for (var i2 = 0, l = xs.length; i2 < l; i2++) {
    if (xs[i2] === x) {
      return i2;
    }
  }
  return -1;
}
function isMap(x) {
  if (!mapSize || !x || typeof x !== "object") {
    return false;
  }
  try {
    mapSize.call(x);
    try {
      setSize.call(x);
    } catch (s2) {
      return true;
    }
    return x instanceof Map;
  } catch (e) {
  }
  return false;
}
function isWeakMap(x) {
  if (!weakMapHas || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakMapHas.call(x, weakMapHas);
    try {
      weakSetHas.call(x, weakSetHas);
    } catch (s2) {
      return true;
    }
    return x instanceof WeakMap;
  } catch (e) {
  }
  return false;
}
function isWeakRef(x) {
  if (!weakRefDeref || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakRefDeref.call(x);
    return true;
  } catch (e) {
  }
  return false;
}
function isSet(x) {
  if (!setSize || !x || typeof x !== "object") {
    return false;
  }
  try {
    setSize.call(x);
    try {
      mapSize.call(x);
    } catch (m2) {
      return true;
    }
    return x instanceof Set;
  } catch (e) {
  }
  return false;
}
function isWeakSet(x) {
  if (!weakSetHas || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakSetHas.call(x, weakSetHas);
    try {
      weakMapHas.call(x, weakMapHas);
    } catch (s2) {
      return true;
    }
    return x instanceof WeakSet;
  } catch (e) {
  }
  return false;
}
function isElement(x) {
  if (!x || typeof x !== "object") {
    return false;
  }
  if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) {
    return true;
  }
  return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function inspectString(str, opts) {
  if (str.length > opts.maxStringLength) {
    var remaining = str.length - opts.maxStringLength;
    var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
    return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
  }
  var s2 = str.replace(/(['\\])/g, "\\$1").replace(/[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(s2, "single", opts);
}
function lowbyte(c) {
  var n = c.charCodeAt(0);
  var x = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[n];
  if (x) {
    return "\\" + x;
  }
  return "\\x" + (n < 16 ? "0" : "") + n.toString(16).toUpperCase();
}
function markBoxed(str) {
  return "Object(" + str + ")";
}
function weakCollectionOf(type) {
  return type + " { ? }";
}
function collectionOf(type, size, entries, indent) {
  var joinedEntries = indent ? indentedJoin(entries, indent) : entries.join(", ");
  return type + " (" + size + ") {" + joinedEntries + "}";
}
function singleLineValues(xs) {
  for (var i2 = 0; i2 < xs.length; i2++) {
    if (indexOf$2(xs[i2], "\n") >= 0) {
      return false;
    }
  }
  return true;
}
function getIndent(opts, depth) {
  var baseIndent;
  if (opts.indent === "	") {
    baseIndent = "	";
  } else if (typeof opts.indent === "number" && opts.indent > 0) {
    baseIndent = Array(opts.indent + 1).join(" ");
  } else {
    return null;
  }
  return {
    base: baseIndent,
    prev: Array(depth + 1).join(baseIndent)
  };
}
function indentedJoin(xs, indent) {
  if (xs.length === 0) {
    return "";
  }
  var lineJoiner = "\n" + indent.prev + indent.base;
  return lineJoiner + xs.join("," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys(obj, inspect2) {
  var isArr = isArray$5(obj);
  var xs = [];
  if (isArr) {
    xs.length = obj.length;
    for (var i2 = 0; i2 < obj.length; i2++) {
      xs[i2] = has$4(obj, i2) ? inspect2(obj[i2], obj) : "";
    }
  }
  var syms = typeof gOPS === "function" ? gOPS(obj) : [];
  var symMap;
  if (hasShammedSymbols) {
    symMap = {};
    for (var k = 0; k < syms.length; k++) {
      symMap["$" + syms[k]] = syms[k];
    }
  }
  for (var key in obj) {
    if (!has$4(obj, key)) {
      continue;
    }
    if (isArr && String(Number(key)) === key && key < obj.length) {
      continue;
    }
    if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) {
      continue;
    } else if (/[^\w$]/.test(key)) {
      xs.push(inspect2(key, obj) + ": " + inspect2(obj[key], obj));
    } else {
      xs.push(key + ": " + inspect2(obj[key], obj));
    }
  }
  if (typeof gOPS === "function") {
    for (var j = 0; j < syms.length; j++) {
      if (isEnumerable.call(obj, syms[j])) {
        xs.push("[" + inspect2(syms[j]) + "]: " + inspect2(obj[syms[j]], obj));
      }
    }
  }
  return xs;
}
var GetIntrinsic2 = getIntrinsic;
var callBound = callBound$1;
var inspect = objectInspect;
var $TypeError = GetIntrinsic2("%TypeError%");
var $WeakMap = GetIntrinsic2("%WeakMap%", true);
var $Map = GetIntrinsic2("%Map%", true);
var $weakMapGet = callBound("WeakMap.prototype.get", true);
var $weakMapSet = callBound("WeakMap.prototype.set", true);
var $weakMapHas = callBound("WeakMap.prototype.has", true);
var $mapGet = callBound("Map.prototype.get", true);
var $mapSet = callBound("Map.prototype.set", true);
var $mapHas = callBound("Map.prototype.has", true);
var listGetNode = function(list, key) {
  for (var prev2 = list, curr; (curr = prev2.next) !== null; prev2 = curr) {
    if (curr.key === key) {
      prev2.next = curr.next;
      curr.next = list.next;
      list.next = curr;
      return curr;
    }
  }
};
var listGet = function(objects, key) {
  var node = listGetNode(objects, key);
  return node && node.value;
};
var listSet = function(objects, key, value) {
  var node = listGetNode(objects, key);
  if (node) {
    node.value = value;
  } else {
    objects.next = {
      key,
      next: objects.next,
      value
    };
  }
};
var listHas = function(objects, key) {
  return !!listGetNode(objects, key);
};
var sideChannel = function getSideChannel() {
  var $wm;
  var $m;
  var $o;
  var channel = {
    assert: function(key) {
      if (!channel.has(key)) {
        throw new $TypeError("Side channel does not contain " + inspect(key));
      }
    },
    get: function(key) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapGet($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapGet($m, key);
        }
      } else {
        if ($o) {
          return listGet($o, key);
        }
      }
    },
    has: function(key) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapHas($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapHas($m, key);
        }
      } else {
        if ($o) {
          return listHas($o, key);
        }
      }
      return false;
    },
    set: function(key, value) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if (!$wm) {
          $wm = new $WeakMap();
        }
        $weakMapSet($wm, key, value);
      } else if ($Map) {
        if (!$m) {
          $m = new $Map();
        }
        $mapSet($m, key, value);
      } else {
        if (!$o) {
          $o = { key: {}, next: null };
        }
        listSet($o, key, value);
      }
    }
  };
  return channel;
};
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
};
var formats$3 = {
  "default": Format.RFC3986,
  formatters: {
    RFC1738: function(value) {
      return replace.call(value, percentTwenties, "+");
    },
    RFC3986: function(value) {
      return String(value);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
};
var formats$2 = formats$3;
var has$3 = Object.prototype.hasOwnProperty;
var isArray$4 = Array.isArray;
var hexTable = function() {
  var array = [];
  for (var i2 = 0; i2 < 256; ++i2) {
    array.push("%" + ((i2 < 16 ? "0" : "") + i2.toString(16)).toUpperCase());
  }
  return array;
}();
var compactQueue = function compactQueue2(queue) {
  while (queue.length > 1) {
    var item = queue.pop();
    var obj = item.obj[item.prop];
    if (isArray$4(obj)) {
      var compacted = [];
      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== "undefined") {
          compacted.push(obj[j]);
        }
      }
      item.obj[item.prop] = compacted;
    }
  }
};
var arrayToObject = function arrayToObject2(source2, options) {
  var obj = options && options.plainObjects ? Object.create(null) : {};
  for (var i2 = 0; i2 < source2.length; ++i2) {
    if (typeof source2[i2] !== "undefined") {
      obj[i2] = source2[i2];
    }
  }
  return obj;
};
var merge = function merge2(target, source2, options) {
  if (!source2) {
    return target;
  }
  if (typeof source2 !== "object") {
    if (isArray$4(target)) {
      target.push(source2);
    } else if (target && typeof target === "object") {
      if (options && (options.plainObjects || options.allowPrototypes) || !has$3.call(Object.prototype, source2)) {
        target[source2] = true;
      }
    } else {
      return [target, source2];
    }
    return target;
  }
  if (!target || typeof target !== "object") {
    return [target].concat(source2);
  }
  var mergeTarget = target;
  if (isArray$4(target) && !isArray$4(source2)) {
    mergeTarget = arrayToObject(target, options);
  }
  if (isArray$4(target) && isArray$4(source2)) {
    source2.forEach(function(item, i2) {
      if (has$3.call(target, i2)) {
        var targetItem = target[i2];
        if (targetItem && typeof targetItem === "object" && item && typeof item === "object") {
          target[i2] = merge2(targetItem, item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i2] = item;
      }
    });
    return target;
  }
  return Object.keys(source2).reduce(function(acc, key) {
    var value = source2[key];
    if (has$3.call(acc, key)) {
      acc[key] = merge2(acc[key], value, options);
    } else {
      acc[key] = value;
    }
    return acc;
  }, mergeTarget);
};
var assign = function assignSingleSource(target, source2) {
  return Object.keys(source2).reduce(function(acc, key) {
    acc[key] = source2[key];
    return acc;
  }, target);
};
var decode$1 = function(str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, " ");
  if (charset === "iso-8859-1") {
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  }
  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};
var encode$1 = function encode(str, defaultEncoder, charset, kind, format) {
  if (str.length === 0) {
    return str;
  }
  var string = str;
  if (typeof str === "symbol") {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== "string") {
    string = String(str);
  }
  if (charset === "iso-8859-1") {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
      return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
  }
  var out = "";
  for (var i2 = 0; i2 < string.length; ++i2) {
    var c = string.charCodeAt(i2);
    if (c === 45 || c === 46 || c === 95 || c === 126 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format === formats$2.RFC1738 && (c === 40 || c === 41)) {
      out += string.charAt(i2);
      continue;
    }
    if (c < 128) {
      out = out + hexTable[c];
      continue;
    }
    if (c < 2048) {
      out = out + (hexTable[192 | c >> 6] + hexTable[128 | c & 63]);
      continue;
    }
    if (c < 55296 || c >= 57344) {
      out = out + (hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63]);
      continue;
    }
    i2 += 1;
    c = 65536 + ((c & 1023) << 10 | string.charCodeAt(i2) & 1023);
    out += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
  }
  return out;
};
var compact = function compact2(value) {
  var queue = [{ obj: { o: value }, prop: "o" }];
  var refs = [];
  for (var i2 = 0; i2 < queue.length; ++i2) {
    var item = queue[i2];
    var obj = item.obj[item.prop];
    var keys3 = Object.keys(obj);
    for (var j = 0; j < keys3.length; ++j) {
      var key = keys3[j];
      var val = obj[key];
      if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
        queue.push({ obj, prop: key });
        refs.push(val);
      }
    }
  }
  compactQueue(queue);
  return value;
};
var isRegExp = function isRegExp2(obj) {
  return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var isBuffer$1 = function isBuffer(obj) {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine = function combine2(a, b) {
  return [].concat(a, b);
};
var maybeMap = function maybeMap2(val, fn) {
  if (isArray$4(val)) {
    var mapped = [];
    for (var i2 = 0; i2 < val.length; i2 += 1) {
      mapped.push(fn(val[i2]));
    }
    return mapped;
  }
  return fn(val);
};
var utils$2 = {
  arrayToObject,
  assign,
  combine,
  compact,
  decode: decode$1,
  encode: encode$1,
  isBuffer: isBuffer$1,
  isRegExp,
  maybeMap,
  merge
};
var getSideChannel2 = sideChannel;
var utils$1 = utils$2;
var formats$1 = formats$3;
var has$2 = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    return prefix + "[]";
  },
  comma: "comma",
  indices: function indices(prefix, key) {
    return prefix + "[" + key + "]";
  },
  repeat: function repeat(prefix) {
    return prefix;
  }
};
var isArray$3 = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function(arr, valueOrArray) {
  push.apply(arr, isArray$3(valueOrArray) ? valueOrArray : [valueOrArray]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats$1["default"];
var defaults$1 = {
  addQueryPrefix: false,
  allowDots: false,
  charset: "utf-8",
  charsetSentinel: false,
  delimiter: "&",
  encode: true,
  encoder: utils$1.encode,
  encodeValuesOnly: false,
  format: defaultFormat,
  formatter: formats$1.formatters[defaultFormat],
  indices: false,
  serializeDate: function serializeDate(date) {
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};
var isNonNullishPrimitive = function isNonNullishPrimitive2(v) {
  return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var stringify$1 = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate2, format, formatter, encodeValuesOnly, charset, sideChannel2) {
  var obj = object;
  if (sideChannel2.has(object)) {
    throw new RangeError("Cyclic object value");
  }
  if (typeof filter === "function") {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate2(obj);
  } else if (generateArrayPrefix === "comma" && isArray$3(obj)) {
    obj = utils$1.maybeMap(obj, function(value2) {
      if (value2 instanceof Date) {
        return serializeDate2(value2);
      }
      return value2;
    });
  }
  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset, "key", format) : prefix;
    }
    obj = "";
  }
  if (isNonNullishPrimitive(obj) || utils$1.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset, "key", format);
      return [formatter(keyValue) + "=" + formatter(encoder(obj, defaults$1.encoder, charset, "value", format))];
    }
    return [formatter(prefix) + "=" + formatter(String(obj))];
  }
  var values = [];
  if (typeof obj === "undefined") {
    return values;
  }
  var objKeys;
  if (generateArrayPrefix === "comma" && isArray$3(obj)) {
    objKeys = [{ value: obj.length > 0 ? obj.join(",") || null : void 0 }];
  } else if (isArray$3(filter)) {
    objKeys = filter;
  } else {
    var keys3 = Object.keys(obj);
    objKeys = sort ? keys3.sort(sort) : keys3;
  }
  for (var i2 = 0; i2 < objKeys.length; ++i2) {
    var key = objKeys[i2];
    var value = typeof key === "object" && key.value !== void 0 ? key.value : obj[key];
    if (skipNulls && value === null) {
      continue;
    }
    var keyPrefix = isArray$3(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
    sideChannel2.set(object, true);
    var valueSideChannel = getSideChannel2();
    pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate2, format, formatter, encodeValuesOnly, charset, valueSideChannel));
  }
  return values;
};
var normalizeStringifyOptions = function normalizeStringifyOptions2(opts) {
  if (!opts) {
    return defaults$1;
  }
  if (opts.encoder !== null && opts.encoder !== void 0 && typeof opts.encoder !== "function") {
    throw new TypeError("Encoder has to be a function.");
  }
  var charset = opts.charset || defaults$1.charset;
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  var format = formats$1["default"];
  if (typeof opts.format !== "undefined") {
    if (!has$2.call(formats$1.formatters, opts.format)) {
      throw new TypeError("Unknown format option provided.");
    }
    format = opts.format;
  }
  var formatter = formats$1.formatters[format];
  var filter = defaults$1.filter;
  if (typeof opts.filter === "function" || isArray$3(opts.filter)) {
    filter = opts.filter;
  }
  return {
    addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults$1.addQueryPrefix,
    allowDots: typeof opts.allowDots === "undefined" ? defaults$1.allowDots : !!opts.allowDots,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults$1.charsetSentinel,
    delimiter: typeof opts.delimiter === "undefined" ? defaults$1.delimiter : opts.delimiter,
    encode: typeof opts.encode === "boolean" ? opts.encode : defaults$1.encode,
    encoder: typeof opts.encoder === "function" ? opts.encoder : defaults$1.encoder,
    encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults$1.encodeValuesOnly,
    filter,
    format,
    formatter,
    serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults$1.serializeDate,
    skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults$1.skipNulls,
    sort: typeof opts.sort === "function" ? opts.sort : null,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults$1.strictNullHandling
  };
};
var stringify_1 = function(object, opts) {
  var obj = object;
  var options = normalizeStringifyOptions(opts);
  var objKeys;
  var filter;
  if (typeof options.filter === "function") {
    filter = options.filter;
    obj = filter("", obj);
  } else if (isArray$3(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }
  var keys3 = [];
  if (typeof obj !== "object" || obj === null) {
    return "";
  }
  var arrayFormat;
  if (opts && opts.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = opts.arrayFormat;
  } else if (opts && "indices" in opts) {
    arrayFormat = opts.indices ? "indices" : "repeat";
  } else {
    arrayFormat = "indices";
  }
  var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
  if (!objKeys) {
    objKeys = Object.keys(obj);
  }
  if (options.sort) {
    objKeys.sort(options.sort);
  }
  var sideChannel2 = getSideChannel2();
  for (var i2 = 0; i2 < objKeys.length; ++i2) {
    var key = objKeys[i2];
    if (options.skipNulls && obj[key] === null) {
      continue;
    }
    pushToArray(keys3, stringify$1(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel2));
  }
  var joined = keys3.join(options.delimiter);
  var prefix = options.addQueryPrefix === true ? "?" : "";
  if (options.charsetSentinel) {
    if (options.charset === "iso-8859-1") {
      prefix += "utf8=%26%2310003%3B&";
    } else {
      prefix += "utf8=%E2%9C%93&";
    }
  }
  return joined.length > 0 ? prefix + joined : "";
};
var utils = utils$2;
var has$1 = Object.prototype.hasOwnProperty;
var isArray$2 = Array.isArray;
var defaults = {
  allowDots: false,
  allowPrototypes: false,
  allowSparse: false,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: false,
  comma: false,
  decoder: utils.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1e3,
  parseArrays: true,
  plainObjects: false,
  strictNullHandling: false
};
var interpretNumericEntities = function(str) {
  return str.replace(/&#(\d+);/g, function($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
};
var parseArrayValue = function(val, options) {
  if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) {
    return val.split(",");
  }
  return val;
};
var isoSentinel = "utf8=%26%2310003%3B";
var charsetSentinel = "utf8=%E2%9C%93";
var parseValues = function parseQueryStringValues(str, options) {
  var obj = {};
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
  var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
  var parts2 = cleanStr.split(options.delimiter, limit);
  var skipIndex = -1;
  var i2;
  var charset = options.charset;
  if (options.charsetSentinel) {
    for (i2 = 0; i2 < parts2.length; ++i2) {
      if (parts2[i2].indexOf("utf8=") === 0) {
        if (parts2[i2] === charsetSentinel) {
          charset = "utf-8";
        } else if (parts2[i2] === isoSentinel) {
          charset = "iso-8859-1";
        }
        skipIndex = i2;
        i2 = parts2.length;
      }
    }
  }
  for (i2 = 0; i2 < parts2.length; ++i2) {
    if (i2 === skipIndex) {
      continue;
    }
    var part = parts2[i2];
    var bracketEqualsPos = part.indexOf("]=");
    var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
    var key, val;
    if (pos === -1) {
      key = options.decoder(part, defaults.decoder, charset, "key");
      val = options.strictNullHandling ? null : "";
    } else {
      key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
      val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
        return options.decoder(encodedVal, defaults.decoder, charset, "value");
      });
    }
    if (val && options.interpretNumericEntities && charset === "iso-8859-1") {
      val = interpretNumericEntities(val);
    }
    if (part.indexOf("[]=") > -1) {
      val = isArray$2(val) ? [val] : val;
    }
    if (has$1.call(obj, key)) {
      obj[key] = utils.combine(obj[key], val);
    } else {
      obj[key] = val;
    }
  }
  return obj;
};
var parseObject = function(chain, val, options, valuesParsed) {
  var leaf = valuesParsed ? val : parseArrayValue(val, options);
  for (var i2 = chain.length - 1; i2 >= 0; --i2) {
    var obj;
    var root = chain[i2];
    if (root === "[]" && options.parseArrays) {
      obj = [].concat(leaf);
    } else {
      obj = options.plainObjects ? Object.create(null) : {};
      var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
      var index2 = parseInt(cleanRoot, 10);
      if (!options.parseArrays && cleanRoot === "") {
        obj = { 0: leaf };
      } else if (!isNaN(index2) && root !== cleanRoot && String(index2) === cleanRoot && index2 >= 0 && (options.parseArrays && index2 <= options.arrayLimit)) {
        obj = [];
        obj[index2] = leaf;
      } else {
        obj[cleanRoot] = leaf;
      }
    }
    leaf = obj;
  }
  return leaf;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
  if (!givenKey) {
    return;
  }
  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
  var brackets2 = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g;
  var segment = options.depth > 0 && brackets2.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key;
  var keys3 = [];
  if (parent) {
    if (!options.plainObjects && has$1.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys3.push(parent);
  }
  var i2 = 0;
  while (options.depth > 0 && (segment = child.exec(key)) !== null && i2 < options.depth) {
    i2 += 1;
    if (!options.plainObjects && has$1.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys3.push(segment[1]);
  }
  if (segment) {
    keys3.push("[" + key.slice(segment.index) + "]");
  }
  return parseObject(keys3, val, options, valuesParsed);
};
var normalizeParseOptions = function normalizeParseOptions2(opts) {
  if (!opts) {
    return defaults;
  }
  if (opts.decoder !== null && opts.decoder !== void 0 && typeof opts.decoder !== "function") {
    throw new TypeError("Decoder has to be a function.");
  }
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
  return {
    allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
    allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
    allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
    arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
    comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
    decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
    delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
    depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
  };
};
var parse$2 = function(str, opts) {
  var options = normalizeParseOptions(opts);
  if (str === "" || str === null || typeof str === "undefined") {
    return options.plainObjects ? Object.create(null) : {};
  }
  var tempObj = typeof str === "string" ? parseValues(str, options) : str;
  var obj = options.plainObjects ? Object.create(null) : {};
  var keys3 = Object.keys(tempObj);
  for (var i2 = 0; i2 < keys3.length; ++i2) {
    var key = keys3[i2];
    var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
    obj = utils.merge(obj, newObj, options);
  }
  if (options.allowSparse === true) {
    return obj;
  }
  return utils.compact(obj);
};
var stringify2 = stringify_1;
var parse$1 = parse$2;
var formats = formats$3;
var lib$2 = {
  formats,
  parse: parse$1,
  stringify: stringify2
};
const client = axios.create({
  paramsSerializer(params) {
    return lib$2.stringify(params, { arrayFormat: "brackets" });
  }
});
const getPresignedUrl = async (fileName, fileSize, endpoint) => {
  return client.get(endpoint, {
    params: {
      fileName,
      fileSize
    }
  });
};
async function useS3Presign(file, { endpoint }) {
  const { data: data2 } = await getPresignedUrl(file.name, file.size, endpoint);
  file.meta.ref = data2.ref;
  return {
    method: "PUT",
    url: data2.url,
    headers: {
      "X-Amz-Acl": "public-read",
      "Content-Type": file.type
    }
  };
}
function usePreventLoaderFlash(isLoading, loaderDelayMs = 200, loaderMinTimeVisibleMs = 500) {
  const shouldShowLoader = ref(false);
  const loaderMinTimeVisibleExceeded = ref(true);
  let delayShowLoaderTimeoutId;
  let delayHideLoaderTimeoutId;
  function hideLoader() {
    clearTimeout(delayShowLoaderTimeoutId);
    clearTimeout(delayHideLoaderTimeoutId);
    shouldShowLoader.value = false;
  }
  function showLoader() {
    shouldShowLoader.value = true;
    loaderMinTimeVisibleExceeded.value = false;
    delayHideLoaderTimeoutId = setTimeout(() => {
      loaderMinTimeVisibleExceeded.value = true;
      if (!isLoading.value) {
        hideLoader();
      }
    }, loaderMinTimeVisibleMs);
  }
  function delayLoader(isLoadingValue) {
    if (!shouldShowLoader.value && isLoadingValue) {
      delayShowLoaderTimeoutId = setTimeout(() => {
        showLoader();
      }, loaderDelayMs);
    }
    if (!isLoadingValue && loaderMinTimeVisibleExceeded.value) {
      hideLoader();
    }
  }
  watch(isLoading, delayLoader, {
    immediate: true
  });
  return {
    shouldShowLoader
  };
}
function useListLoader({
  url: _url,
  params: _params,
  count: _count = 0,
  responseToItems: _responseToItems = () => [],
  responseToMeta: _responseToMeta = () => null,
  order: _order,
  pageSize: _pageSize = 10
}) {
  assertHasScope();
  const axiosInstance = useAxios();
  const { handlingEventFromSocket } = useRealTimeUpdates();
  const url2 = shallowRef(_url);
  const params = shallowRef(_params);
  const count = shallowRef(_count);
  const responseToItems2 = shallowRef(_responseToItems);
  const responseToMeta2 = shallowRef(_responseToMeta);
  const order2 = shallowRef(_order);
  const pageSize = shallowRef(_pageSize);
  const cursor = shallowRef(void 0);
  const loadedCount = shallowRef(0);
  const totalCount = shallowRef(void 0);
  const lastUpdated = shallowRef(void 0);
  const itemsMap = shallowRef(new Map());
  const updatedItemIds = shallowRef(new Set());
  const optimisticUpdates = shallowRef(new Set());
  const cancel = shallowRef(void 0);
  const backOff = useBackOff();
  const meta = shallowRef(void 0);
  const response = shallowRef(void 0);
  const error = shallowRef(void 0);
  const loading = computed(() => Boolean(cancel.value));
  const outdatedItems = shallowRef(void 0);
  const needsBuffer = shallowRef(false);
  const bufferSize = computed(() => needsBuffer.value ? Math.ceil(pageSize.value * 0.2) : 0);
  const needsRefresh = computed(() => updatedItemIds.value.size > 0 || Boolean(outdatedItems.value));
  const inSync = computed(() => !needsRefresh.value && optimisticUpdates.value.size === 0 && (lastUpdated.value !== void 0 || count.value < 0) && (pageSize.value === 0 || loadedCount.value >= count.value || loadedCount.value >= totalCount.value));
  const shouldUseCache = computed(() => response.value === void 0 && error.value === void 0);
  let cachedItems = [];
  function applyOptimisticUpdates(loadedItems) {
    let processedItems = loadedItems;
    optimisticUpdates.value.forEach((optimisticUpdate) => {
      processedItems = optimisticUpdate.apply(processedItems);
    });
    return processedItems;
  }
  const allItems = computed(() => {
    const newItems = applyOptimisticUpdates(outdatedItems.value || Array.from(itemsMap.value.values()));
    if (typeof order2.value === "function") {
      newItems.sort(order2.value);
    }
    return newItems;
  });
  const items = computed(() => {
    const newItems = allItems.value.slice(0, Math.max(0, count.value));
    if (newItems.length !== cachedItems.length || newItems.some((newItem, index2) => newItem !== cachedItems[index2])) {
      cachedItems = newItems;
    }
    return cachedItems;
  });
  let triggeredBy = "user";
  function reset() {
    cursor.value = void 0;
    needsBuffer.value = false;
    loadedCount.value = 0;
    totalCount.value = void 0;
    lastUpdated.value = void 0;
    response.value = void 0;
    error.value = void 0;
    meta.value = void 0;
    itemsMap.value.clear();
    triggerRef(itemsMap);
    updatedItemIds.value.clear();
    triggerRef(updatedItemIds);
    if (cancel.value)
      cancel.value();
    backOff.reset();
    triggeredBy = "user";
  }
  function refresh(itemId) {
    if (typeof itemId === "undefined") {
      outdatedItems.value = Array.from(itemsMap.value.values());
      cursor.value = void 0;
      loadedCount.value = 0;
      lastUpdated.value = void 0;
      itemsMap.value.clear();
      triggerRef(itemsMap);
      updatedItemIds.value.clear();
      triggerRef(updatedItemIds);
    } else {
      needsBuffer.value = true;
      updatedItemIds.value.add(itemId);
      triggerRef(updatedItemIds);
    }
    if (cancel.value)
      cancel.value();
    backOff.reset();
    triggeredBy = handlingEventFromSocket.value ? "event/ws" : "event/local";
  }
  function getLastUpdated({ headers }) {
    return moment.utc(headers.date).subtract(1e4);
  }
  async function loadUpdates() {
    var _a;
    if (lastUpdated.value === void 0) {
      updatedItemIds.value.clear();
      triggerRef(updatedItemIds);
      return;
    }
    if (updatedItemIds.value.size > pageSize.value) {
      refresh();
      return;
    }
    try {
      response.value = await new Promise((resolve, reject) => {
        const requestParams = __spreadProps(__spreadValues({}, params.value), {
          cursor: "",
          limit: pageSize.value,
          pageSize: pageSize.value
        });
        if (url2.value.startsWith("/projects/api/v3/")) {
          requestParams.updatedAfter = lastUpdated.value.format();
        } else {
          requestParams.updatedAfterDate = lastUpdated.value.format("YYYYMMDDHHmmss");
        }
        cancel.value = () => reject(new axios.Cancel());
        axiosInstance.get(url2.value, {
          params: requestParams,
          headers: {
            "Triggered-By": triggeredBy,
            "Sent-By": "composable",
            Accept: "application/json"
          }
        }).then(resolve, reject);
      });
      error.value = void 0;
      const responseMeta = (_a = response.value.data) == null ? void 0 : _a.meta;
      const hasCursorPagination = typeof (responseMeta == null ? void 0 : responseMeta.limit) === "number";
      if (hasCursorPagination && responseMeta.nextCursor != null || pagination(response.value).pages > 1) {
        refresh();
        return;
      }
      let newLoadedCount = loadedCount.value;
      const loadedItemsSet = new Set();
      meta.value = responseToMeta2.value(response.value);
      const loadedItems = responseToItems2.value(response.value);
      loadedItems.forEach((item) => {
        const oldItem = itemsMap.value.get(item.id);
        if (oldItem && (typeof order2.value !== "function" || order2.value(item, oldItem) !== 0)) {
          newLoadedCount -= 1;
        }
        itemsMap.value.set(item.id, item);
        loadedItemsSet.add(item.id);
      });
      updatedItemIds.value.forEach((id) => {
        if (itemsMap.value.has(id) && !loadedItemsSet.has(id)) {
          itemsMap.value.delete(id);
          newLoadedCount -= 1;
        }
      });
      updatedItemIds.value.clear();
      triggerRef(itemsMap);
      triggerRef(updatedItemIds);
      if (loadedCount.value < totalCount.value) {
        loadedCount.value = Math.max(newLoadedCount, 0);
        totalCount.value = Math.max(totalCount.value, itemsMap.value.size);
      } else {
        loadedCount.value = itemsMap.value.size;
        totalCount.value = itemsMap.value.size;
      }
      lastUpdated.value = getLastUpdated(response.value);
      backOff.reset();
    } catch (axiosError) {
      if (axios.isCancel(axiosError))
        return;
      if (!axiosError.config || axiosError.config.cache !== "only-if-cached") {
        console.error("Error in useListLoader:", axiosError);
      }
      response.value = void 0;
      error.value = axiosError;
      backOff.start();
    } finally {
      cancel.value = void 0;
    }
  }
  async function loadMore() {
    var _a, _b, _c;
    if (count.value < 0) {
      if (outdatedItems.value)
        outdatedItems.value = void 0;
      return;
    }
    if (lastUpdated.value !== void 0) {
      if (pageSize.value <= 0) {
        if (outdatedItems.value)
          outdatedItems.value = void 0;
        return;
      }
      if (loadedCount.value >= totalCount.value) {
        if (outdatedItems.value)
          outdatedItems.value = void 0;
        return;
      }
      if (loadedCount.value >= count.value) {
        if (outdatedItems.value)
          outdatedItems.value = void 0;
        if (cursor.value !== void 0) {
          return;
        }
        if (bufferSize.value <= 0) {
          return;
        }
        if (loadedCount.value > Math.floor((count.value + bufferSize.value - 1) / pageSize.value) * pageSize.value) {
          return;
        }
      }
    }
    try {
      response.value = await new Promise((resolve, reject) => {
        const requestParams = __spreadProps(__spreadValues({}, params.value), {
          limit: pageSize.value,
          pageSize: pageSize.value
        });
        if (lastUpdated.value === void 0) {
          requestParams.cursor = "";
        } else if (cursor.value !== void 0) {
          requestParams.cursor = cursor.value;
        } else if (loadedCount.value >= pageSize.value) {
          requestParams.page = (loadedCount.value / pageSize.value | 0) + 1;
        }
        cancel.value = () => reject(new axios.Cancel());
        axiosInstance.get(url2.value, {
          params: requestParams,
          headers: {
            "Triggered-By": triggeredBy,
            "Sent-By": "composable",
            Accept: "application/json"
          },
          cache: shouldUseCache.value ? "only-if-cached" : void 0,
          mode: shouldUseCache.value ? "same-origin" : void 0
        }).then(resolve, reject);
      });
      error.value = void 0;
      const responseMeta = (_a = response.value.data) == null ? void 0 : _a.meta;
      const hasCursorPagination = typeof (responseMeta == null ? void 0 : responseMeta.limit) === "number";
      meta.value = responseToMeta2.value(response.value);
      const loadedItems = responseToItems2.value(response.value);
      loadedItems.forEach((item) => itemsMap.value.set(item.id, item));
      triggerRef(itemsMap);
      if (hasCursorPagination) {
        cursor.value = (_b = responseMeta.nextCursor) != null ? _b : "";
        if (responseMeta.limit > 0 && responseMeta.nextCursor == null) {
          loadedCount.value = itemsMap.value.size;
          totalCount.value = itemsMap.value.size;
        } else {
          loadedCount.value = Math.min(itemsMap.value.size, loadedCount.value + loadedItems.length);
          totalCount.value = typeof ((_c = responseMeta.page) == null ? void 0 : _c.count) === "number" ? Number(responseMeta.page.count) : Infinity;
        }
      } else {
        const pageMeta = pagination(response.value);
        loadedCount.value = pageMeta.page * pageMeta.pageSize;
        totalCount.value = pageMeta.records;
      }
      if (lastUpdated.value === void 0) {
        lastUpdated.value = getLastUpdated(response.value);
      }
      backOff.reset();
    } catch (axiosError) {
      if (axios.isCancel(axiosError))
        return;
      if (!axiosError.config || axiosError.config.cache !== "only-if-cached") {
        console.error("Error in useListLoader:", axiosError);
      }
      response.value = void 0;
      error.value = axiosError;
      backOff.start();
    } finally {
      cancel.value = void 0;
    }
  }
  function load() {
    if (cancel.value)
      return;
    if (backOff.active.value)
      return;
    if (typeof url2.value !== "string")
      return;
    if (updatedItemIds.value.size > 0)
      loadUpdates();
    else
      loadMore();
  }
  function itemInSync(itemToCheck) {
    return Boolean(itemToCheck) && itemsMap.value.get(itemToCheck.id) === itemToCheck && !updatedItemIds.value.has(itemToCheck.id);
  }
  function update(apply, promise) {
    const optimisticUpdate = { apply, promise };
    promise.then(() => {
      if (needsRefresh.value) {
        optimisticUpdate.promise = void 0;
      } else {
        optimisticUpdates.value.delete(optimisticUpdate);
        triggerRef(optimisticUpdates);
      }
    }, () => {
      optimisticUpdates.value.delete(optimisticUpdate);
      triggerRef(optimisticUpdates);
    });
    optimisticUpdates.value.add(optimisticUpdate);
    triggerRef(optimisticUpdates);
  }
  watch(needsRefresh, () => {
    if (!needsRefresh.value) {
      optimisticUpdates.value.forEach((optimisticUpdate) => {
        if (!optimisticUpdate.promise) {
          optimisticUpdates.value.delete(optimisticUpdate);
          triggerRef(optimisticUpdates);
        }
      });
    }
  });
  watch(url2, reset);
  watch(params, reset, { deep: true });
  watch(responseToItems2, reset);
  watch(responseToMeta2, reset);
  watch(order2, reset);
  watch(cancel, load);
  watch(backOff.active, load);
  watch(updatedItemIds, load);
  watch(pageSize, load);
  watch(count, load);
  watch(cursor, load);
  watch(loadedCount, load);
  watch(totalCount, load);
  watch(shouldUseCache, () => {
    if (!shouldUseCache.value) {
      refresh();
      triggeredBy = "user";
    }
  });
  onUnmounted(reset);
  load();
  return {
    state: {
      items,
      totalCount: computed(() => {
        if (typeof totalCount.value !== "number") {
          return totalCount.value;
        }
        if (loadedCount.value >= totalCount.value) {
          return allItems.value.length;
        }
        return Math.max(totalCount.value, allItems.value.length);
      }),
      inSync,
      itemInSync,
      loading,
      meta,
      response,
      error
    },
    refresh,
    update
  };
}
function responseToItems$n(response) {
  const { columns } = response.data;
  columns.forEach((column) => {
    column.id = Number(column.id);
  });
  return columns;
}
function useBoardColumnsLoader({
  projectId: _projectId,
  params,
  count,
  pageSize = 50
}) {
  const projectId = shallowRef(_projectId);
  const url2 = computed(() => v1Url(`projects/${projectId.value}/boards/columns`));
  const { state } = useListLoader({
    url: url2,
    params,
    count,
    responseToItems: responseToItems$n,
    pageSize
  });
  return state;
}
function useItemLoader({
  url: _url,
  params: _params,
  responseToItem: _responseToItem = () => void 0,
  responseToMeta: _responseToMeta = () => null
}) {
  assertHasScope();
  const axiosInstance = useAxios();
  const { handlingEventFromSocket } = useRealTimeUpdates();
  const url2 = shallowRef(_url);
  const params = shallowRef(_params);
  const responseToItem2 = shallowRef(_responseToItem);
  const responseToMeta2 = shallowRef(_responseToMeta);
  const backOff = useBackOff();
  const loadedItem = shallowRef(void 0);
  const needsRefresh = shallowRef(true);
  const response = shallowRef(void 0);
  const error = shallowRef(void 0);
  const meta = shallowRef(void 0);
  const cancel = shallowRef(void 0);
  const loading = computed(() => Boolean(cancel.value));
  const optimisticUpdates = shallowRef(new Set());
  const item = computed(() => {
    let processedItem = loadedItem.value;
    optimisticUpdates.value.forEach((optimisticUpdate) => {
      processedItem = optimisticUpdate.apply(processedItem);
    });
    return processedItem;
  });
  const inSync = computed(() => !needsRefresh.value && optimisticUpdates.value.size === 0);
  const shouldUseCache = computed(() => response.value === void 0 && error.value === void 0);
  let triggeredBy = "user";
  function refresh() {
    needsRefresh.value = true;
    if (cancel.value)
      cancel.value();
    backOff.reset();
    optimisticUpdates.value.forEach((optimisticUpdate) => {
      if (optimisticUpdate.updated) {
        clearTimeout(optimisticUpdate.timeout);
        optimisticUpdate.refreshing = true;
      }
    });
    triggeredBy = handlingEventFromSocket.value ? "event/ws" : "event/local";
  }
  function reset() {
    loadedItem.value = void 0;
    response.value = void 0;
    error.value = void 0;
    meta.value = void 0;
    refresh();
    triggeredBy = "user";
  }
  function update(apply, promise) {
    const optimisticUpdate = { apply, promise };
    promise.then(() => {
      if (needsRefresh.value) {
        optimisticUpdate.promise = void 0;
      } else {
        optimisticUpdates.value.delete(optimisticUpdate);
        triggerRef(optimisticUpdates);
      }
    }, () => {
      optimisticUpdates.value.delete(optimisticUpdate);
      triggerRef(optimisticUpdates);
    });
    optimisticUpdates.value.add(optimisticUpdate);
    triggerRef(optimisticUpdates);
  }
  function prune() {
    if (!needsRefresh.value) {
      optimisticUpdates.value.forEach((optimisticUpdate) => {
        if (!optimisticUpdate.promise) {
          optimisticUpdates.value.delete(optimisticUpdate);
          triggerRef(optimisticUpdates);
        }
      });
    }
  }
  async function load() {
    if (cancel.value)
      return;
    if (backOff.active.value)
      return;
    if (!needsRefresh.value)
      return;
    if (typeof url2.value !== "string") {
      needsRefresh.value = false;
      return;
    }
    try {
      response.value = await new Promise((resolve, reject) => {
        cancel.value = () => reject(new axios.Cancel());
        axiosInstance.get(url2.value, {
          params: params.value,
          headers: {
            "Triggered-By": triggeredBy,
            "Sent-By": "composable",
            Accept: "application/json"
          },
          cache: shouldUseCache.value ? "only-if-cached" : void 0,
          mode: shouldUseCache.value ? "same-origin" : void 0
        }).then(resolve, reject);
      });
      error.value = void 0;
      loadedItem.value = responseToItem2.value(response.value);
      meta.value = responseToMeta2.value(response.value);
      needsRefresh.value = false;
      backOff.reset();
    } catch (axiosError) {
      if (axios.isCancel(axiosError))
        return;
      if (!axiosError.config || axiosError.config.cache !== "only-if-cached") {
        console.error("Error in useItemLoader:", axiosError);
      }
      response.value = void 0;
      error.value = axiosError;
      if (error.value.response && error.value.response.status === 404) {
        backOff.reset();
        loadedItem.value = null;
        needsRefresh.value = false;
      } else {
        backOff.start();
      }
    } finally {
      cancel.value = void 0;
    }
  }
  watch(url2, reset);
  watch(params, reset, { deep: true });
  watch(responseToItem2, reset);
  watch(responseToMeta2, reset);
  watch(cancel, load);
  watch(backOff.active, load);
  watch(needsRefresh, load);
  watch(needsRefresh, prune);
  watch(shouldUseCache, () => {
    if (!shouldUseCache.value) {
      refresh();
      triggeredBy = "user";
    }
  });
  onUnmounted(reset);
  load();
  return {
    state: {
      item,
      inSync,
      loading,
      meta,
      response,
      error
    },
    refresh,
    update
  };
}
function responseToItem$b({ data: { branding } }) {
  return branding;
}
function useBrandingLoader({ params } = {}) {
  const { state } = useItemLoader({
    url: v1Url("v/1/settings/branding"),
    params,
    responseToItem: responseToItem$b
  });
  return state;
}
function responseToItem$a(response) {
  return response.data.categories.map((category) => ({
    id: Number(category.id),
    type: category.type,
    parentId: Number(category["parent-id"]) || 0,
    name: category.name,
    color: category.color,
    count: Number(category.count)
  }));
}
function responseToMeta$6(type, response) {
  return {
    totalItems: Number(response.headers[`x-total-${type.value}s`]),
    totalCategorizedItems: Number(response.headers[`x-total-${type.value}s-categorized`]),
    totalUncategorizedItems: Number(response.headers[`x-total-${type.value}s-uncategorized`])
  };
}
function useCategoriesLoader({
  projectId: _projectId,
  type: _type,
  params,
  count: _count = 0
}) {
  const projectId = shallowRef(_projectId);
  const type = shallowRef(_type);
  const count = shallowRef(_count);
  const url2 = computed(() => {
    switch (type.value) {
      case "project":
        return v1Url(`projectcategories`);
      case "file":
      case "notebook":
      case "message":
      case "link":
        return v1Url(`projects/${projectId.value}/${type.value}categories`);
      default:
        return void 0;
    }
  });
  const {
    state: { item, inSync, loading, meta, response, error },
    refresh
  } = useItemLoader({
    url: url2,
    params,
    responseToItem: responseToItem$a,
    responseToMeta: responseToMeta$6.bind(null, type)
  });
  useRealTimeUpdates((event) => {
    if (event.type === "category") {
      if (event.categoryType === type.value && (event.categoryType === "project" || event.projectId === projectId.value)) {
        refresh();
      }
    } else if (event.type === type.value && (event.type === "project" || event.projectId === projectId.value)) {
      if (event.categoryChanged || event.action === "added" || event.action === "archived" || event.action === "deleted" || event.action === "new" || event.action === "reopened" || event.action === "undelete") {
        refresh();
      }
    }
  });
  return {
    items: computed(() => {
      if (item.value && count.value > 0) {
        if (item.value.length <= count.value) {
          return item.value;
        }
        return item.value.slice(0, count.value);
      }
      return [];
    }),
    totalCount: computed(() => item.value && item.value.length),
    itemInSync: () => inSync.value,
    inSync,
    loading,
    meta,
    response,
    error
  };
}
function responseToItems$m(response) {
  return response.data.companies;
}
function useCompaniesLoader({
  projectsCompanies: _projectsCompanies = false,
  params,
  count,
  pageSize
}) {
  const projectsCompanies = shallowRef(_projectsCompanies);
  const url2 = computed(() => v3Url(projectsCompanies.value ? "projects/companies" : "companies"));
  const { state } = useListLoader({
    url: url2,
    params,
    count,
    pageSize,
    responseToItems: responseToItems$m
  });
  return state;
}
const keyMapping = new Map([
  ["companyid", "companyId"],
  ["companyname", "companyName"],
  ["datesignedup", "dateSignedUp"],
  ["priceplanAllowSSL", "pricePlanAllowSSL"],
  ["priceplanCanTurnOffTWBranding", "pricePlanCanTurnOffTWBranding"],
  ["priceplanData", "pricePlanData"],
  ["priceplanMaxUsers", "pricePlanMaxUsers"],
  ["priceplanType", "pricePlanType"]
]);
function responseToItem$9({ data: { account } }) {
  const normalizedAccount = {};
  Object.keys(account).forEach((key) => {
    const normalizedKey = keyMapping.get(key) || key.replace(/-./g, (match2) => match2.slice(1).toUpperCase());
    normalizedAccount[normalizedKey] = account[key];
  });
  normalizedAccount.accountHolderId = Number(normalizedAccount.accountHolderId);
  normalizedAccount.companyId = Number(normalizedAccount.companyId);
  normalizedAccount.id = Number(normalizedAccount.id);
  normalizedAccount.isPaid = normalizedAccount.isPaid === "1";
  normalizedAccount.memberOfOwnerCompany = normalizedAccount.memberOfOwnerCompany === "YES";
  normalizedAccount.paidForUsers = Number(normalizedAccount.paidForUsers);
  normalizedAccount.pricePlanId = Number(normalizedAccount.pricePlanId);
  normalizedAccount.pricePlanMaxUsers = Number(normalizedAccount.pricePlanMaxUsers);
  normalizedAccount.shardNo = Number(normalizedAccount.shardNo);
  normalizedAccount.tasklistTemplateProjectId = Number(normalizedAccount.tasklistTemplateProjectId);
  normalizedAccount.installationTeamsCount = Number(normalizedAccount.installationTeamsCount);
  normalizedAccount.createdAt = moment(normalizedAccount.createdAt);
  normalizedAccount.dateSignedUp = moment(normalizedAccount.dateSignedUp);
  normalizedAccount.inGracePeriod = Boolean(normalizedAccount.inGracePeriod);
  const { pricePlanData, currency } = normalizedAccount;
  if (pricePlanData) {
    const normalizedPricePlanData = {};
    Object.keys(pricePlanData).forEach((key) => {
      normalizedPricePlanData[key] = pricePlanData[key];
    });
    normalizedPricePlanData.id = Number(normalizedPricePlanData.id);
    normalizedPricePlanData.maxFinancialBudgets = Number(normalizedPricePlanData.maxFinancialBudgets);
    normalizedPricePlanData.maxUsers = Number(normalizedPricePlanData.maxUsers);
    normalizedAccount.pricePlanData = normalizedPricePlanData;
  }
  if (currency) {
    const normalizedCurrency = {};
    normalizedCurrency.id = Number(currency.id);
    normalizedCurrency.decimalPoints = Number(currency.decimalPoints);
    normalizedCurrency.code = currency.code;
    normalizedCurrency.symbol = currency.symbol;
    normalizedCurrency.name = currency.name;
    normalizedAccount.currency = normalizedCurrency;
  }
  return normalizedAccount;
}
function useCurrentAccountLoader({ params } = {}) {
  const { state, refresh } = useItemLoader({
    url: v1Url("account"),
    params,
    responseToItem: responseToItem$9
  });
  useRealTimeUpdates((event) => {
    if (event.type === "account") {
      refresh();
    }
  });
  return state;
}
function responseToItem$8({ data: { person: user } }) {
  const normalizedUser = {};
  Object.keys(user).forEach((key) => {
    const normalizedKey = key.replace(/-./g, (match2) => match2.slice(1).toUpperCase());
    normalizedUser[normalizedKey] = user[key];
  });
  const { permissions } = user;
  if (permissions) {
    const normalizedPermissions = {};
    Object.keys(permissions).forEach((key) => {
      const normalizedKey = key.replace(/-./g, (match2) => match2.slice(1).toUpperCase());
      normalizedPermissions[normalizedKey] = permissions[key];
    });
    normalizedUser.permissions = normalizedPermissions;
  }
  normalizedUser.id = Number(normalizedUser.id);
  normalizedUser.companyId = Number(normalizedUser.companyId);
  normalizedUser.loginCount = Number(normalizedUser.loginCount);
  normalizedUser.numActiveProjects = Number(normalizedUser.numActiveProjects);
  normalizedUser.featureUpdatesCount = Number(normalizedUser.featureUpdatesCount);
  normalizedUser.inOwnerCompany = normalizedUser.inOwnerCompany === "1";
  normalizedUser.userInvited = normalizedUser.userInvited === "1";
  normalizedUser.lastChangedOn = moment(normalizedUser.lastChangedOn);
  normalizedUser.lastLogin = moment(normalizedUser.lastLogin);
  return normalizedUser;
}
function useCurrentUserLoader({ params } = {}) {
  const { state, refresh } = useItemLoader({
    url: v1Url("me"),
    params,
    responseToItem: responseToItem$8
  });
  useRealTimeUpdates((event) => {
    if (event.type === "person" && state.item.value && state.item.value.id === event.userId) {
      refresh();
    }
  });
  return state;
}
function responseToItems$l(response) {
  return response.data.customfields;
}
function useCustomFieldsLoader({ params, count, pageSize = 50 }) {
  const { state, refresh } = useListLoader({
    url: v3Url("customfields"),
    params,
    count,
    responseToItems: responseToItems$l,
    pageSize
  });
  useRealTimeUpdates((event) => {
    if (event.type === "customfield") {
      refresh(event.customfieldId);
    }
  });
  return state;
}
function responseToItems$k({ data: { dataViews } }) {
  for (let i2 = 0; i2 < dataViews.length; i2 += 1) {
    const dataView = dataViews[i2];
    dataView.id = Number(dataView.id);
    dataView.userId = Number(dataView.userId);
    dataView.projectId = Number(dataView.projectId);
  }
  return dataViews;
}
function useDataViewsLoader({ count, params, pageSize = 50 }) {
  const { state } = useListLoader({
    url: v1Url("me/dataviews"),
    params,
    count,
    pageSize,
    responseToItems: responseToItems$k
  });
  return state;
}
function responseToItems$j(response) {
  const featuresList = response.data.features || [];
  featuresList.forEach((feature) => {
    feature.id = feature.key;
  });
  return featuresList;
}
function useFeaturesLoader({ params, count, pageSize = 50 }) {
  const { state } = useListLoader({
    url: v3Url("features"),
    params,
    count,
    responseToItems: responseToItems$j,
    pageSize
  });
  return state;
}
function responseToItems$i({ data: { files, included: { users } = {} } }) {
  for (let i2 = 0; i2 < files.length; i2 += 1) {
    const file = files[i2];
    file.uploadedBy = users && users[file.uploadedBy] || {
      id: file.uploadedBy
    };
    if (file.changeFollowers.userIds) {
      file.changeFollowers.users = file.changeFollowers.userIds.map((id) => users && users[id] || { id });
    }
    if (file.commentFollowers.userIds) {
      file.commentFollowers.users = file.commentFollowers.userIds.map((id) => users && users[id] || { id });
    }
  }
  return files;
}
function useFilesLoader({ params, count, pageSize }) {
  const { state, refresh, update } = useListLoader({
    url: v3Url("files"),
    params,
    count,
    pageSize,
    responseToItems: responseToItems$i
  });
  const taskId = computed(() => {
    var _a;
    return (_a = unref(params)) == null ? void 0 : _a.taskId;
  });
  useRealTimeUpdates((event) => {
    if (event.type === "task") {
      if (event.detail === "task-fileattached" && taskId.value === event.taskId) {
        refresh();
      }
    } else if (event.type === "file") {
      refresh(event.fileId);
    } else if (event.type === "comment") {
      if (event.fileId > 0 && (event.action === "new" || event.action === "deleted")) {
        refresh(event.fileId);
      }
    }
  });
  useOptimisticUpdates((event) => {
    if (event.type === "file") {
      update((files) => {
        if (event.action === "update") {
          return files.map((file) => file.id === event.file.id ? __spreadValues(__spreadValues({}, file), event.file) : file);
        }
        if (event.action === "delete") {
          return files.filter((file) => file.id !== event.file.id);
        }
        return files;
      }, event.promise);
    }
  });
  return state;
}
function responseToItems$h({ data: data2 }) {
  const { milestones } = data2;
  const {
    projectCategories = {},
    companies = {},
    projects = {},
    tags = {},
    tasklists = {},
    tasks = {},
    teams = {},
    users = {},
    tasklistTaskStats = {}
  } = data2.included;
  milestones.forEach((milestone) => {
    if (milestone.project && projects[milestone.project.id]) {
      milestone.project = projects[milestone.project.id];
    }
    if (milestone.tags && milestone.tags.length && tags) {
      const tgs = [];
      milestone.tags.forEach((tg) => {
        tgs.push(tags[tg.id]);
      });
      milestone.tags = tgs;
    }
    if (milestone.tasklists && milestone.tasklists.length && tasklists) {
      const tskls = [];
      milestone.tasklists.forEach((tl) => {
        tasklists[tl.id].stats = tasklistTaskStats[tl.id] || {};
        tskls.push(tasklists[tl.id]);
      });
      milestone.tasklists = tskls;
    }
    if (milestone.tasks && milestone.tasks.length && tasks) {
      const tsks = [];
      milestone.tasks.forEach((tsk) => {
        tsks.push(tasks[tsk.id]);
      });
      milestone.tasks = tsks;
    }
    if (milestone.project.categoryId && projectCategories) {
      milestone.category = projectCategories[milestone.project.categoryId];
    }
    if (milestone.project.companyId && companies) {
      milestone.company = companies[milestone.project.companyId];
    }
    if (milestone.creatorUserId && users[milestone.creatorUserId]) {
      milestone.createdBy = users[milestone.creatorUserId];
    }
    if (milestone.updatedBy && users[milestone.updatedBy]) {
      milestone.updatedBy = users[milestone.updatedBy];
    }
    if (milestone.completedBy && users[milestone.completedBy]) {
      milestone.completedBy = users[milestone.completedBy];
    }
    if (milestone.responsibleParties && milestone.responsibleParties.length) {
      const result = [];
      milestone.responsibleParties.forEach((item) => {
        switch (item.type) {
          case "users":
            if (users && users[item.id]) {
              result.push(__spreadProps(__spreadValues({}, users[item.id]), {
                assigneeType: "users"
              }));
            }
            break;
          case "companies":
            if (companies && companies[item.id]) {
              result.push(__spreadProps(__spreadValues({}, companies[item.id]), {
                assigneeType: "companies"
              }));
            }
            break;
          case "teams":
            if (teams && teams[item.id]) {
              result.push(teams[item.id]);
              result.push(__spreadProps(__spreadValues({}, teams[item.id]), {
                assigneeType: "teams"
              }));
            }
            break;
        }
      });
      milestone.responsibleParties = result;
    }
  });
  return milestones;
}
function useMilestonesLoader({ params, count, pageSize } = {}) {
  const { state, refresh, update } = useListLoader({
    url: v3Url("milestones"),
    params,
    count,
    pageSize,
    responseToItems: responseToItems$h
  });
  useOptimisticUpdates((event) => {
    if (event.type === "milestone" && event.action === "update") {
      update((milestones) => milestones.map((milestone) => milestone.id === event.milestone.id ? __spreadValues(__spreadValues({}, milestone), event.milestone) : milestone), event.promise);
    }
  });
  useRealTimeUpdates((event) => {
    if (event.type === "milestone") {
      refresh(event.milestoneId);
    } else if (event.type === "task") {
      if (event.action === "completed" || event.action === "reopened" || event.action === "deleted" || event.action === "new") {
        refresh();
      }
    }
  });
  return state;
}
function responseToItems$g(response) {
  const { companies = {}, teams = {} } = response.data.included;
  const usersList = response.data.people || [];
  usersList.forEach((user) => {
    var _a;
    if (user.company && companies[user.company.id]) {
      user.company = companies[user.company.id];
    }
    (_a = user.teams) == null ? void 0 : _a.forEach((team, index2) => {
      if (teams[team.id]) {
        user.teams[index2] = teams[team.id];
      }
    });
  });
  return usersList;
}
function usePeopleLoader({ params, count, pageSize = 50 }) {
  const { state } = useListLoader({
    url: v3Url("people"),
    params,
    count,
    responseToItems: responseToItems$g,
    pageSize
  });
  return state;
}
function responseToItem$7({ data: { predecessors } }) {
  for (let i2 = 0; i2 < predecessors.length; i2 += 1) {
    const predecessor = predecessors[i2];
    predecessor.id = Number(predecessor.id);
    predecessor.projectId = Number(predecessor.projectId);
  }
  return predecessors;
}
function usePredecessorsLoader({
  taskId: _taskId,
  params,
  count: _count
}) {
  const taskId = shallowRef(_taskId);
  const count = shallowRef(_count);
  const url2 = computed(() => Number.isInteger(taskId.value) && v1Url(`tasks/${taskId.value}/predecessors`));
  const {
    state: { item, inSync, loading, meta, response, error }
  } = useItemLoader({ url: url2, params, responseToItem: responseToItem$7 });
  return {
    items: computed(() => {
      if (item.value && count.value > 0) {
        if (item.value.length <= count.value) {
          return item.value;
        }
        return item.value.slice(0, count.value);
      }
      return [];
    }),
    totalCount: computed(() => item.value && item.value.length),
    itemInSync: () => inSync.value,
    inSync,
    loading,
    meta,
    response,
    error
  };
}
function responseToMeta$5(_a) {
  var {
    data: _b
  } = _a, {
    projectProfitabilities: _c
  } = _b, _d = _c, { projects } = _d, profitability = __objRest(_d, ["projects"]);
  return { profitability };
}
function responseToItems$f({
  data: {
    projectProfitabilities: { projects: profitabilityItems = [] },
    included: {
      projects = {},
      users = {},
      companies = {},
      projectBudgets = {}
    } = {}
  }
}) {
  return profitabilityItems.map((_a) => {
    var _b = _a, { project: { id } } = _b, profitability = __objRest(_b, ["project"]);
    const project = projects[id] || { id };
    project.profitability = profitability;
    if (project.company && companies[project.company.id]) {
      project.company = companies[project.company.id];
    }
    const budgetId = project.timeBudgetId || project.financialBudgetId;
    project.budget = budgetId && projectBudgets[budgetId] || null;
    project.owner = project.ownerId && users[project.ownerId] || null;
    return project;
  });
}
function useProfitabilityProjectsLoader({
  params,
  count,
  pageSize
} = {}) {
  const { state, refresh } = useListLoader({
    url: v3Url("profitability/projects"),
    params,
    count,
    pageSize,
    responseToItems: responseToItems$f,
    responseToMeta: responseToMeta$5
  });
  useRealTimeUpdates((event) => {
    if (event.type === "budget" || event.type === "time" || event.type === "project" && event.action === "rate-set") {
      refresh(event.projectId);
    }
    if (event.type === "installation" && event.action === "rate-set") {
      refresh();
    }
  });
  return state;
}
function responseToMeta$4(_e) {
  var {
    data: _f
  } = _e, {
    userProfitabilities: _g
  } = _f, _h = _g, { users } = _h, profitability = __objRest(_h, ["users"]);
  return { profitability };
}
function responseToItems$e({
  data: {
    userProfitabilities: { users: profitabilityItems = [] },
    included: { users = {} } = {}
  }
}) {
  return profitabilityItems.map((_a) => {
    var _b = _a, { user: { id } } = _b, profitability = __objRest(_b, ["user"]);
    const user = users[id] || { id };
    user.profitability = profitability;
    return user;
  });
}
function useProfitabilityUsersLoader({ count, params, pageSize } = {}) {
  const { state, refresh } = useListLoader({
    url: v3Url("profitability/users"),
    params,
    count,
    pageSize,
    responseToItems: responseToItems$e,
    responseToMeta: responseToMeta$4
  });
  useRealTimeUpdates((event) => {
    if (event.type === "project" && event.action === "rate-set") {
      refresh(event.userId);
    }
    if (event.type === "time" || event.type === "installation" && event.action === "rate-set") {
      refresh();
    }
  });
  return state;
}
const responseToItem$6 = (response) => {
  return response.data.budgetCounts;
};
function useProjectBudgetCountsLoader() {
  const { state, refresh } = useItemLoader({
    url: v3Url("projects/budgets/counts"),
    responseToItem: responseToItem$6
  });
  useRealTimeUpdates((event) => {
    if (event.type === "budget") {
      refresh();
    }
  });
  return state;
}
function responseToItems$d(response) {
  const { users = {} } = response.data.included;
  const budgetExpenses = response.data.budgetExpenses || [];
  budgetExpenses.forEach((budgetExpense) => {
    budgetExpense.cost = Number(budgetExpense.cost);
    if (users[budgetExpense.createdBy.id]) {
      budgetExpense.createdBy = users[budgetExpense.createdBy.id];
    }
    if (users[budgetExpense.updatedBy.id]) {
      budgetExpense.updatedBy = users[budgetExpense.updatedBy.id];
    }
  });
  return budgetExpenses;
}
function responseToMeta$3(response) {
  const { totalCost } = response.data.meta;
  return { totalCost };
}
function useProjectBudgetExpensesLoader({
  params,
  count,
  pageSize = 50,
  projectBudgetId: _projectBudgetId
}) {
  const projectBudgetId = shallowRef(_projectBudgetId);
  const url2 = computed(() => v3Url(`projects/budgets/${projectBudgetId.value}/expenses`));
  const { state, update, refresh } = useListLoader({
    url: url2,
    params,
    count,
    responseToItems: responseToItems$d,
    responseToMeta: responseToMeta$3,
    pageSize
  });
  useOptimisticUpdates((event) => {
    if (event.type !== "budgetExpense") {
      return;
    }
    update((budgetExpenses) => {
      if (event.action === "create") {
        return budgetExpenses.concat(event.budgetExpense);
      }
      if (event.action === "update") {
        return budgetExpenses.map((budgetExpense) => budgetExpense.id === event.budgetExpense.id ? __spreadValues(__spreadValues({}, budgetExpense), event.budgetExpense) : budgetExpense);
      }
      if (event.action === "delete") {
        return budgetExpenses.filter((budgetExpense) => budgetExpense.id !== event.budgetExpense.id);
      }
      return budgetExpenses;
    }, event.promise);
  });
  useRealTimeUpdates((event) => {
    if (event.type === "budgetExpense") {
      refresh(event.budgetExpenseId);
    }
  });
  return state;
}
function responseToItems$c(response) {
  const {
    notifications = {},
    companies = {},
    projects = {},
    teams = {},
    users = {}
  } = response.data.included;
  const projectBudgets = response.data.budgets || [];
  projectBudgets.forEach((budget) => {
    budget.repeatUnit = budget.repeatUnit.toLowerCase();
    budget.status = budget.status.toLowerCase();
    budget.timelogType = budget.timelogType.toLowerCase();
    budget.type = budget.type.toLowerCase();
    if (projects[budget.projectId]) {
      budget.project = projects[budget.projectId];
    }
    budget.notifications.forEach((_notification, index2) => {
      if (notifications[_notification.id]) {
        const notification = notifications[_notification.id];
        notification.notificationMedium = notification.notificationMedium.toLowerCase();
        notification.users = notification.users.map((user) => {
          var _a;
          return (_a = users[user.id]) != null ? _a : user;
        });
        notification.teams = notification.teams.map((_team) => {
          var _a;
          const team = (_a = teams[_team.id]) != null ? _a : _team;
          team.teamId = team.id;
          return team;
        });
        notification.companies = notification.companies.map((_company) => {
          var _a;
          const company = (_a = companies[_company.id]) != null ? _a : _company;
          company.companyId = company.id;
          return company;
        });
        budget.notifications[index2] = notification;
      }
    });
  });
  return projectBudgets;
}
function useProjectBudgetsLoader({ params, count, pageSize = 50 }) {
  const { state, update, refresh } = useListLoader({
    url: v3Url("projects/budgets"),
    params,
    count,
    responseToItems: responseToItems$c,
    pageSize
  });
  useOptimisticUpdates((event) => {
    if (event.type !== "budget") {
      return;
    }
    update((budgets) => {
      if (event.action === "create") {
        return budgets.concat(event.budget);
      }
      if (event.action === "update") {
        return budgets.map((budget) => budget.id === event.budget.id ? __spreadValues(__spreadValues({}, budget), event.budget) : budget);
      }
      if (event.action === "delete") {
        return budgets.filter((budget) => budget.id !== event.budget.id);
      }
      return budgets;
    }, event.promise);
  });
  useRealTimeUpdates((event) => {
    if (event.type === "budget") {
      refresh(event.budgetId);
      return;
    }
    if (event.type === "budgetExpense") {
      refresh(event.projectBudgetId);
      return;
    }
    if (event.type === "time" || event.type === "project" && event.action === "rate-set") {
      const budget = state.items.value.find((_budget) => event.projectId === _budget.projectId);
      if (budget)
        refresh(budget.id);
      return;
    }
    if (event.type === "installation" && event.action === "rate-set") {
      refresh();
    }
  });
  return state;
}
function responseToItems$b(response) {
  var _a, _b;
  const items = (_b = (_a = response.data.budgetUsages) == null ? void 0 : _a.map(({ budgetSummary, usageTimeline = [] }) => ({
    id: Number(budgetSummary.id),
    projectId: Number(budgetSummary.projectId),
    timeline: usageTimeline
  }))) != null ? _b : [];
  return items;
}
function useProjectBudgetUsagesLoader({ params, count, pageSize = 50 }) {
  const { state, refresh } = useListLoader({
    url: v3Url("projects/budgets/usages"),
    params,
    count,
    responseToItems: responseToItems$b,
    pageSize
  });
  useRealTimeUpdates((event) => {
    if (event.type === "budget") {
      refresh(event.budgetId);
      return;
    }
    if (event.type === "tasklistBudget" || event.type === "budgetExpense") {
      refresh(event.projectBudgetId);
      return;
    }
    if (event.type === "time" || event.type === "project" && event.action === "rate-set") {
      const budget = state.items.value.find(({ projectId }) => projectId === event.projectId);
      if (budget)
        refresh(budget.id);
      return;
    }
    if (event.type === "installation" && event.action === "rate-set") {
      refresh();
    }
  });
  return state;
}
function responseToItem$5({ data: data2 }) {
  const project = data2.project;
  const meta = data2.meta || {};
  const { permissions = {} } = meta;
  if (project.id && permissions[project.id]) {
    project.permissions = permissions[project.id];
  }
  return project;
}
function useProjectLoader({ projectId: _projectId, params }) {
  const projectId = shallowRef(_projectId);
  const url2 = computed(() => Number.isInteger(projectId.value) && v3Url(`projects/${projectId.value}`));
  const { state } = useItemLoader({
    url: url2,
    params,
    responseToItem: responseToItem$5
  });
  return state;
}
function responseToItem$4(response, id) {
  const projectRate = response.data.projectRate;
  return { id, projectRate };
}
function useProjectRateLoader({
  projectId,
  params
}) {
  const { state } = useItemLoader({
    url: v3Url(`rates/projects/${projectId}`),
    params,
    responseToItem: (response) => responseToItem$4(response, projectId)
  });
  return state;
}
function responseToItems$a(response) {
  const projects = {};
  const {
    activities = {},
    companies = {},
    customfieldProjects: customFieldProjects = {},
    customfields: customFields = {},
    portfolioBoards = {},
    portfolioCards = {},
    portfolioColumns = {},
    projectBudgets = {},
    projectCategories = {},
    projectTaskStats = {},
    projectUpdates = {},
    tags = {},
    users = {}
  } = response.data.included;
  const permissions = response.data.meta.permissions || {};
  const projectsList = response.data.projects || [];
  projectsList.forEach((project) => {
    var _a;
    projects[project.id] = project;
    project.startDate = project.startDate ? moment(project.startDate) : null;
    project.endDate = project.endDate ? moment(project.endDate) : null;
    project.createdAt = project.createdAt ? moment(project.createdAt) : null;
    project.updatedAt = project.updatedAt ? moment(project.updatedAt) : null;
    project.lastWorkedOn = project.lastWorkedOn ? moment(project.lastWorkedOn) : null;
    if (project.category && projectCategories[project.category.id]) {
      project.category = projectCategories[project.category.id];
    }
    if (project.company && companies[project.company.id]) {
      project.company = companies[project.company.id];
    }
    if (project.customFieldValues) {
      project.customFieldValues.forEach((customFieldValue, index2) => {
        if (customFieldProjects[customFieldValue.id]) {
          project.customFieldValues[index2] = customFieldProjects[customFieldValue.id];
        }
      });
    }
    if (project.latestActivity && activities[project.latestActivity.id]) {
      project.latestActivity = activities[project.latestActivity.id];
    }
    if (project.ownerId && users[project.ownerId]) {
      project.owner = users[project.ownerId];
    }
    if (permissions[project.id]) {
      project.permissions = permissions[project.id];
    }
    if (project.portfolioCards) {
      project.portfolioCards.forEach((portfolioCard, index2) => {
        if (portfolioCards[portfolioCard.id]) {
          project.portfolioCards[index2] = portfolioCards[portfolioCard.id];
        }
      });
    }
    if ((_a = project.tags) == null ? void 0 : _a.length) {
      project.tags.forEach((tag, index2) => {
        if (tags[tag.id]) {
          project.tags[index2] = tags[tag.id];
        }
      });
    }
    if (projectTaskStats[project.id]) {
      project.taskStats = projectTaskStats[project.id];
    }
    const budgetId = project.timeBudgetId || project.financialBudgetId;
    if (projectBudgets[budgetId]) {
      project.budget = projectBudgets[budgetId];
    }
    if (project.updateId && projectUpdates[project.updateId]) {
      project.update = projectUpdates[project.updateId];
    }
  });
  Object.values(activities).forEach((activity) => {
    activity.datetime = activity.datetime ? moment(activity.datetime) : null;
    if (activity.user && users[activity.user.id]) {
      activity.user = users[activity.user.id];
    }
  });
  Object.values(customFieldProjects).forEach((customFieldProject) => {
    if (customFieldProject.customfield) {
      customFieldProject.customField = customFieldProject.customfield;
      delete customFieldProject.customfield;
    }
    if (customFieldProject.customfieldId) {
      customFieldProject.customFieldId = customFieldProject.customfieldId;
      delete customFieldProject.customfieldId;
    }
    if (customFieldProject.customField && customFields[customFieldProject.customField.id]) {
      customFieldProject.customField = customFields[customFieldProject.customField.id];
    }
    if (customFieldProject.project && projects[customFieldProject.project.id]) {
      customFieldProject.project = projects[customFieldProject.project.id];
    }
  });
  Object.values(portfolioCards).forEach((portfolioCard) => {
    if (portfolioCard.project && projects[portfolioCard.project.id]) {
      portfolioCard.project = projects[portfolioCard.project.id];
    }
    if (portfolioCard.column && portfolioColumns[portfolioCard.column.id]) {
      portfolioCard.column = portfolioColumns[portfolioCard.column.id];
    }
    if (portfolioCard.board && portfolioBoards[portfolioCard.board.id]) {
      portfolioCard.board = portfolioBoards[portfolioCard.board.id];
    }
  });
  Object.values(projectCategories).forEach((projectCategory) => {
    if (projectCategory.parent && projectCategories[projectCategory.parent.id]) {
      projectCategory.parent = projectCategories[projectCategory.parent.id];
    }
  });
  Object.values(projectUpdates).forEach((projectUpdate) => {
    projectUpdate.createdAt = projectUpdate.createdAt ? moment(projectUpdate.createdAt) : null;
    projectUpdate.updatedAt = projectUpdate.updatedAt ? moment(projectUpdate.updatedAt) : null;
    if (users[projectUpdate.createdBy]) {
      projectUpdate.creator = users[projectUpdate.createdBy];
    }
    if (projectUpdate.project && projects[projectUpdate.project.id]) {
      projectUpdate.project = projects[projectUpdate.project.id];
    }
  });
  return projectsList;
}
function responseToMeta$2(response) {
  const { projects, user } = response.data.meta;
  return { projects, user };
}
function useProjectsLoader({ params, count, pageSize } = {}) {
  const url2 = computed(() => v3Url("projects"));
  const { state, refresh, update } = useListLoader({
    url: url2,
    params,
    count,
    pageSize,
    responseToItems: responseToItems$a,
    responseToMeta: responseToMeta$2
  });
  useOptimisticUpdates((event) => {
    if (event.type === "project") {
      if (event.action === "update") {
        update((projects) => projects.map((project) => project.id === event.project.id ? __spreadValues(__spreadValues({}, project), event.project) : project), event.promise);
      }
    }
  });
  useRealTimeUpdates((event) => {
    switch (event.type) {
      case "project":
        if (event.action === "permissions")
          ;
        else if (event.action === "starred" || event.action === "unstarred") {
          refresh();
        } else {
          refresh(event.projectId);
        }
        break;
      case "budget":
        if (params.value && typeof params.value.include === "string" && /(^|,)projectBudgets($|,)/.test(params.value.include)) {
          refresh(event.projectId);
        }
        break;
      case "time":
        if (params.value && typeof params.value.include === "string" && /(^|,)projectBudgets($|,)/.test(params.value.include)) {
          refresh();
        }
        break;
      case "task":
        if (params.value && typeof params.value.include === "string" && /(^|,)projectTaskStats($|,)/.test(params.value.include) && (event.action === "completed" || event.action === "reopened" || event.action === "deleted" || event.action === "new")) {
          refresh();
        }
        break;
    }
  });
  return state;
}
function responseToItems$9({
  data: { projectRates = [], included: { projects = {} } = {} }
}) {
  return projectRates.map((p) => ({
    id: p.project.id,
    userRate: p.userRate,
    project: projects[p.project.id]
  }));
}
function responseToMeta$1({
  data: { installationRate = null, userCost = null }
}) {
  return { installationRate, userCost };
}
function useProjectsRateLoader({
  userId,
  params,
  count,
  pageSize
}) {
  const { state } = useListLoader({
    url: computed(() => v3Url(`people/${unref(userId)}/rates`)),
    params,
    count,
    pageSize,
    responseToItems: responseToItems$9,
    responseToMeta: responseToMeta$1
  });
  return state;
}
function responseToItems$8(response) {
  return response.data.recents;
}
function useRecentsLoader({
  params,
  count,
  pageSize = 50,
  useElastic = false
}) {
  const url2 = v3Url(`${useElastic ? "recency" : "recency/summary"}`);
  const { state } = useListLoader({
    url: url2,
    params,
    count,
    responseToItems: responseToItems$8,
    pageSize
  });
  return state;
}
function responseToItem$3({
  data: { reminders, included: { users = {} } = {} }
}) {
  for (let i2 = 0; i2 < reminders.length; i2 += 1) {
    const reminder = reminders[i2];
    if (reminder.user && users[reminder.user.id]) {
      reminder.user = users[reminder.user.id];
      reminder.remindAt = moment(reminder.remindAt);
    }
  }
  return reminders;
}
function useRemindersLoader({
  taskId: _taskId,
  params,
  count: _count = 0
}) {
  const taskId = shallowRef(_taskId);
  const count = shallowRef(_count);
  const url2 = computed(() => Number.isInteger(taskId.value) && v3Url(`tasks/${taskId.value}/reminders`));
  const {
    state: { item, inSync, loading, meta, response, error },
    refresh
  } = useItemLoader({
    url: url2,
    params,
    responseToItem: responseToItem$3
  });
  useRealTimeUpdates((event) => {
    if (event.type === "reminder" && event.taskId === taskId.value) {
      refresh();
    }
  });
  return {
    items: computed(() => {
      if (item.value && count.value > 0) {
        if (item.value.length <= count.value) {
          return item.value;
        }
        return item.value.slice(0, count.value);
      }
      return [];
    }),
    totalCount: computed(() => item.value && item.value.length),
    itemInSync: () => inSync.value,
    inSync,
    loading,
    meta,
    response,
    error
  };
}
function deterministicJsonReplacer(_key, value) {
  if (Array.isArray(value)) {
    const { length: length2 } = value;
    const array = new Array(length2 + 1);
    let o = 0;
    array[o++] = "A";
    for (let i2 = 0; i2 < length2; i2++) {
      array[o++] = value[i2];
    }
    return array;
  }
  if (typeof value === "object" && value !== null) {
    const keys3 = Object.keys(value).sort();
    const { length: length2 } = keys3;
    const array = new Array(length2 * 2 + 1);
    let o = 0;
    array[o++] = "O";
    for (let i2 = 0; i2 < length2; i2 += 1) {
      const k = keys3[i2];
      const v = value[k];
      const t = typeof v;
      if (t !== "undefined" && t !== "function" && t !== "symbol") {
        array[o++] = k;
        array[o++] = v;
      }
    }
    if (array.length !== o) {
      array.length = o;
    }
    return array;
  }
  return value;
}
const cache = new Map();
function acquire(input) {
  const projectId = unref(input.projectId);
  const params = JSON.parse(JSON.stringify(unref(input.params) || {}));
  const cacheKey = JSON.stringify({ projectId, params }, deterministicJsonReplacer);
  let cacheItem = cache.get(cacheKey);
  if (cacheItem) {
    cacheItem.inputs.value.add(input);
    triggerRef(cacheItem.inputs);
  } else {
    const inputs = shallowRef(new Set([input]));
    const scope = effectScope(true);
    const loader = scope.run(() => {
      const inputsArray = computed(() => Array.from(inputs.value));
      const count = computed(() => inputsArray.value.reduce((maxCount, { count: currentCount }) => Math.max(maxCount, unref(currentCount)), -1));
      const pageSize = computed(() => inputsArray.value.reduce((maxPageSize, { pageSize: currentPageSize }) => Math.max(maxPageSize, unref(currentPageSize)), 0));
      return useBoardColumnsLoader({ projectId, params, count, pageSize });
    });
    cacheItem = {
      inputs,
      scope,
      loader
    };
    cache.set(cacheKey, cacheItem);
  }
  return {
    loader: cacheItem.loader,
    release() {
      if (cacheItem.inputs.value.delete(input)) {
        triggerRef(cacheItem.inputs);
        if (cacheItem.inputs.value.size === 0) {
          cacheItem.scope.stop();
          cache.delete(cacheKey);
        }
      }
    }
  };
}
function useSharedBoardColumnsLoader({
  projectId,
  params,
  count = 0,
  pageSize = 50
}) {
  const input = { projectId, params, count, pageSize };
  const loaderRef = shallowRef();
  let release;
  function init() {
    ({ loader: loaderRef.value, release } = acquire(input));
  }
  function update() {
    release();
    init();
  }
  init();
  watch(shallowRef(projectId), update);
  watch(shallowRef(params), update, { deep: true });
  onScopeDispose(release);
  return {
    items: computed(() => {
      const items = loaderRef.value.items.value;
      const maxLength = Math.max(0, unref(count) | 0);
      return items.length <= maxLength ? items : items.slice(0, maxLength);
    }),
    totalCount: computed(() => loaderRef.value.totalCount.value),
    inSync: computed(() => loaderRef.value.inSync.value),
    itemInSync: (item) => loaderRef.value.itemInSync(item),
    loading: computed(() => loaderRef.value.loading.value),
    meta: computed(() => loaderRef.value.meta.value),
    response: computed(() => loaderRef.value.response.value),
    error: computed(() => loaderRef.value.error.value)
  };
}
function responseToItems$7({ data: { tags } }) {
  for (let i2 = 0; i2 < tags.length; i2 += 1) {
    const tag = tags[i2];
    tag.id = Number(tag.id);
    tag.projectId = Number(tag.projectId);
  }
  return tags;
}
function useTagsLoader({ params, pageSize, count }) {
  const { state } = useListLoader({
    url: v1Url("tags"),
    params,
    pageSize,
    count,
    responseToItems: responseToItems$7
  });
  return state;
}
function responseToItem$2(response) {
  var _a;
  const {
    notifications = {},
    companies = {},
    tasklists = {},
    teams = {},
    users = {}
  } = response.data.included;
  const tasklistBudget = response.data.tasklistBudget;
  tasklistBudget.type = tasklistBudget.type.toLowerCase();
  if (tasklists[tasklistBudget.tasklistId]) {
    tasklistBudget.tasklist = tasklists[tasklistBudget.tasklistId];
  }
  (_a = tasklistBudget.notifications) == null ? void 0 : _a.forEach((_notification, index2) => {
    if (notifications[_notification.id]) {
      const notification = notifications[_notification.id];
      notification.notificationMedium = notification.notificationMedium.toLowerCase();
      notification.users = notification.users.map((user) => {
        var _a2;
        return (_a2 = users[user.id]) != null ? _a2 : user;
      });
      notification.teams = notification.teams.map((_team) => {
        var _a2;
        const team = (_a2 = teams[_team.id]) != null ? _a2 : _team;
        team.teamId = team.id;
        return team;
      });
      notification.companies = notification.companies.map((_company) => {
        var _a2;
        const company = (_a2 = companies[_company.id]) != null ? _a2 : _company;
        company.companyId = company.id;
        return company;
      });
      tasklistBudget.notifications[index2] = notification;
    }
  });
  return tasklistBudget;
}
function useTasklistBudgetLoader({
  budgetId,
  projectId,
  params
}) {
  const { state } = useItemLoader({
    url: v3Url(`projects/${projectId}/tasklists/budgets/${budgetId}`),
    params,
    responseToItem: (response) => responseToItem$2(response)
  });
  return state;
}
function responseToItems$6(response) {
  const {
    notifications = {},
    companies = {},
    tasklists = {},
    teams = {},
    users = {}
  } = response.data.included;
  const tasklistBudgets = response.data.tasklistBudgets || [];
  tasklistBudgets.forEach((_tasklistBudget) => {
    var _a;
    const tasklistBudget = _tasklistBudget;
    tasklistBudget.type = tasklistBudget.type.toLowerCase();
    if (tasklists[tasklistBudget.tasklistId]) {
      tasklistBudget.tasklist = tasklists[tasklistBudget.tasklistId];
    }
    const budgetNotifications = [];
    (_a = tasklistBudget.notifications) == null ? void 0 : _a.forEach((_notification) => {
      if (notifications[_notification.id]) {
        const notification = notifications[_notification.id];
        const { capacityThreshold, notificationMedium } = notification;
        const existingIndex = budgetNotifications.findIndex((n) => n.capacityThreshold === capacityThreshold && n.notificationMedium === notificationMedium.toLowerCase());
        notification.notificationMedium = notification.notificationMedium.toLowerCase();
        const notificationUsers = notification.userId ? [users[notification.userId]] : [];
        const notificationTeams = notification.teamId ? [teams[notification.teamId]] : [];
        const notificationCompanies = notification.companyId ? [companies[notification.companyId]] : [];
        if (existingIndex > -1) {
          budgetNotifications[existingIndex].users.push(...notificationUsers);
          budgetNotifications[existingIndex].companies.push(...notificationCompanies);
          budgetNotifications[existingIndex].teams.push(...notificationTeams);
        } else {
          notification.users = notificationUsers;
          notification.companies = notificationCompanies;
          notification.teams = notificationTeams;
          budgetNotifications.push(notification);
        }
      }
    });
    tasklistBudget.notifications = budgetNotifications;
  });
  return tasklistBudgets;
}
function responseToMeta(response) {
  const { totalCapacity } = response.data.meta;
  return { totalCapacity };
}
function order$2(tasklistBudget1, tasklistBudget2) {
  return tasklistBudget1.tasklist.displayOrder - tasklistBudget2.tasklist.displayOrder;
}
function useTasklistBudgetsLoader({
  params,
  projectBudgetId: _projectBudgetId,
  count,
  pageSize = 50
}) {
  const projectBudgetId = shallowRef(_projectBudgetId);
  const url2 = computed(() => v3Url(`projects/budgets/${projectBudgetId.value}/tasklists/budgets`));
  const { state, update, refresh } = useListLoader({
    url: url2,
    params,
    count,
    pageSize,
    responseToItems: responseToItems$6,
    responseToMeta,
    order: order$2
  });
  useOptimisticUpdates((event) => {
    if (event.type !== "tasklistBudget") {
      return;
    }
    update((tasklistBudgets) => {
      if (event.action === "create") {
        return tasklistBudgets.concat(event.tasklistBudget);
      }
      if (event.action === "bulkCreated") {
        return event.tasklistBudgets;
      }
      if (event.action === "update") {
        return tasklistBudgets.map((tasklistBudget) => {
          return tasklistBudget.id === event.tasklistBudget.id ? __spreadValues(__spreadValues({}, tasklistBudget), event.tasklistBudget) : tasklistBudget;
        });
      }
      if (event.action === "delete") {
        return tasklistBudgets.filter((tasklistBudget) => tasklistBudget.id !== event.tasklistBudget.id);
      }
      return tasklistBudgets;
    }, event.promise);
  });
  useRealTimeUpdates((event) => {
    if (event.type === "tasklistBudget" || event.type === "budget") {
      refresh();
    } else if (event.type === "time" || event.type === "project" && event.action === "rate-set") {
      refresh();
    } else if (event.type === "installation" && event.action === "rate-set" || event.type === "taskList") {
      refresh();
    }
  });
  return state;
}
function responseToItems$5(response) {
  const {
    notifications = {},
    companies = {},
    projects = {},
    tasklistBudgets = {},
    teams = {},
    users = {}
  } = response.data.included;
  const tasklists = response.data.tasklists || [];
  tasklists.forEach((tasklist) => {
    var _a;
    tasklist.id = Number(tasklist.id);
    tasklist.projectId = Number(tasklist.projectId);
    if (projects[tasklist.projectId]) {
      tasklist.project = projects[tasklist.projectId];
    }
    if (tasklist.tasklistBudget && tasklistBudgets[tasklist.tasklistBudget.id]) {
      const tasklistBudget = tasklistBudgets[tasklist.tasklistBudget.id];
      tasklistBudget.type = tasklistBudget.type.toLowerCase();
      const budgetNotifications = [];
      (_a = tasklistBudget.notifications) == null ? void 0 : _a.forEach((_notification) => {
        if (notifications[_notification.id]) {
          const notification = notifications[_notification.id];
          const { capacityThreshold, notificationMedium } = notification;
          const existingIndex = budgetNotifications.findIndex((n) => n.capacityThreshold === capacityThreshold && n.notificationMedium === notificationMedium.toLowerCase());
          notification.notificationMedium = notification.notificationMedium.toLowerCase();
          const notificationUsers = notification.userId ? [users[notification.userId]] : [];
          const notificationTeams = notification.teamId ? [teams[notification.teamId]] : [];
          const notificationCompanies = notification.companyId ? [companies[notification.companyId]] : [];
          if (existingIndex > -1) {
            budgetNotifications[existingIndex].users.push(...notificationUsers);
            budgetNotifications[existingIndex].companies.push(...notificationCompanies);
            budgetNotifications[existingIndex].teams.push(...notificationTeams);
          } else {
            notification.users = notificationUsers;
            notification.companies = notificationCompanies;
            notification.teams = notificationTeams;
            budgetNotifications.push(notification);
          }
        }
      });
      tasklist.tasklistBudget = tasklistBudget;
      tasklist.tasklistBudget.notifications = budgetNotifications;
    }
  });
  return tasklists;
}
function order$1(list1, list2) {
  return list1.position - list2.position;
}
function useTasklistsLoader({
  projectId: _projectId,
  params,
  count,
  pageSize = 50
}) {
  const projectId = shallowRef(_projectId);
  const url2 = computed(() => {
    if (projectId.value)
      return v3Url(`projects/${projectId.value}/tasklists`);
    return v3Url("tasklists");
  });
  const { state, refresh } = useListLoader({
    url: url2,
    params,
    count,
    responseToItems: responseToItems$5,
    order: order$1,
    pageSize
  });
  useRealTimeUpdates((event) => {
    if (event.type === "projectTasks") {
      refresh();
      return;
    }
    if (projectId.value && projectId.value !== event.projectId)
      return;
    if (event.type !== "task" && event.type !== "taskList" && event.type !== "taskListTasks")
      return;
    if (event.type === "task" && event.action !== "reopened" && event.action !== "completed" && event.action !== "new" && event.action !== "deleted")
      return;
    refresh(event.taskListId);
  });
  return state;
}
function responseToItems$4(response) {
  const tasklists = response.data.tasklists;
  for (let i2 = 0; i2 < tasklists.length; i2 += 1) {
    const tasklist = tasklists[i2];
    tasklist.id = Number(tasklist.id);
    tasklist.completedCount = tasklist["completed-count"];
    tasklist.uncompletedCount = tasklist["uncompleted-count"];
    tasklist.projectId = Number(tasklist.projectId);
  }
  return tasklists;
}
function order(list1, list2) {
  return list1.position - list2.position;
}
function useTasklistsV1Loader({
  projectId: _projectId,
  params,
  count,
  pageSize = 50
}) {
  const projectId = shallowRef(_projectId);
  const url2 = computed(() => {
    if (projectId.value)
      return v1Url(`projects/${projectId.value}/tasklists`);
    return v1Url("tasklists");
  });
  const { state, refresh } = useListLoader({
    url: url2,
    params,
    count,
    responseToItems: responseToItems$4,
    order,
    pageSize
  });
  useRealTimeUpdates((event) => {
    if (event.type === "projectTasks") {
      refresh();
      return;
    }
    if (projectId.value && projectId.value !== event.projectId && projectId.value !== event.previousProjectId) {
      return;
    }
    if (event.type === "taskList" || event.type === "taskListTasks") {
      refresh(event.taskListId);
    } else if (event.type === "task") {
      if (event.action === "reopened" || event.action === "completed" || event.action === "new" || event.action === "deleted") {
        refresh(event.taskListId);
      } else if (event.previousTaskListId && event.previousTaskListId !== event.taskListId) {
        refresh(event.taskListId);
        refresh(event.previousTaskListId);
      }
    }
  });
  return state;
}
function responseToItem$1(response) {
  const datesSet = response.data["dates-set"];
  Object.keys(datesSet).forEach((key) => {
    datesSet[key] = Number(datesSet[key]);
  });
  return {
    datesSet,
    outOfSequence: response.data["out-of-sequence"],
    recurringDates: response.data["recurring-dates"].map((date) => moment.utc(date))
  };
}
function useTaskRecurringLoader({
  taskId: _taskId,
  taskListId: _taskListId,
  projectId: _projectId,
  params
}) {
  const taskId = shallowRef(_taskId);
  const taskListId = shallowRef(_taskListId);
  const projectId = shallowRef(_projectId);
  const url2 = computed(() => Number.isInteger(taskId.value) && v1Url(`tasks/${taskId.value}/recurring`));
  const { state, refresh } = useItemLoader({ url: url2, params, responseToItem: responseToItem$1 });
  useRealTimeUpdates((event) => {
    if (event.type === "task" && event.taskListId === taskListId.value && event.projectId === projectId.value && (event.action === "added" || event.action === "deleted")) {
      refresh();
    }
  });
  return state;
}
function responseToItems$3({ data: data2 }) {
  const { tasks: tasksData } = data2;
  const {
    projectCategories = {},
    projects = {},
    tasklists = {},
    users = {},
    companies = {},
    teams = {},
    timeTotals = {},
    tags = {},
    taskSequences = {},
    cards = {},
    columns = {},
    comments = {},
    subtaskStats = {},
    lockdowns = {},
    customfieldTasks: _customfieldTasks = {},
    tasks = {}
  } = data2.included || {};
  const customfieldTasks = Object.values(_customfieldTasks);
  const commentValues = Object.values(comments);
  for (let i2 = 0; i2 < tasksData.length; i2 += 1) {
    const task = tasksData[i2];
    task.startDate = task.startDate ? moment(task.startDate, "YYYYMMDD") : null;
    task.dueDate = task.dueDate ? moment(task.dueDate, "YYYYMMDD") : null;
    task.createdAt = task.createdAt ? moment(task.createdAt) : null;
    task.updatedAt = task.updatedAt ? moment(task.updatedAt) : null;
    task.completedOn = task.completedOn ? moment(task.completedOn) : null;
    task.originalDueDate = task.originalDueDate ? moment(task.originalDueDate) : null;
    task.dateLastModified = task.dateLastModified ? moment(task.dateLastModified) : null;
    if (tags && task.tagIds && task.tagIds.length > 0) {
      task.tags = [];
      task.tagIds.forEach((tagId) => {
        if (tags[tagId])
          task.tags.push(tags[tagId]);
      });
    }
    if (lockdowns && task.lockdown && lockdowns[task.lockdown.id]) {
      task.lockdown = lockdowns[task.lockdown.id];
    }
    if (timeTotals && timeTotals[task.id]) {
      task.timeTotals = timeTotals[task.id];
    }
    if (taskSequences && task.sequenceId) {
      task.sequence = taskSequences[task.sequenceId];
    }
    if (cards && columns && task.card && cards[task.card.id]) {
      task.column = columns[cards[task.card.id].column.id];
      task.card = cards[task.card.id];
      task.card.column = columns[cards[task.card.id].column.id];
    }
    if (comments) {
      task.comments = commentValues.filter((comment) => comment.objectId === task.id);
    }
    if (task.completedBy && users[task.completedBy]) {
      task.completedBy = users[task.completedBy];
    }
    if (task.createdBy && users[task.createdBy]) {
      task.createdBy = users[task.createdBy];
    }
    if (task.updatedBy && users[task.updatedBy]) {
      task.updatedBy = users[task.updatedBy];
    }
    if (customfieldTasks) {
      task.customfieldTasks = customfieldTasks.filter((field) => field.taskId === task.id);
    }
    if (task.tasklistId && tasklists[task.tasklistId]) {
      task.taskListId = task.tasklistId;
      task.taskList = tasklists[task.tasklistId];
      task.tasklist = tasklists[task.tasklistId];
    }
    if (projects && tasklists[task.tasklistId]) {
      task.project = projects[task.tasklist.projectId];
      task.projectId = task.tasklist.projectId;
      task.tasklist.project = projects[task.tasklist.projectId];
      if (companies) {
        task.project.company = companies[task.project.companyId];
      }
    }
    if (task.project && task.project.categoryId && projectCategories) {
      task.project.category = projectCategories[task.project.categoryId];
    }
    for (let j = 0; j < task.assignees.length; j += 1) {
      const assignee = task.assignees[j];
      if (assignee.type === "users") {
        if (users[assignee.id]) {
          task.assignees[j] = __spreadProps(__spreadValues({}, users[assignee.id]), { assigneeType: "users" });
        }
      } else if (assignee.type === "companies") {
        if (companies[assignee.id]) {
          task.assignees[j] = __spreadProps(__spreadValues({}, companies[assignee.id]), {
            assigneeType: "companies"
          });
        }
      } else if (assignee.type === "teams") {
        if (teams[assignee.id]) {
          task.assignees[j] = __spreadProps(__spreadValues({}, teams[assignee.id]), { assigneeType: "teams" });
        }
      }
    }
    if (task.parentTaskId > 0 && tasks[task.parentTaskId]) {
      task.parentTask = tasks[task.parentTaskId];
    }
    task.subtaskStats = subtaskStats[task.id];
  }
  return tasksData;
}
function computeDisplayOrder(task, tasks) {
  var _a;
  if (task.positionAfterTaskId != null) {
    const previousTask = tasks.find(({ id }) => id === task.positionAfterTaskId);
    if (previousTask) {
      return previousTask.displayOrder + 0.5;
    }
    return Number.MIN_SAFE_INTEGER;
  }
  return (_a = task.displayOrder) != null ? _a : Number.MAX_SAFE_INTEGER;
}
function normalizeTask(inputTask, tasks) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  const newTask = __spreadValues({}, inputTask);
  (_a = newTask.id) != null ? _a : newTask.id = -1;
  (_b = newTask.parentTaskId) != null ? _b : newTask.parentTaskId = 0;
  (_d = newTask.tasklistId) != null ? _d : newTask.tasklistId = (_c = newTask.taskListId) != null ? _c : 0;
  newTask.taskListId = newTask.tasklistId;
  (_e = newTask.projectId) != null ? _e : newTask.projectId = 0;
  (_f = newTask.assignees) != null ? _f : newTask.assignees = [];
  (_g = newTask.createdBy) != null ? _g : newTask.createdBy = {};
  (_h = newTask.priority) != null ? _h : newTask.priority = "";
  (_i = newTask.tags) != null ? _i : newTask.tags = [];
  newTask.displayOrder = computeDisplayOrder(newTask, tasks);
  (_j = newTask.tasklist) != null ? _j : newTask.tasklist = newTask.taskList;
  if (newTask.tasklist == null) {
    for (let i2 = 0; i2 < tasks.length; i2 += 1) {
      const task = tasks[i2];
      if (task.tasklistId === newTask.tasklistId) {
        newTask.tasklist = task.tasklist;
        (_k = newTask.project) != null ? _k : newTask.project = task.project;
        break;
      }
    }
  }
  (_l = newTask.tasklist) != null ? _l : newTask.tasklist = {
    id: newTask.tasklistId,
    name: "",
    displayOrder: 0
  };
  newTask.taskList = newTask.tasklist;
  (_m = newTask.project) != null ? _m : newTask.project = {
    id: newTask.projectId,
    name: ""
  };
  return newTask;
}
function orderAscByManual(task1, task2) {
  return task1.project.name.localeCompare(task2.project.name) || task1.taskList.displayOrder - task2.taskList.displayOrder || task1.parentTaskId - task2.parentTaskId || task1.displayOrder - task2.displayOrder;
}
function orderDescByManual(task1, task2) {
  return task2.project.name.localeCompare(task1.project.name) || task1.taskList.displayOrder - task2.taskList.displayOrder || task1.parentTaskId - task2.parentTaskId || task1.displayOrder - task2.displayOrder;
}
function orderAscByName(task1, task2) {
  return task1.name.localeCompare(task2.name);
}
function orderDescByName(task1, task2) {
  return task2.name.localeCompare(task1.name);
}
function orderAscByDueDate({ dueDate: date1 }, { dueDate: date2 }) {
  if (date1 && date1.isValid()) {
    if (date2 && date2.isValid()) {
      return date1.valueOf() - date2.valueOf();
    }
    return -1;
  }
  if (date2 && date2.isValid()) {
    return 1;
  }
  return 0;
}
function orderDescByDueDate({ dueDate: date1 }, { dueDate: date2 }) {
  if (date1 && date1.isValid()) {
    if (date2 && date2.isValid()) {
      return date2.valueOf() - date1.valueOf();
    }
    return -1;
  }
  if (date2 && date2.isValid()) {
    return 1;
  }
  return 0;
}
function orderAscByStartDate({ startDate: date1 }, { startDate: date2 }) {
  if (date1 && date1.isValid()) {
    if (date2 && date2.isValid()) {
      return date1.valueOf() - date2.valueOf();
    }
    return -1;
  }
  if (date2 && date2.isValid()) {
    return 1;
  }
  return 0;
}
function orderDescByStartDate({ startDate: date1 }, { startDate: date2 }) {
  if (date2 && date2.isValid()) {
    if (date1 && date1.isValid()) {
      return date2.valueOf() - date1.valueOf();
    }
    return -1;
  }
  if (date1 && date1.isValid()) {
    return 1;
  }
  return 0;
}
function orderAscByCreatedDate(task1, task2) {
  return task1.createdAt.valueOf() - task2.createdAt.valueOf();
}
function orderDescByCreatedDate(task1, task2) {
  return task2.createdAt.valueOf() - task1.createdAt.valueOf();
}
function orderAscByPriority({ priority: priority1 }, { priority: priority2 }) {
  if (priority1 === priority2)
    return 0;
  if (priority1 === "low")
    return -1;
  if (priority2 === "low")
    return 1;
  if (priority1 === "medium")
    return -1;
  if (priority2 === "medium")
    return 1;
  if (priority1 === "high")
    return -1;
  if (priority2 === "high")
    return 1;
  return 0;
}
function orderDescByPriority({ priority: priority1 }, { priority: priority2 }) {
  if (priority1 === priority2)
    return 0;
  if (priority1 === "high")
    return -1;
  if (priority2 === "high")
    return 1;
  if (priority1 === "medium")
    return -1;
  if (priority2 === "medium")
    return 1;
  if (priority1 === "low")
    return -1;
  if (priority2 === "low")
    return 1;
  return 0;
}
function orderAscByTaskListName(task1, task2) {
  return task1.taskList.name.localeCompare(task2.taskList.name);
}
function orderDescByTaskListName(task1, task2) {
  return task2.taskList.name.localeCompare(task1.taskList.name);
}
function orderAscByProject(task1, task2) {
  return task1.project.name.localeCompare(task2.project.name) || task1.taskList.id - task2.taskList.id;
}
function orderDescByProject(task1, task2) {
  return task2.project.name.localeCompare(task1.project.name) || task2.taskList.id - task1.taskList.id;
}
function orderAscByCreatedBy(task1, task2) {
  return task1.createdBy.firstName.localeCompare(task2.createdBy.firstName) || task1.createdBy.lastName.localeCompare(task2.createdBy.lastName);
}
function orderDescByCreatedBy(task1, task2) {
  return task2.createdBy.firstName.localeCompare(task1.createdBy.firstName) || task2.createdBy.lastName.localeCompare(task1.createdBy.lastName);
}
function orderAscByCompletedOn(task1, task2) {
  if (task1.completedOn && task1.completedOn.isValid()) {
    if (task2.completedOn && task2.completedOn.isValid()) {
      return task2.completedOn.valueOf() - task1.completedOn.valueOf();
    }
    return -1;
  }
  if (task2.completedOn && task2.completedOn.isValid()) {
    return 1;
  }
  return orderAscByName(task1, task2);
}
function orderDescByCompletedOn(task1, task2) {
  if (task2.completedOn && task2.completedOn.isValid()) {
    if (task1.completedOn && task1.completedOn.isValid()) {
      return task1.completedOn.valueOf() - task2.completedOn.valueOf();
    }
    return -1;
  }
  if (task1.completedOn && task1.completedOn.isValid()) {
    return 1;
  }
  return orderAscByName(task1, task2);
}
function orderAscByEstimate(task1, task2) {
  return task1.estimateMinutes - task2.estimateMinutes;
}
function orderDescByEstimate(task1, task2) {
  return task2.estimateMinutes - task1.estimateMinutes;
}
function orderByDefault() {
  return 0;
}
function useTasksLoader({
  taskId: _taskId,
  tasklistId: _tasklistId,
  taskListId: _taskListId,
  projectId: _projectId,
  params: _params,
  count,
  pageSize
}) {
  const taskId = shallowRef(_taskId);
  const taskListId = shallowRef(_taskListId !== void 0 ? _taskListId : _tasklistId);
  const projectId = shallowRef(_projectId);
  const params = computed(() => {
    const normalizedParams = __spreadValues({}, unref(_params));
    const { orderBy, orderMode } = normalizedParams;
    if (!orderBy) {
      normalizedParams.orderBy = "manual";
    }
    if (!orderMode) {
      normalizedParams.orderMode = "asc";
    } else if (orderMode !== "asc" && orderMode !== "desc") {
      console.warn(`useTasksLoader: unknown params.orderMode: ${orderMode}`);
      normalizedParams.orderMode = "asc";
    }
    normalizedParams.include = [
      ...new Set((normalizedParams.include || "").split(",").map((item) => item.trim()).filter(Boolean).concat(["taskLists", "taskListNames", "projectNames", "projects"]))
    ].join(",");
    return normalizedParams;
  });
  const url2 = computed(() => {
    if (taskId.value)
      return v3Url(`tasks/${taskId.value}/subtasks`);
    if (taskListId.value)
      return v3Url(`tasklists/${taskListId.value}/tasks`);
    if (projectId.value)
      return v3Url(`projects/${projectId.value}/tasks`);
    return v3Url("tasks");
  });
  const order2 = computed(() => {
    const { orderBy, orderMode } = params.value;
    const desc = orderMode === "desc";
    switch (orderBy.toLowerCase()) {
      case "manual":
        return orderAscByManual;
      case "projectmanual":
        return desc ? orderDescByManual : orderAscByManual;
      case "taskname":
        return desc ? orderDescByName : orderAscByName;
      case "duedate":
        return desc ? orderDescByDueDate : orderAscByDueDate;
      case "startdate":
        return desc ? orderDescByStartDate : orderAscByStartDate;
      case "priority":
        return desc ? orderDescByPriority : orderAscByPriority;
      case "tasklistname":
        return desc ? orderDescByTaskListName : orderAscByTaskListName;
      case "createdby":
        return desc ? orderDescByCreatedBy : orderAscByCreatedBy;
      case "project":
        return desc ? orderDescByProject : orderAscByProject;
      case "dateadded":
        return desc ? orderDescByCreatedDate : orderAscByCreatedDate;
      case "active":
        return desc ? orderDescByCompletedOn : orderAscByCompletedOn;
      case "estimatedtime":
        return desc ? orderDescByEstimate : orderAscByEstimate;
      default:
        console.warn(`useTasksLoader: unknown params.orderBy: ${orderBy}`);
        return orderByDefault;
    }
  });
  const { state, refresh, update } = useListLoader({
    url: url2,
    params,
    count,
    responseToItems: responseToItems$3,
    order: order2,
    pageSize
  });
  function matchesFilter(task, avoidFalsePositives) {
    var _a, _b;
    if (avoidFalsePositives && params.value && (params.value.filterText || params.value["responsible-party-ids"] || params.value.tagIds || params.value.filter === "completed")) {
      return false;
    }
    if (!((_a = params.value) == null ? void 0 : _a.getSubTasks) && !taskId.value && task.parentTaskId) {
      return false;
    }
    if (taskId.value && taskId.value !== task.parentTaskId) {
      return false;
    }
    if (taskListId.value && taskListId.value !== task.taskListId && taskListId.value !== task.tasklistId) {
      return false;
    }
    if (projectId.value && projectId.value !== task.projectId) {
      return false;
    }
    if (params.value && params.value.ignoreStartDates) {
      const today = moment().startOf("day");
      const { dueDate } = task;
      switch (params.value.taskFilter) {
        case "upcoming":
          if (!dueDate) {
            return false;
          }
          if (((_b = params.value.includeToday) != null ? _b : true) ? dueDate.isBefore(today) : dueDate.isBefore(today.add(1, "day"))) {
            return false;
          }
          break;
        case "today":
          if (!dueDate) {
            return false;
          }
          if (!dueDate.isSame(today)) {
            return false;
          }
          break;
        case "overdue":
          if (!dueDate) {
            return false;
          }
          if (dueDate.isSameOrAfter(today)) {
            return false;
          }
          break;
        case "noduedate":
          if (dueDate) {
            return false;
          }
          break;
      }
    }
    return true;
  }
  useOptimisticUpdates((event) => {
    if (event.type === "task") {
      update((tasks) => {
        if (event.action === "create") {
          if (matchesFilter(event.task, true)) {
            return tasks.concat([normalizeTask(event.task, tasks)]);
          }
          return tasks;
        }
        if (event.action === "update") {
          if (!matchesFilter(event.task)) {
            return tasks.filter((task) => task.id !== event.task.id);
          }
          if (tasks.some((task) => task.id === event.task.id)) {
            return tasks.map((task) => {
              if (task.id === event.task.id) {
                const newTask = __spreadValues(__spreadValues({}, task), event.task);
                newTask.displayOrder = computeDisplayOrder(newTask, tasks);
                return newTask;
              }
              return task;
            });
          }
          if (event.task.previousParentTaskId != null && event.task.previousParentTaskId !== event.task.parentTaskId || event.task.previousTaskListId != null && event.task.previousTaskListId !== event.task.taskListId || event.task.previousProjectId != null && event.task.previousProjectId !== event.task.projectId) {
            return tasks.concat([normalizeTask(event.task, tasks)]);
          }
          return tasks;
        }
        if (event.action === "delete") {
          return tasks.filter((task) => task.id !== event.task.id);
        }
        return tasks;
      }, event.promise);
    }
  });
  useRealTimeUpdates((event) => {
    if (event.type === "projectTasks") {
      refresh();
      return;
    }
    if (event.type === "task") {
      refresh(event.taskId);
      return;
    }
    if (projectId.value && projectId.value !== event.projectId)
      return;
    if (taskListId.value && taskListId.value !== event.taskListId && taskListId.value !== event.previousTaskListId) {
      return;
    }
    if (event.type === "taskListTasks") {
      refresh();
      return;
    }
    if (event.type === "taskList") {
      if (event.action === "edited")
        refresh();
      return;
    }
    if (event.type !== "task" && event.type !== "comment" && event.type !== "time") {
      return;
    }
    if (event.type === "comment" && event.action === "edited")
      return;
    if (event.type === "task" && event.parentTaskId && (event.action === "reopened" || event.action === "completed" || event.action === "new" || event.action === "deleted")) {
      refresh(event.parentTaskId);
    }
    if (!params.value.getSubTasks) {
      if (taskId.value && taskId.value !== event.parentTaskId && taskId.value !== event.previousParentTaskId)
        return;
      if (!taskId.value && event.parentTaskId && event.previousParentTaskId)
        return;
    }
    refresh(event.taskId);
  });
  return state;
}
function responseToItems$2(response) {
  const {
    users = {},
    projects = {},
    tasks = {},
    tags = {},
    tasklists = {}
  } = response.data.included;
  const { permissions = {} } = response.data.meta;
  const timelogs = response.data.timelogs || [];
  timelogs.forEach((timelog) => {
    var _a, _b, _c, _d, _e;
    timelog.minutes = Number(timelog.minutes);
    timelog.createdAt = timelog.createdAt ? moment(timelog.createdAt) : null;
    timelog.timeLogged = timelog.timeLogged ? moment(timelog.timeLogged) : null;
    timelog.timeLoggedEnd = timelog.timeLogged ? moment(timelog.timeLogged).add(timelog.minutes, "minutes") : null;
    timelog.isBilled = Boolean((_a = timelog.projectBillingInvoice) == null ? void 0 : _a.id);
    if (permissions[timelog.id]) {
      timelog.permissions = permissions[timelog.id];
    }
    if (projects[(_b = timelog.project) == null ? void 0 : _b.id]) {
      timelog.project = projects[timelog.project.id];
    }
    if (timelog.tags) {
      timelog.tags.forEach((tag, index2) => {
        if (tags[tag.id]) {
          timelog.tags[index2] = tags[tag.id];
        }
      });
    }
    if (tasks[(_c = timelog.task) == null ? void 0 : _c.id]) {
      timelog.task = tasks[timelog.task.id];
      if (tasklists[(_d = timelog.task.tasklist) == null ? void 0 : _d.id]) {
        timelog.task.tasklist = tasklists[timelog.task.tasklist.id];
      }
    }
    if (users[(_e = timelog.user) == null ? void 0 : _e.id]) {
      timelog.user = users[timelog.user.id];
    }
  });
  return timelogs;
}
function useTimelogsLoader({
  projectId: _projectId,
  taskId: _taskId,
  params,
  count,
  pageSize
} = {}) {
  const taskId = shallowRef(_taskId);
  const projectId = shallowRef(_projectId);
  const url2 = computed(() => {
    if (taskId.value) {
      return v3Url(`tasks/${taskId.value}/time`);
    }
    if (projectId.value) {
      return v3Url(`projects/${projectId.value}/time`);
    }
    return v3Url("time");
  });
  const { state, update, refresh } = useListLoader({
    url: url2,
    params,
    count,
    responseToItems: responseToItems$2,
    pageSize
  });
  useOptimisticUpdates((event) => {
    if (event.type !== "time") {
      return;
    }
    update((timelogs) => {
      if (event.action === "create") {
        return timelogs.concat(event.timelog);
      }
      if (event.action === "update") {
        return timelogs.map((timelog) => timelog.id === event.timelog.id ? __spreadValues(__spreadValues({}, timelog), event.timelog) : timelog);
      }
      if (event.action === "delete") {
        return timelogs.filter((timelog) => timelog.id !== event.timelog.id);
      }
      return timelogs;
    }, event.promise);
  });
  useRealTimeUpdates((event) => {
    if (event.type === "time") {
      refresh(event.timeId);
    }
  });
  return state;
}
function responseToItem(response) {
  const { "time-totals": timeTotals, subTasks } = response.data;
  Object.entries(timeTotals).forEach(([key, value]) => {
    timeTotals[key] = Number(value);
  });
  Object.entries(subTasks).forEach(([key, value]) => {
    subTasks[key] = Number(value);
  });
  return {
    timeTotals,
    subTasks
  };
}
function useTimelogTotalsLoader({
  projectId: _projectId,
  taskId: _taskId,
  params
} = {}) {
  const taskId = shallowRef(_taskId);
  const projectId = shallowRef(_projectId);
  const url2 = computed(() => {
    if (taskId.value) {
      return v3Url(`tasks/${taskId.value}/time/totals`);
    }
    if (projectId.value) {
      return v3Url(`projects/${projectId.value}/time/totals`);
    }
    return v3Url("time/totals");
  });
  const { state, refresh } = useItemLoader({
    url: url2,
    params,
    responseToItem
  });
  useRealTimeUpdates((event) => {
    if (event.type === "time") {
      refresh();
    }
  });
  return state;
}
function responseToItems$1(response) {
  const { users = {} } = response.data.included;
  const userRatesList = response.data.userRates || [];
  userRatesList.forEach((userRate) => {
    userRate.id = userRate.user.id;
    if (users[userRate.user.id]) {
      userRate.user = users[userRate.user.id];
    }
  });
  return userRatesList;
}
function useUserRatesLoader({
  projectId,
  params,
  count,
  pageSize = 50
}) {
  const url2 = projectId ? v3Url(`rates/projects/${projectId}/users`) : v3Url("rates/installation/users");
  const { state } = useListLoader({
    url: url2,
    params,
    count,
    responseToItems: responseToItems$1,
    pageSize
  });
  return state;
}
function responseToItems(response) {
  const users = response.data.included.users;
  const utilizations = response.data.utilization.map((u) => ({
    id: u.userId,
    user: users[u.userId],
    utilizations: u.data
  }));
  return utilizations;
}
function useUtilizationPeopleLoader({ params, count, pageSize = 50 }) {
  const { state, refresh } = useListLoader({
    url: v3Url("people/utilization"),
    params,
    count,
    responseToItems,
    pageSize
  });
  useRealTimeUpdates((event) => {
    if (event.type === "person") {
      refresh(event.userId);
    } else if (event.type === "event") {
      refresh();
    }
  });
  return state;
}
var lib$1 = { exports: {} };
var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
var parts = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
var parseuri$2 = function parseuri(str) {
  var src2 = str, b = str.indexOf("["), e = str.indexOf("]");
  if (b != -1 && e != -1) {
    str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ";") + str.substring(e, str.length);
  }
  var m2 = re.exec(str || ""), uri = {}, i2 = 14;
  while (i2--) {
    uri[parts[i2]] = m2[i2] || "";
  }
  if (b != -1 && e != -1) {
    uri.source = src2;
    uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
    uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
    uri.ipv6uri = true;
  }
  uri.pathNames = pathNames(uri, uri["path"]);
  uri.queryKey = queryKey(uri, uri["query"]);
  return uri;
};
function pathNames(obj, path) {
  var regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
  if (path.substr(0, 1) == "/" || path.length === 0) {
    names.splice(0, 1);
  }
  if (path.substr(path.length - 1, 1) == "/") {
    names.splice(names.length - 1, 1);
  }
  return names;
}
function queryKey(uri, query) {
  var data2 = {};
  query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
    if ($1) {
      data2[$1] = $2;
    }
  });
  return data2;
}
var browser$1 = { exports: {} };
var debug$6 = { exports: {} };
var s = 1e3;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;
var ms = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === "string" && val.length > 0) {
    return parse(val);
  } else if (type === "number" && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match2 = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match2) {
    return;
  }
  var n = parseFloat(match2[1]);
  var type = (match2[2] || "ms").toLowerCase();
  switch (type) {
    case "years":
    case "year":
    case "yrs":
    case "yr":
    case "y":
      return n * y;
    case "days":
    case "day":
    case "d":
      return n * d;
    case "hours":
    case "hour":
    case "hrs":
    case "hr":
    case "h":
      return n * h;
    case "minutes":
    case "minute":
    case "mins":
    case "min":
    case "m":
      return n * m;
    case "seconds":
    case "second":
    case "secs":
    case "sec":
    case "s":
      return n * s;
    case "milliseconds":
    case "millisecond":
    case "msecs":
    case "msec":
    case "ms":
      return n;
    default:
      return void 0;
  }
}
function fmtShort(ms2) {
  if (ms2 >= d) {
    return Math.round(ms2 / d) + "d";
  }
  if (ms2 >= h) {
    return Math.round(ms2 / h) + "h";
  }
  if (ms2 >= m) {
    return Math.round(ms2 / m) + "m";
  }
  if (ms2 >= s) {
    return Math.round(ms2 / s) + "s";
  }
  return ms2 + "ms";
}
function fmtLong(ms2) {
  return plural(ms2, d, "day") || plural(ms2, h, "hour") || plural(ms2, m, "minute") || plural(ms2, s, "second") || ms2 + " ms";
}
function plural(ms2, n, name) {
  if (ms2 < n) {
    return;
  }
  if (ms2 < n * 1.5) {
    return Math.floor(ms2 / n) + " " + name;
  }
  return Math.ceil(ms2 / n) + " " + name + "s";
}
(function(module, exports) {
  exports = module.exports = createDebug.debug = createDebug["default"] = createDebug;
  exports.coerce = coerce;
  exports.disable = disable;
  exports.enable = enable;
  exports.enabled = enabled;
  exports.humanize = ms;
  exports.instances = [];
  exports.names = [];
  exports.skips = [];
  exports.formatters = {};
  function selectColor(namespace) {
    var hash = 0, i2;
    for (i2 in namespace) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i2);
      hash |= 0;
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
  }
  function createDebug(namespace) {
    var prevTime;
    function debug2() {
      if (!debug2.enabled)
        return;
      var self2 = debug2;
      var curr = +new Date();
      var ms2 = curr - (prevTime || curr);
      self2.diff = ms2;
      self2.prev = prevTime;
      self2.curr = curr;
      prevTime = curr;
      var args = new Array(arguments.length);
      for (var i2 = 0; i2 < args.length; i2++) {
        args[i2] = arguments[i2];
      }
      args[0] = exports.coerce(args[0]);
      if (typeof args[0] !== "string") {
        args.unshift("%O");
      }
      var index2 = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match2, format) {
        if (match2 === "%%")
          return match2;
        index2++;
        var formatter = exports.formatters[format];
        if (typeof formatter === "function") {
          var val = args[index2];
          match2 = formatter.call(self2, val);
          args.splice(index2, 1);
          index2--;
        }
        return match2;
      });
      exports.formatArgs.call(self2, args);
      var logFn = debug2.log || exports.log || console.log.bind(console);
      logFn.apply(self2, args);
    }
    debug2.namespace = namespace;
    debug2.enabled = exports.enabled(namespace);
    debug2.useColors = exports.useColors();
    debug2.color = selectColor(namespace);
    debug2.destroy = destroy;
    if (typeof exports.init === "function") {
      exports.init(debug2);
    }
    exports.instances.push(debug2);
    return debug2;
  }
  function destroy() {
    var index2 = exports.instances.indexOf(this);
    if (index2 !== -1) {
      exports.instances.splice(index2, 1);
      return true;
    } else {
      return false;
    }
  }
  function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var i2;
    var split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
    var len = split.length;
    for (i2 = 0; i2 < len; i2++) {
      if (!split[i2])
        continue;
      namespaces = split[i2].replace(/\*/g, ".*?");
      if (namespaces[0] === "-") {
        exports.skips.push(new RegExp("^" + namespaces.substr(1) + "$"));
      } else {
        exports.names.push(new RegExp("^" + namespaces + "$"));
      }
    }
    for (i2 = 0; i2 < exports.instances.length; i2++) {
      var instance = exports.instances[i2];
      instance.enabled = exports.enabled(instance.namespace);
    }
  }
  function disable() {
    exports.enable("");
  }
  function enabled(name) {
    if (name[name.length - 1] === "*") {
      return true;
    }
    var i2, len;
    for (i2 = 0, len = exports.skips.length; i2 < len; i2++) {
      if (exports.skips[i2].test(name)) {
        return false;
      }
    }
    for (i2 = 0, len = exports.names.length; i2 < len; i2++) {
      if (exports.names[i2].test(name)) {
        return true;
      }
    }
    return false;
  }
  function coerce(val) {
    if (val instanceof Error)
      return val.stack || val.message;
    return val;
  }
})(debug$6, debug$6.exports);
(function(module, exports) {
  exports = module.exports = debug$6.exports;
  exports.log = log;
  exports.formatArgs = formatArgs;
  exports.save = save;
  exports.load = load;
  exports.useColors = useColors;
  exports.storage = typeof chrome != "undefined" && typeof chrome.storage != "undefined" ? chrome.storage.local : localstorage();
  exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
  ];
  function useColors() {
    if (typeof window !== "undefined" && window.process && window.process.type === "renderer") {
      return true;
    }
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
      return false;
    }
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  exports.formatters.j = function(v) {
    try {
      return JSON.stringify(v);
    } catch (err) {
      return "[UnexpectedJSONParseError]: " + err.message;
    }
  };
  function formatArgs(args) {
    var useColors2 = this.useColors;
    args[0] = (useColors2 ? "%c" : "") + this.namespace + (useColors2 ? " %c" : " ") + args[0] + (useColors2 ? "%c " : " ") + "+" + exports.humanize(this.diff);
    if (!useColors2)
      return;
    var c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    var index2 = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match2) {
      if (match2 === "%%")
        return;
      index2++;
      if (match2 === "%c") {
        lastC = index2;
      }
    });
    args.splice(lastC, 0, c);
  }
  function log() {
    return typeof console === "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
  }
  function save(namespaces) {
    try {
      if (namespaces == null) {
        exports.storage.removeItem("debug");
      } else {
        exports.storage.debug = namespaces;
      }
    } catch (e) {
    }
  }
  function load() {
    var r;
    try {
      r = exports.storage.debug;
    } catch (e) {
    }
    if (!r && typeof process !== "undefined" && "env" in process) {
      r = {}.DEBUG;
    }
    return r;
  }
  exports.enable(load());
  function localstorage() {
    try {
      return window.localStorage;
    } catch (e) {
    }
  }
})(browser$1, browser$1.exports);
var parseuri$1 = parseuri$2;
var debug$5 = browser$1.exports("socket.io-client:url");
var url_1 = url;
function url(uri, loc) {
  var obj = uri;
  loc = loc || typeof location !== "undefined" && location;
  if (uri == null)
    uri = loc.protocol + "//" + loc.host;
  if (typeof uri === "string") {
    if (uri.charAt(0) === "/") {
      if (uri.charAt(1) === "/") {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }
    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug$5("protocol-less url %s", uri);
      if (typeof loc !== "undefined") {
        uri = loc.protocol + "//" + uri;
      } else {
        uri = "https://" + uri;
      }
    }
    debug$5("parse %s", uri);
    obj = parseuri$1(uri);
  }
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = "80";
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = "443";
    }
  }
  obj.path = obj.path || "/";
  var ipv6 = obj.host.indexOf(":") !== -1;
  var host = ipv6 ? "[" + obj.host + "]" : obj.host;
  obj.id = obj.protocol + "://" + host + ":" + obj.port;
  obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
  return obj;
}
var socket_ioParser = {};
var componentEmitter = { exports: {} };
(function(module) {
  {
    module.exports = Emitter2;
  }
  function Emitter2(obj) {
    if (obj)
      return mixin(obj);
  }
  function mixin(obj) {
    for (var key in Emitter2.prototype) {
      obj[key] = Emitter2.prototype[key];
    }
    return obj;
  }
  Emitter2.prototype.on = Emitter2.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
  };
  Emitter2.prototype.once = function(event, fn) {
    function on2() {
      this.off(event, on2);
      fn.apply(this, arguments);
    }
    on2.fn = fn;
    this.on(event, on2);
    return this;
  };
  Emitter2.prototype.off = Emitter2.prototype.removeListener = Emitter2.prototype.removeAllListeners = Emitter2.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    if (arguments.length == 0) {
      this._callbacks = {};
      return this;
    }
    var callbacks2 = this._callbacks["$" + event];
    if (!callbacks2)
      return this;
    if (arguments.length == 1) {
      delete this._callbacks["$" + event];
      return this;
    }
    var cb;
    for (var i2 = 0; i2 < callbacks2.length; i2++) {
      cb = callbacks2[i2];
      if (cb === fn || cb.fn === fn) {
        callbacks2.splice(i2, 1);
        break;
      }
    }
    if (callbacks2.length === 0) {
      delete this._callbacks["$" + event];
    }
    return this;
  };
  Emitter2.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks2 = this._callbacks["$" + event];
    for (var i2 = 1; i2 < arguments.length; i2++) {
      args[i2 - 1] = arguments[i2];
    }
    if (callbacks2) {
      callbacks2 = callbacks2.slice(0);
      for (var i2 = 0, len = callbacks2.length; i2 < len; ++i2) {
        callbacks2[i2].apply(this, args);
      }
    }
    return this;
  };
  Emitter2.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
  };
  Emitter2.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
  };
})(componentEmitter);
var binary = {};
var toString$2 = {}.toString;
var isarray = Array.isArray || function(arr) {
  return toString$2.call(arr) == "[object Array]";
};
var isBuffer2 = isBuf$1;
var withNativeBuffer = typeof Buffer === "function" && typeof Buffer.isBuffer === "function";
var withNativeArrayBuffer = typeof ArrayBuffer === "function";
var isView = function(obj) {
  return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
function isBuf$1(obj) {
  return withNativeBuffer && Buffer.isBuffer(obj) || withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj));
}
var isArray$1 = isarray;
var isBuf = isBuffer2;
var toString$1 = Object.prototype.toString;
var withNativeBlob$1 = typeof Blob === "function" || typeof Blob !== "undefined" && toString$1.call(Blob) === "[object BlobConstructor]";
var withNativeFile$1 = typeof File === "function" || typeof File !== "undefined" && toString$1.call(File) === "[object FileConstructor]";
binary.deconstructPacket = function(packet) {
  var buffers = [];
  var packetData = packet.data;
  var pack = packet;
  pack.data = _deconstructPacket(packetData, buffers);
  pack.attachments = buffers.length;
  return { packet: pack, buffers };
};
function _deconstructPacket(data2, buffers) {
  if (!data2)
    return data2;
  if (isBuf(data2)) {
    var placeholder = { _placeholder: true, num: buffers.length };
    buffers.push(data2);
    return placeholder;
  } else if (isArray$1(data2)) {
    var newData = new Array(data2.length);
    for (var i2 = 0; i2 < data2.length; i2++) {
      newData[i2] = _deconstructPacket(data2[i2], buffers);
    }
    return newData;
  } else if (typeof data2 === "object" && !(data2 instanceof Date)) {
    var newData = {};
    for (var key in data2) {
      newData[key] = _deconstructPacket(data2[key], buffers);
    }
    return newData;
  }
  return data2;
}
binary.reconstructPacket = function(packet, buffers) {
  packet.data = _reconstructPacket(packet.data, buffers);
  packet.attachments = void 0;
  return packet;
};
function _reconstructPacket(data2, buffers) {
  if (!data2)
    return data2;
  if (data2 && data2._placeholder) {
    return buffers[data2.num];
  } else if (isArray$1(data2)) {
    for (var i2 = 0; i2 < data2.length; i2++) {
      data2[i2] = _reconstructPacket(data2[i2], buffers);
    }
  } else if (typeof data2 === "object") {
    for (var key in data2) {
      data2[key] = _reconstructPacket(data2[key], buffers);
    }
  }
  return data2;
}
binary.removeBlobs = function(data2, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj)
      return obj;
    if (withNativeBlob$1 && obj instanceof Blob || withNativeFile$1 && obj instanceof File) {
      pendingBlobs++;
      var fileReader = new FileReader();
      fileReader.onload = function() {
        if (containingObject) {
          containingObject[curKey] = this.result;
        } else {
          bloblessData = this.result;
        }
        if (!--pendingBlobs) {
          callback(bloblessData);
        }
      };
      fileReader.readAsArrayBuffer(obj);
    } else if (isArray$1(obj)) {
      for (var i2 = 0; i2 < obj.length; i2++) {
        _removeBlobs(obj[i2], i2, obj);
      }
    } else if (typeof obj === "object" && !isBuf(obj)) {
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }
  var pendingBlobs = 0;
  var bloblessData = data2;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};
(function(exports) {
  var debug2 = browser$1.exports("socket.io-parser");
  var Emitter2 = componentEmitter.exports;
  var binary$1 = binary;
  var isArray2 = isarray;
  var isBuf2 = isBuffer2;
  exports.protocol = 4;
  exports.types = [
    "CONNECT",
    "DISCONNECT",
    "EVENT",
    "ACK",
    "ERROR",
    "BINARY_EVENT",
    "BINARY_ACK"
  ];
  exports.CONNECT = 0;
  exports.DISCONNECT = 1;
  exports.EVENT = 2;
  exports.ACK = 3;
  exports.ERROR = 4;
  exports.BINARY_EVENT = 5;
  exports.BINARY_ACK = 6;
  exports.Encoder = Encoder;
  exports.Decoder = Decoder;
  function Encoder() {
  }
  var ERROR_PACKET = exports.ERROR + '"encode error"';
  Encoder.prototype.encode = function(obj, callback) {
    debug2("encoding packet %j", obj);
    if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
      encodeAsBinary(obj, callback);
    } else {
      var encoding = encodeAsString(obj);
      callback([encoding]);
    }
  };
  function encodeAsString(obj) {
    var str = "" + obj.type;
    if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
      str += obj.attachments + "-";
    }
    if (obj.nsp && obj.nsp !== "/") {
      str += obj.nsp + ",";
    }
    if (obj.id != null) {
      str += obj.id;
    }
    if (obj.data != null) {
      var payload = tryStringify(obj.data);
      if (payload !== false) {
        str += payload;
      } else {
        return ERROR_PACKET;
      }
    }
    debug2("encoded %j as %s", obj, str);
    return str;
  }
  function tryStringify(str) {
    try {
      return JSON.stringify(str);
    } catch (e) {
      return false;
    }
  }
  function encodeAsBinary(obj, callback) {
    function writeEncoding(bloblessData) {
      var deconstruction = binary$1.deconstructPacket(bloblessData);
      var pack = encodeAsString(deconstruction.packet);
      var buffers = deconstruction.buffers;
      buffers.unshift(pack);
      callback(buffers);
    }
    binary$1.removeBlobs(obj, writeEncoding);
  }
  function Decoder() {
    this.reconstructor = null;
  }
  Emitter2(Decoder.prototype);
  Decoder.prototype.add = function(obj) {
    var packet;
    if (typeof obj === "string") {
      packet = decodeString(obj);
      if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) {
        this.reconstructor = new BinaryReconstructor(packet);
        if (this.reconstructor.reconPack.attachments === 0) {
          this.emit("decoded", packet);
        }
      } else {
        this.emit("decoded", packet);
      }
    } else if (isBuf2(obj) || obj.base64) {
      if (!this.reconstructor) {
        throw new Error("got binary data when not reconstructing a packet");
      } else {
        packet = this.reconstructor.takeBinaryData(obj);
        if (packet) {
          this.reconstructor = null;
          this.emit("decoded", packet);
        }
      }
    } else {
      throw new Error("Unknown type: " + obj);
    }
  };
  function decodeString(str) {
    var i2 = 0;
    var p = {
      type: Number(str.charAt(0))
    };
    if (exports.types[p.type] == null) {
      return error("unknown packet type " + p.type);
    }
    if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
      var start = i2 + 1;
      while (str.charAt(++i2) !== "-" && i2 != str.length) {
      }
      var buf = str.substring(start, i2);
      if (buf != Number(buf) || str.charAt(i2) !== "-") {
        throw new Error("Illegal attachments");
      }
      p.attachments = Number(buf);
    }
    if (str.charAt(i2 + 1) === "/") {
      var start = i2 + 1;
      while (++i2) {
        var c = str.charAt(i2);
        if (c === ",")
          break;
        if (i2 === str.length)
          break;
      }
      p.nsp = str.substring(start, i2);
    } else {
      p.nsp = "/";
    }
    var next = str.charAt(i2 + 1);
    if (next !== "" && Number(next) == next) {
      var start = i2 + 1;
      while (++i2) {
        var c = str.charAt(i2);
        if (c == null || Number(c) != c) {
          --i2;
          break;
        }
        if (i2 === str.length)
          break;
      }
      p.id = Number(str.substring(start, i2 + 1));
    }
    if (str.charAt(++i2)) {
      var payload = tryParse(str.substr(i2));
      var isPayloadValid = payload !== false && (p.type === exports.ERROR || isArray2(payload));
      if (isPayloadValid) {
        p.data = payload;
      } else {
        return error("invalid payload");
      }
    }
    debug2("decoded %s as %j", str, p);
    return p;
  }
  function tryParse(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return false;
    }
  }
  Decoder.prototype.destroy = function() {
    if (this.reconstructor) {
      this.reconstructor.finishedReconstruction();
    }
  };
  function BinaryReconstructor(packet) {
    this.reconPack = packet;
    this.buffers = [];
  }
  BinaryReconstructor.prototype.takeBinaryData = function(binData) {
    this.buffers.push(binData);
    if (this.buffers.length === this.reconPack.attachments) {
      var packet = binary$1.reconstructPacket(this.reconPack, this.buffers);
      this.finishedReconstruction();
      return packet;
    }
    return null;
  };
  BinaryReconstructor.prototype.finishedReconstruction = function() {
    this.reconPack = null;
    this.buffers = [];
  };
  function error(msg) {
    return {
      type: exports.ERROR,
      data: "parser error: " + msg
    };
  }
})(socket_ioParser);
var lib = { exports: {} };
var transports$1 = {};
var hasCors = { exports: {} };
try {
  hasCors.exports = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
  hasCors.exports = false;
}
var globalThis_browser = function() {
  if (typeof self !== "undefined") {
    return self;
  } else if (typeof window !== "undefined") {
    return window;
  } else {
    return Function("return this")();
  }
}();
var hasCORS = hasCors.exports;
var globalThis$2 = globalThis_browser;
var xmlhttprequest = function(opts) {
  var xdomain = opts.xdomain;
  var xscheme = opts.xscheme;
  var enablesXDR = opts.enablesXDR;
  try {
    if (typeof XMLHttpRequest !== "undefined" && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) {
  }
  try {
    if (typeof XDomainRequest !== "undefined" && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) {
  }
  if (!xdomain) {
    try {
      return new globalThis$2[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {
    }
  }
};
var pollingXhr = { exports: {} };
var browser = {};
var keys = Object.keys || function keys2(obj) {
  var arr = [];
  var has2 = Object.prototype.hasOwnProperty;
  for (var i2 in obj) {
    if (has2.call(obj, i2)) {
      arr.push(i2);
    }
  }
  return arr;
};
var isArray = isarray;
var toString2 = Object.prototype.toString;
var withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && toString2.call(Blob) === "[object BlobConstructor]";
var withNativeFile = typeof File === "function" || typeof File !== "undefined" && toString2.call(File) === "[object FileConstructor]";
var hasBinary2 = hasBinary;
function hasBinary(obj) {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  if (isArray(obj)) {
    for (var i2 = 0, l = obj.length; i2 < l; i2++) {
      if (hasBinary(obj[i2])) {
        return true;
      }
    }
    return false;
  }
  if (typeof Buffer === "function" && Buffer.isBuffer && Buffer.isBuffer(obj) || typeof ArrayBuffer === "function" && obj instanceof ArrayBuffer || withNativeBlob && obj instanceof Blob || withNativeFile && obj instanceof File) {
    return true;
  }
  if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) {
    return hasBinary(obj.toJSON(), true);
  }
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
      return true;
    }
  }
  return false;
}
var arraybuffer_slice = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;
  if (arraybuffer.slice) {
    return arraybuffer.slice(start, end);
  }
  if (start < 0) {
    start += bytes;
  }
  if (end < 0) {
    end += bytes;
  }
  if (end > bytes) {
    end = bytes;
  }
  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }
  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i2 = start, ii = 0; i2 < end; i2++, ii++) {
    result[ii] = abv[i2];
  }
  return result.buffer;
};
var after_1 = after;
function after(count, callback, err_cb) {
  var bail = false;
  err_cb = err_cb || noop;
  proxy.count = count;
  return count === 0 ? callback() : proxy;
  function proxy(err, result) {
    if (proxy.count <= 0) {
      throw new Error("after called too many times");
    }
    --proxy.count;
    if (err) {
      bail = true;
      callback(err);
      callback = err_cb;
    } else if (proxy.count === 0 && !bail) {
      callback(null, result);
    }
  }
}
function noop() {
}
/*! https://mths.be/utf8js v2.1.2 by @mathias */
var stringFromCharCode = String.fromCharCode;
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length2 = string.length;
  var value;
  var extra;
  while (counter < length2) {
    value = string.charCodeAt(counter++);
    if (value >= 55296 && value <= 56319 && counter < length2) {
      extra = string.charCodeAt(counter++);
      if ((extra & 64512) == 56320) {
        output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
}
function ucs2encode(array) {
  var length2 = array.length;
  var index2 = -1;
  var value;
  var output = "";
  while (++index2 < length2) {
    value = array[index2];
    if (value > 65535) {
      value -= 65536;
      output += stringFromCharCode(value >>> 10 & 1023 | 55296);
      value = 56320 | value & 1023;
    }
    output += stringFromCharCode(value);
  }
  return output;
}
function checkScalarValue(codePoint, strict) {
  if (codePoint >= 55296 && codePoint <= 57343) {
    if (strict) {
      throw Error("Lone surrogate U+" + codePoint.toString(16).toUpperCase() + " is not a scalar value");
    }
    return false;
  }
  return true;
}
function createByte(codePoint, shift) {
  return stringFromCharCode(codePoint >> shift & 63 | 128);
}
function encodeCodePoint(codePoint, strict) {
  if ((codePoint & 4294967168) == 0) {
    return stringFromCharCode(codePoint);
  }
  var symbol = "";
  if ((codePoint & 4294965248) == 0) {
    symbol = stringFromCharCode(codePoint >> 6 & 31 | 192);
  } else if ((codePoint & 4294901760) == 0) {
    if (!checkScalarValue(codePoint, strict)) {
      codePoint = 65533;
    }
    symbol = stringFromCharCode(codePoint >> 12 & 15 | 224);
    symbol += createByte(codePoint, 6);
  } else if ((codePoint & 4292870144) == 0) {
    symbol = stringFromCharCode(codePoint >> 18 & 7 | 240);
    symbol += createByte(codePoint, 12);
    symbol += createByte(codePoint, 6);
  }
  symbol += stringFromCharCode(codePoint & 63 | 128);
  return symbol;
}
function utf8encode(string, opts) {
  opts = opts || {};
  var strict = opts.strict !== false;
  var codePoints = ucs2decode(string);
  var length2 = codePoints.length;
  var index2 = -1;
  var codePoint;
  var byteString = "";
  while (++index2 < length2) {
    codePoint = codePoints[index2];
    byteString += encodeCodePoint(codePoint, strict);
  }
  return byteString;
}
function readContinuationByte() {
  if (byteIndex >= byteCount) {
    throw Error("Invalid byte index");
  }
  var continuationByte = byteArray[byteIndex] & 255;
  byteIndex++;
  if ((continuationByte & 192) == 128) {
    return continuationByte & 63;
  }
  throw Error("Invalid continuation byte");
}
function decodeSymbol(strict) {
  var byte1;
  var byte2;
  var byte3;
  var byte4;
  var codePoint;
  if (byteIndex > byteCount) {
    throw Error("Invalid byte index");
  }
  if (byteIndex == byteCount) {
    return false;
  }
  byte1 = byteArray[byteIndex] & 255;
  byteIndex++;
  if ((byte1 & 128) == 0) {
    return byte1;
  }
  if ((byte1 & 224) == 192) {
    byte2 = readContinuationByte();
    codePoint = (byte1 & 31) << 6 | byte2;
    if (codePoint >= 128) {
      return codePoint;
    } else {
      throw Error("Invalid continuation byte");
    }
  }
  if ((byte1 & 240) == 224) {
    byte2 = readContinuationByte();
    byte3 = readContinuationByte();
    codePoint = (byte1 & 15) << 12 | byte2 << 6 | byte3;
    if (codePoint >= 2048) {
      return checkScalarValue(codePoint, strict) ? codePoint : 65533;
    } else {
      throw Error("Invalid continuation byte");
    }
  }
  if ((byte1 & 248) == 240) {
    byte2 = readContinuationByte();
    byte3 = readContinuationByte();
    byte4 = readContinuationByte();
    codePoint = (byte1 & 7) << 18 | byte2 << 12 | byte3 << 6 | byte4;
    if (codePoint >= 65536 && codePoint <= 1114111) {
      return codePoint;
    }
  }
  throw Error("Invalid UTF-8 detected");
}
var byteArray;
var byteCount;
var byteIndex;
function utf8decode(byteString, opts) {
  opts = opts || {};
  var strict = opts.strict !== false;
  byteArray = ucs2decode(byteString);
  byteCount = byteArray.length;
  byteIndex = 0;
  var codePoints = [];
  var tmp;
  while ((tmp = decodeSymbol(strict)) !== false) {
    codePoints.push(tmp);
  }
  return ucs2encode(codePoints);
}
var utf8 = {
  version: "2.1.2",
  encode: utf8encode,
  decode: utf8decode
};
var base64Arraybuffer = {};
(function(chars) {
  base64Arraybuffer.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for (i2 = 0; i2 < len; i2 += 3) {
      base64 += chars[bytes[i2] >> 2];
      base64 += chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
      base64 += chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
      base64 += chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }
    return base64;
  };
  base64Arraybuffer.decode = function(base64) {
    var bufferLength = base64.length * 0.75, len = base64.length, i2, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }
    var arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for (i2 = 0; i2 < len; i2 += 4) {
      encoded1 = chars.indexOf(base64[i2]);
      encoded2 = chars.indexOf(base64[i2 + 1]);
      encoded3 = chars.indexOf(base64[i2 + 2]);
      encoded4 = chars.indexOf(base64[i2 + 3]);
      bytes[p++] = encoded1 << 2 | encoded2 >> 4;
      bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
      bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
  };
})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");
var BlobBuilder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof WebKitBlobBuilder !== "undefined" ? WebKitBlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : false;
var blobSupported = function() {
  try {
    var a = new Blob(["hi"]);
    return a.size === 2;
  } catch (e) {
    return false;
  }
}();
var blobSupportsArrayBufferView = blobSupported && function() {
  try {
    var b = new Blob([new Uint8Array([1, 2])]);
    return b.size === 2;
  } catch (e) {
    return false;
  }
}();
var blobBuilderSupported = BlobBuilder && BlobBuilder.prototype.append && BlobBuilder.prototype.getBlob;
function mapArrayBufferViews(ary) {
  return ary.map(function(chunk) {
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }
      return buf;
    }
    return chunk;
  });
}
function BlobBuilderConstructor(ary, options) {
  options = options || {};
  var bb = new BlobBuilder();
  mapArrayBufferViews(ary).forEach(function(part) {
    bb.append(part);
  });
  return options.type ? bb.getBlob(options.type) : bb.getBlob();
}
function BlobConstructor(ary, options) {
  return new Blob(mapArrayBufferViews(ary), options || {});
}
if (typeof Blob !== "undefined") {
  BlobBuilderConstructor.prototype = Blob.prototype;
  BlobConstructor.prototype = Blob.prototype;
}
var blob = function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return void 0;
  }
}();
(function(exports) {
  var keys$1 = keys;
  var hasBinary3 = hasBinary2;
  var sliceBuffer = arraybuffer_slice;
  var after2 = after_1;
  var utf8$1 = utf8;
  var base64encoder;
  if (typeof ArrayBuffer !== "undefined") {
    base64encoder = base64Arraybuffer;
  }
  var isAndroid = typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent);
  var isPhantomJS = typeof navigator !== "undefined" && /PhantomJS/i.test(navigator.userAgent);
  var dontSendBlobs = isAndroid || isPhantomJS;
  exports.protocol = 3;
  var packets = exports.packets = {
    open: 0,
    close: 1,
    ping: 2,
    pong: 3,
    message: 4,
    upgrade: 5,
    noop: 6
  };
  var packetslist = keys$1(packets);
  var err = { type: "error", data: "parser error" };
  var Blob2 = blob;
  exports.encodePacket = function(packet, supportsBinary, utf8encode2, callback) {
    if (typeof supportsBinary === "function") {
      callback = supportsBinary;
      supportsBinary = false;
    }
    if (typeof utf8encode2 === "function") {
      callback = utf8encode2;
      utf8encode2 = null;
    }
    var data2 = packet.data === void 0 ? void 0 : packet.data.buffer || packet.data;
    if (typeof ArrayBuffer !== "undefined" && data2 instanceof ArrayBuffer) {
      return encodeArrayBuffer(packet, supportsBinary, callback);
    } else if (typeof Blob2 !== "undefined" && data2 instanceof Blob2) {
      return encodeBlob(packet, supportsBinary, callback);
    }
    if (data2 && data2.base64) {
      return encodeBase64Object(packet, callback);
    }
    var encoded = packets[packet.type];
    if (packet.data !== void 0) {
      encoded += utf8encode2 ? utf8$1.encode(String(packet.data), { strict: false }) : String(packet.data);
    }
    return callback("" + encoded);
  };
  function encodeBase64Object(packet, callback) {
    var message = "b" + exports.packets[packet.type] + packet.data.data;
    return callback(message);
  }
  function encodeArrayBuffer(packet, supportsBinary, callback) {
    if (!supportsBinary) {
      return exports.encodeBase64Packet(packet, callback);
    }
    var data2 = packet.data;
    var contentArray = new Uint8Array(data2);
    var resultBuffer = new Uint8Array(1 + data2.byteLength);
    resultBuffer[0] = packets[packet.type];
    for (var i2 = 0; i2 < contentArray.length; i2++) {
      resultBuffer[i2 + 1] = contentArray[i2];
    }
    return callback(resultBuffer.buffer);
  }
  function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
    if (!supportsBinary) {
      return exports.encodeBase64Packet(packet, callback);
    }
    var fr = new FileReader();
    fr.onload = function() {
      exports.encodePacket({ type: packet.type, data: fr.result }, supportsBinary, true, callback);
    };
    return fr.readAsArrayBuffer(packet.data);
  }
  function encodeBlob(packet, supportsBinary, callback) {
    if (!supportsBinary) {
      return exports.encodeBase64Packet(packet, callback);
    }
    if (dontSendBlobs) {
      return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
    }
    var length2 = new Uint8Array(1);
    length2[0] = packets[packet.type];
    var blob2 = new Blob2([length2.buffer, packet.data]);
    return callback(blob2);
  }
  exports.encodeBase64Packet = function(packet, callback) {
    var message = "b" + exports.packets[packet.type];
    if (typeof Blob2 !== "undefined" && packet.data instanceof Blob2) {
      var fr = new FileReader();
      fr.onload = function() {
        var b64 = fr.result.split(",")[1];
        callback(message + b64);
      };
      return fr.readAsDataURL(packet.data);
    }
    var b64data;
    try {
      b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
    } catch (e) {
      var typed = new Uint8Array(packet.data);
      var basic = new Array(typed.length);
      for (var i2 = 0; i2 < typed.length; i2++) {
        basic[i2] = typed[i2];
      }
      b64data = String.fromCharCode.apply(null, basic);
    }
    message += btoa(b64data);
    return callback(message);
  };
  exports.decodePacket = function(data2, binaryType, utf8decode2) {
    if (data2 === void 0) {
      return err;
    }
    if (typeof data2 === "string") {
      if (data2.charAt(0) === "b") {
        return exports.decodeBase64Packet(data2.substr(1), binaryType);
      }
      if (utf8decode2) {
        data2 = tryDecode(data2);
        if (data2 === false) {
          return err;
        }
      }
      var type = data2.charAt(0);
      if (Number(type) != type || !packetslist[type]) {
        return err;
      }
      if (data2.length > 1) {
        return { type: packetslist[type], data: data2.substring(1) };
      } else {
        return { type: packetslist[type] };
      }
    }
    var asArray = new Uint8Array(data2);
    var type = asArray[0];
    var rest = sliceBuffer(data2, 1);
    if (Blob2 && binaryType === "blob") {
      rest = new Blob2([rest]);
    }
    return { type: packetslist[type], data: rest };
  };
  function tryDecode(data2) {
    try {
      data2 = utf8$1.decode(data2, { strict: false });
    } catch (e) {
      return false;
    }
    return data2;
  }
  exports.decodeBase64Packet = function(msg, binaryType) {
    var type = packetslist[msg.charAt(0)];
    if (!base64encoder) {
      return { type, data: { base64: true, data: msg.substr(1) } };
    }
    var data2 = base64encoder.decode(msg.substr(1));
    if (binaryType === "blob" && Blob2) {
      data2 = new Blob2([data2]);
    }
    return { type, data: data2 };
  };
  exports.encodePayload = function(packets2, supportsBinary, callback) {
    if (typeof supportsBinary === "function") {
      callback = supportsBinary;
      supportsBinary = null;
    }
    var isBinary = hasBinary3(packets2);
    if (supportsBinary && isBinary) {
      if (Blob2 && !dontSendBlobs) {
        return exports.encodePayloadAsBlob(packets2, callback);
      }
      return exports.encodePayloadAsArrayBuffer(packets2, callback);
    }
    if (!packets2.length) {
      return callback("0:");
    }
    function setLengthHeader(message) {
      return message.length + ":" + message;
    }
    function encodeOne(packet, doneCallback) {
      exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
        doneCallback(null, setLengthHeader(message));
      });
    }
    map2(packets2, encodeOne, function(err2, results) {
      return callback(results.join(""));
    });
  };
  function map2(ary, each, done) {
    var result = new Array(ary.length);
    var next = after2(ary.length, done);
    var eachWithIndex = function(i3, el, cb) {
      each(el, function(error, msg) {
        result[i3] = msg;
        cb(error, result);
      });
    };
    for (var i2 = 0; i2 < ary.length; i2++) {
      eachWithIndex(i2, ary[i2], next);
    }
  }
  exports.decodePayload = function(data2, binaryType, callback) {
    if (typeof data2 !== "string") {
      return exports.decodePayloadAsBinary(data2, binaryType, callback);
    }
    if (typeof binaryType === "function") {
      callback = binaryType;
      binaryType = null;
    }
    var packet;
    if (data2 === "") {
      return callback(err, 0, 1);
    }
    var length2 = "", n, msg;
    for (var i2 = 0, l = data2.length; i2 < l; i2++) {
      var chr = data2.charAt(i2);
      if (chr !== ":") {
        length2 += chr;
        continue;
      }
      if (length2 === "" || length2 != (n = Number(length2))) {
        return callback(err, 0, 1);
      }
      msg = data2.substr(i2 + 1, n);
      if (length2 != msg.length) {
        return callback(err, 0, 1);
      }
      if (msg.length) {
        packet = exports.decodePacket(msg, binaryType, false);
        if (err.type === packet.type && err.data === packet.data) {
          return callback(err, 0, 1);
        }
        var ret = callback(packet, i2 + n, l);
        if (ret === false)
          return;
      }
      i2 += n;
      length2 = "";
    }
    if (length2 !== "") {
      return callback(err, 0, 1);
    }
  };
  exports.encodePayloadAsArrayBuffer = function(packets2, callback) {
    if (!packets2.length) {
      return callback(new ArrayBuffer(0));
    }
    function encodeOne(packet, doneCallback) {
      exports.encodePacket(packet, true, true, function(data2) {
        return doneCallback(null, data2);
      });
    }
    map2(packets2, encodeOne, function(err2, encodedPackets) {
      var totalLength = encodedPackets.reduce(function(acc, p) {
        var len;
        if (typeof p === "string") {
          len = p.length;
        } else {
          len = p.byteLength;
        }
        return acc + len.toString().length + len + 2;
      }, 0);
      var resultArray = new Uint8Array(totalLength);
      var bufferIndex = 0;
      encodedPackets.forEach(function(p) {
        var isString2 = typeof p === "string";
        var ab = p;
        if (isString2) {
          var view = new Uint8Array(p.length);
          for (var i2 = 0; i2 < p.length; i2++) {
            view[i2] = p.charCodeAt(i2);
          }
          ab = view.buffer;
        }
        if (isString2) {
          resultArray[bufferIndex++] = 0;
        } else {
          resultArray[bufferIndex++] = 1;
        }
        var lenStr = ab.byteLength.toString();
        for (var i2 = 0; i2 < lenStr.length; i2++) {
          resultArray[bufferIndex++] = parseInt(lenStr[i2]);
        }
        resultArray[bufferIndex++] = 255;
        var view = new Uint8Array(ab);
        for (var i2 = 0; i2 < view.length; i2++) {
          resultArray[bufferIndex++] = view[i2];
        }
      });
      return callback(resultArray.buffer);
    });
  };
  exports.encodePayloadAsBlob = function(packets2, callback) {
    function encodeOne(packet, doneCallback) {
      exports.encodePacket(packet, true, true, function(encoded) {
        var binaryIdentifier = new Uint8Array(1);
        binaryIdentifier[0] = 1;
        if (typeof encoded === "string") {
          var view = new Uint8Array(encoded.length);
          for (var i2 = 0; i2 < encoded.length; i2++) {
            view[i2] = encoded.charCodeAt(i2);
          }
          encoded = view.buffer;
          binaryIdentifier[0] = 0;
        }
        var len = encoded instanceof ArrayBuffer ? encoded.byteLength : encoded.size;
        var lenStr = len.toString();
        var lengthAry = new Uint8Array(lenStr.length + 1);
        for (var i2 = 0; i2 < lenStr.length; i2++) {
          lengthAry[i2] = parseInt(lenStr[i2]);
        }
        lengthAry[lenStr.length] = 255;
        if (Blob2) {
          var blob2 = new Blob2([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
          doneCallback(null, blob2);
        }
      });
    }
    map2(packets2, encodeOne, function(err2, results) {
      return callback(new Blob2(results));
    });
  };
  exports.decodePayloadAsBinary = function(data2, binaryType, callback) {
    if (typeof binaryType === "function") {
      callback = binaryType;
      binaryType = null;
    }
    var bufferTail = data2;
    var buffers = [];
    while (bufferTail.byteLength > 0) {
      var tailArray = new Uint8Array(bufferTail);
      var isString2 = tailArray[0] === 0;
      var msgLength = "";
      for (var i2 = 1; ; i2++) {
        if (tailArray[i2] === 255)
          break;
        if (msgLength.length > 310) {
          return callback(err, 0, 1);
        }
        msgLength += tailArray[i2];
      }
      bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
      msgLength = parseInt(msgLength);
      var msg = sliceBuffer(bufferTail, 0, msgLength);
      if (isString2) {
        try {
          msg = String.fromCharCode.apply(null, new Uint8Array(msg));
        } catch (e) {
          var typed = new Uint8Array(msg);
          msg = "";
          for (var i2 = 0; i2 < typed.length; i2++) {
            msg += String.fromCharCode(typed[i2]);
          }
        }
      }
      buffers.push(msg);
      bufferTail = sliceBuffer(bufferTail, msgLength);
    }
    var total = buffers.length;
    buffers.forEach(function(buffer, i3) {
      callback(exports.decodePacket(buffer, binaryType, true), i3, total);
    });
  };
})(browser);
var parser$4 = browser;
var Emitter$3 = componentEmitter.exports;
var transport = Transport$2;
function Transport$2(opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = "";
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;
  this.withCredentials = opts.withCredentials;
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;
  this.isReactNative = opts.isReactNative;
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}
Emitter$3(Transport$2.prototype);
Transport$2.prototype.onError = function(msg, desc) {
  var err = new Error(msg);
  err.type = "TransportError";
  err.description = desc;
  this.emit("error", err);
  return this;
};
Transport$2.prototype.open = function() {
  if (this.readyState === "closed" || this.readyState === "") {
    this.readyState = "opening";
    this.doOpen();
  }
  return this;
};
Transport$2.prototype.close = function() {
  if (this.readyState === "opening" || this.readyState === "open") {
    this.doClose();
    this.onClose();
  }
  return this;
};
Transport$2.prototype.send = function(packets) {
  if (this.readyState === "open") {
    this.write(packets);
  } else {
    throw new Error("Transport not open");
  }
};
Transport$2.prototype.onOpen = function() {
  this.readyState = "open";
  this.writable = true;
  this.emit("open");
};
Transport$2.prototype.onData = function(data2) {
  var packet = parser$4.decodePacket(data2, this.socket.binaryType);
  this.onPacket(packet);
};
Transport$2.prototype.onPacket = function(packet) {
  this.emit("packet", packet);
};
Transport$2.prototype.onClose = function() {
  this.readyState = "closed";
  this.emit("close");
};
var parseqs$3 = {};
parseqs$3.encode = function(obj) {
  var str = "";
  for (var i2 in obj) {
    if (obj.hasOwnProperty(i2)) {
      if (str.length)
        str += "&";
      str += encodeURIComponent(i2) + "=" + encodeURIComponent(obj[i2]);
    }
  }
  return str;
};
parseqs$3.decode = function(qs) {
  var qry = {};
  var pairs = qs.split("&");
  for (var i2 = 0, l = pairs.length; i2 < l; i2++) {
    var pair = pairs[i2].split("=");
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};
var componentInherit = function(a, b) {
  var fn = function() {
  };
  fn.prototype = b.prototype;
  a.prototype = new fn();
  a.prototype.constructor = a;
};
var alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), length = 64, map = {}, seed = 0, i = 0, prev;
function encode2(num) {
  var encoded = "";
  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);
  return encoded;
}
function decode(str) {
  var decoded = 0;
  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }
  return decoded;
}
function yeast$2() {
  var now = encode2(+new Date());
  if (now !== prev)
    return seed = 0, prev = now;
  return now + "." + encode2(seed++);
}
for (; i < length; i++)
  map[alphabet[i]] = i;
yeast$2.encode = encode2;
yeast$2.decode = decode;
var yeast_1 = yeast$2;
var Transport$1 = transport;
var parseqs$2 = parseqs$3;
var parser$3 = browser;
var inherit$3 = componentInherit;
var yeast$1 = yeast_1;
var debug$4 = browser$1.exports("engine.io-client:polling");
var polling$1 = Polling$2;
var hasXHR2 = function() {
  var XMLHttpRequest2 = xmlhttprequest;
  var xhr2 = new XMLHttpRequest2({ xdomain: false });
  return xhr2.responseType != null;
}();
function Polling$2(opts) {
  var forceBase64 = opts && opts.forceBase64;
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport$1.call(this, opts);
}
inherit$3(Polling$2, Transport$1);
Polling$2.prototype.name = "polling";
Polling$2.prototype.doOpen = function() {
  this.poll();
};
Polling$2.prototype.pause = function(onPause) {
  var self2 = this;
  this.readyState = "pausing";
  function pause() {
    debug$4("paused");
    self2.readyState = "paused";
    onPause();
  }
  if (this.polling || !this.writable) {
    var total = 0;
    if (this.polling) {
      debug$4("we are currently polling - waiting to pause");
      total++;
      this.once("pollComplete", function() {
        debug$4("pre-pause polling complete");
        --total || pause();
      });
    }
    if (!this.writable) {
      debug$4("we are currently writing - waiting to pause");
      total++;
      this.once("drain", function() {
        debug$4("pre-pause writing complete");
        --total || pause();
      });
    }
  } else {
    pause();
  }
};
Polling$2.prototype.poll = function() {
  debug$4("polling");
  this.polling = true;
  this.doPoll();
  this.emit("poll");
};
Polling$2.prototype.onData = function(data2) {
  var self2 = this;
  debug$4("polling got data %s", data2);
  var callback = function(packet, index2, total) {
    if (self2.readyState === "opening" && packet.type === "open") {
      self2.onOpen();
    }
    if (packet.type === "close") {
      self2.onClose();
      return false;
    }
    self2.onPacket(packet);
  };
  parser$3.decodePayload(data2, this.socket.binaryType, callback);
  if (this.readyState !== "closed") {
    this.polling = false;
    this.emit("pollComplete");
    if (this.readyState === "open") {
      this.poll();
    } else {
      debug$4('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};
Polling$2.prototype.doClose = function() {
  var self2 = this;
  function close() {
    debug$4("writing close packet");
    self2.write([{ type: "close" }]);
  }
  if (this.readyState === "open") {
    debug$4("transport open - closing");
    close();
  } else {
    debug$4("transport not open - deferring close");
    this.once("open", close);
  }
};
Polling$2.prototype.write = function(packets) {
  var self2 = this;
  this.writable = false;
  var callbackfn = function() {
    self2.writable = true;
    self2.emit("drain");
  };
  parser$3.encodePayload(packets, this.supportsBinary, function(data2) {
    self2.doWrite(data2, callbackfn);
  });
};
Polling$2.prototype.uri = function() {
  var query = this.query || {};
  var schema = this.secure ? "https" : "http";
  var port = "";
  if (this.timestampRequests !== false) {
    query[this.timestampParam] = yeast$1();
  }
  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }
  query = parseqs$2.encode(query);
  if (this.port && (schema === "https" && Number(this.port) !== 443 || schema === "http" && Number(this.port) !== 80)) {
    port = ":" + this.port;
  }
  if (query.length) {
    query = "?" + query;
  }
  var ipv6 = this.hostname.indexOf(":") !== -1;
  return schema + "://" + (ipv6 ? "[" + this.hostname + "]" : this.hostname) + port + this.path + query;
};
var XMLHttpRequest$2 = xmlhttprequest;
var Polling$1 = polling$1;
var Emitter$2 = componentEmitter.exports;
var inherit$2 = componentInherit;
var debug$3 = browser$1.exports("engine.io-client:polling-xhr");
var globalThis$1 = globalThis_browser;
pollingXhr.exports = XHR$1;
pollingXhr.exports.Request = Request;
function empty$1() {
}
function XHR$1(opts) {
  Polling$1.call(this, opts);
  this.requestTimeout = opts.requestTimeout;
  this.extraHeaders = opts.extraHeaders;
  if (typeof location !== "undefined") {
    var isSSL = location.protocol === "https:";
    var port = location.port;
    if (!port) {
      port = isSSL ? 443 : 80;
    }
    this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
    this.xs = opts.secure !== isSSL;
  }
}
inherit$2(XHR$1, Polling$1);
XHR$1.prototype.supportsBinary = true;
XHR$1.prototype.request = function(opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;
  opts.withCredentials = this.withCredentials;
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;
  opts.extraHeaders = this.extraHeaders;
  return new Request(opts);
};
XHR$1.prototype.doWrite = function(data2, fn) {
  var isBinary = typeof data2 !== "string" && data2 !== void 0;
  var req = this.request({ method: "POST", data: data2, isBinary });
  var self2 = this;
  req.on("success", fn);
  req.on("error", function(err) {
    self2.onError("xhr post error", err);
  });
  this.sendXhr = req;
};
XHR$1.prototype.doPoll = function() {
  debug$3("xhr poll");
  var req = this.request();
  var self2 = this;
  req.on("data", function(data2) {
    self2.onData(data2);
  });
  req.on("error", function(err) {
    self2.onError("xhr poll error", err);
  });
  this.pollXhr = req;
};
function Request(opts) {
  this.method = opts.method || "GET";
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = opts.async !== false;
  this.data = opts.data !== void 0 ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.withCredentials = opts.withCredentials;
  this.requestTimeout = opts.requestTimeout;
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.extraHeaders = opts.extraHeaders;
  this.create();
}
Emitter$2(Request.prototype);
Request.prototype.create = function() {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  var xhr2 = this.xhr = new XMLHttpRequest$2(opts);
  var self2 = this;
  try {
    debug$3("xhr open %s: %s", this.method, this.uri);
    xhr2.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr2.setDisableHeaderCheck && xhr2.setDisableHeaderCheck(true);
        for (var i2 in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i2)) {
            xhr2.setRequestHeader(i2, this.extraHeaders[i2]);
          }
        }
      }
    } catch (e) {
    }
    if (this.method === "POST") {
      try {
        if (this.isBinary) {
          xhr2.setRequestHeader("Content-type", "application/octet-stream");
        } else {
          xhr2.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        }
      } catch (e) {
      }
    }
    try {
      xhr2.setRequestHeader("Accept", "*/*");
    } catch (e) {
    }
    if ("withCredentials" in xhr2) {
      xhr2.withCredentials = this.withCredentials;
    }
    if (this.requestTimeout) {
      xhr2.timeout = this.requestTimeout;
    }
    if (this.hasXDR()) {
      xhr2.onload = function() {
        self2.onLoad();
      };
      xhr2.onerror = function() {
        self2.onError(xhr2.responseText);
      };
    } else {
      xhr2.onreadystatechange = function() {
        if (xhr2.readyState === 2) {
          try {
            var contentType = xhr2.getResponseHeader("Content-Type");
            if (self2.supportsBinary && contentType === "application/octet-stream" || contentType === "application/octet-stream; charset=UTF-8") {
              xhr2.responseType = "arraybuffer";
            }
          } catch (e) {
          }
        }
        if (xhr2.readyState !== 4)
          return;
        if (xhr2.status === 200 || xhr2.status === 1223) {
          self2.onLoad();
        } else {
          setTimeout(function() {
            self2.onError(typeof xhr2.status === "number" ? xhr2.status : 0);
          }, 0);
        }
      };
    }
    debug$3("xhr data %s", this.data);
    xhr2.send(this.data);
  } catch (e) {
    setTimeout(function() {
      self2.onError(e);
    }, 0);
    return;
  }
  if (typeof document !== "undefined") {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};
Request.prototype.onSuccess = function() {
  this.emit("success");
  this.cleanup();
};
Request.prototype.onData = function(data2) {
  this.emit("data", data2);
  this.onSuccess();
};
Request.prototype.onError = function(err) {
  this.emit("error", err);
  this.cleanup(true);
};
Request.prototype.cleanup = function(fromError) {
  if (typeof this.xhr === "undefined" || this.xhr === null) {
    return;
  }
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty$1;
  } else {
    this.xhr.onreadystatechange = empty$1;
  }
  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e) {
    }
  }
  if (typeof document !== "undefined") {
    delete Request.requests[this.index];
  }
  this.xhr = null;
};
Request.prototype.onLoad = function() {
  var data2;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader("Content-Type");
    } catch (e) {
    }
    if (contentType === "application/octet-stream" || contentType === "application/octet-stream; charset=UTF-8") {
      data2 = this.xhr.response || this.xhr.responseText;
    } else {
      data2 = this.xhr.responseText;
    }
  } catch (e) {
    this.onError(e);
  }
  if (data2 != null) {
    this.onData(data2);
  }
};
Request.prototype.hasXDR = function() {
  return typeof XDomainRequest !== "undefined" && !this.xs && this.enablesXDR;
};
Request.prototype.abort = function() {
  this.cleanup();
};
Request.requestsCount = 0;
Request.requests = {};
if (typeof document !== "undefined") {
  if (typeof attachEvent === "function") {
    attachEvent("onunload", unloadHandler);
  } else if (typeof addEventListener === "function") {
    var terminationEvent = "onpagehide" in globalThis$1 ? "pagehide" : "unload";
    addEventListener(terminationEvent, unloadHandler, false);
  }
}
function unloadHandler() {
  for (var i2 in Request.requests) {
    if (Request.requests.hasOwnProperty(i2)) {
      Request.requests[i2].abort();
    }
  }
}
var Polling = polling$1;
var inherit$1 = componentInherit;
var globalThis = globalThis_browser;
var pollingJsonp = JSONPPolling;
var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;
var callbacks;
function empty() {
}
function JSONPPolling(opts) {
  Polling.call(this, opts);
  this.query = this.query || {};
  if (!callbacks) {
    callbacks = globalThis.___eio = globalThis.___eio || [];
  }
  this.index = callbacks.length;
  var self2 = this;
  callbacks.push(function(msg) {
    self2.onData(msg);
  });
  this.query.j = this.index;
  if (typeof addEventListener === "function") {
    addEventListener("beforeunload", function() {
      if (self2.script)
        self2.script.onerror = empty;
    }, false);
  }
}
inherit$1(JSONPPolling, Polling);
JSONPPolling.prototype.supportsBinary = false;
JSONPPolling.prototype.doClose = function() {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }
  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }
  Polling.prototype.doClose.call(this);
};
JSONPPolling.prototype.doPoll = function() {
  var self2 = this;
  var script = document.createElement("script");
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }
  script.async = true;
  script.src = this.uri();
  script.onerror = function(e) {
    self2.onError("jsonp poll error", e);
  };
  var insertAt = document.getElementsByTagName("script")[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;
  var isUAgecko = typeof navigator !== "undefined" && /gecko/i.test(navigator.userAgent);
  if (isUAgecko) {
    setTimeout(function() {
      var iframe = document.createElement("iframe");
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};
JSONPPolling.prototype.doWrite = function(data2, fn) {
  var self2 = this;
  if (!this.form) {
    var form = document.createElement("form");
    var area = document.createElement("textarea");
    var id = this.iframeId = "eio_iframe_" + this.index;
    var iframe;
    form.className = "socketio";
    form.style.position = "absolute";
    form.style.top = "-1000px";
    form.style.left = "-1000px";
    form.target = id;
    form.method = "POST";
    form.setAttribute("accept-charset", "utf-8");
    area.name = "d";
    form.appendChild(area);
    document.body.appendChild(form);
    this.form = form;
    this.area = area;
  }
  this.form.action = this.uri();
  function complete() {
    initIframe();
    fn();
  }
  function initIframe() {
    if (self2.iframe) {
      try {
        self2.form.removeChild(self2.iframe);
      } catch (e) {
        self2.onError("jsonp polling iframe removal error", e);
      }
    }
    try {
      var html = '<iframe src="javascript:0" name="' + self2.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement("iframe");
      iframe.name = self2.iframeId;
      iframe.src = "javascript:0";
    }
    iframe.id = self2.iframeId;
    self2.form.appendChild(iframe);
    self2.iframe = iframe;
  }
  initIframe();
  data2 = data2.replace(rEscapedNewline, "\\\n");
  this.area.value = data2.replace(rNewline, "\\n");
  try {
    this.form.submit();
  } catch (e) {
  }
  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function() {
      if (self2.iframe.readyState === "complete") {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};
var Transport = transport;
var parser$2 = browser;
var parseqs$1 = parseqs$3;
var inherit = componentInherit;
var yeast = yeast_1;
var debug$2 = browser$1.exports("engine.io-client:websocket");
var BrowserWebSocket, NodeWebSocket;
if (typeof WebSocket !== "undefined") {
  BrowserWebSocket = WebSocket;
} else if (typeof self !== "undefined") {
  BrowserWebSocket = self.WebSocket || self.MozWebSocket;
}
if (typeof window === "undefined") {
  try {
    NodeWebSocket = require$$6;
  } catch (e) {
  }
}
var WebSocketImpl = BrowserWebSocket || NodeWebSocket;
var websocket$1 = WS;
function WS(opts) {
  var forceBase64 = opts && opts.forceBase64;
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  this.protocols = opts.protocols;
  if (!this.usingBrowserWebSocket) {
    WebSocketImpl = NodeWebSocket;
  }
  Transport.call(this, opts);
}
inherit(WS, Transport);
WS.prototype.name = "websocket";
WS.prototype.supportsBinary = true;
WS.prototype.doOpen = function() {
  if (!this.check()) {
    return;
  }
  var uri = this.uri();
  var protocols = this.protocols;
  var opts = {};
  if (!this.isReactNative) {
    opts.agent = this.agent;
    opts.perMessageDeflate = this.perMessageDeflate;
    opts.pfx = this.pfx;
    opts.key = this.key;
    opts.passphrase = this.passphrase;
    opts.cert = this.cert;
    opts.ca = this.ca;
    opts.ciphers = this.ciphers;
    opts.rejectUnauthorized = this.rejectUnauthorized;
  }
  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }
  try {
    this.ws = this.usingBrowserWebSocket && !this.isReactNative ? protocols ? new WebSocketImpl(uri, protocols) : new WebSocketImpl(uri) : new WebSocketImpl(uri, protocols, opts);
  } catch (err) {
    return this.emit("error", err);
  }
  if (this.ws.binaryType === void 0) {
    this.supportsBinary = false;
  }
  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = "nodebuffer";
  } else {
    this.ws.binaryType = "arraybuffer";
  }
  this.addEventListeners();
};
WS.prototype.addEventListeners = function() {
  var self2 = this;
  this.ws.onopen = function() {
    self2.onOpen();
  };
  this.ws.onclose = function() {
    self2.onClose();
  };
  this.ws.onmessage = function(ev) {
    self2.onData(ev.data);
  };
  this.ws.onerror = function(e) {
    self2.onError("websocket error", e);
  };
};
WS.prototype.write = function(packets) {
  var self2 = this;
  this.writable = false;
  var total = packets.length;
  for (var i2 = 0, l = total; i2 < l; i2++) {
    (function(packet) {
      parser$2.encodePacket(packet, self2.supportsBinary, function(data2) {
        if (!self2.usingBrowserWebSocket) {
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }
          if (self2.perMessageDeflate) {
            var len = typeof data2 === "string" ? Buffer.byteLength(data2) : data2.length;
            if (len < self2.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }
        try {
          if (self2.usingBrowserWebSocket) {
            self2.ws.send(data2);
          } else {
            self2.ws.send(data2, opts);
          }
        } catch (e) {
          debug$2("websocket closed before onclose event");
        }
        --total || done();
      });
    })(packets[i2]);
  }
  function done() {
    self2.emit("flush");
    setTimeout(function() {
      self2.writable = true;
      self2.emit("drain");
    }, 0);
  }
};
WS.prototype.onClose = function() {
  Transport.prototype.onClose.call(this);
};
WS.prototype.doClose = function() {
  if (typeof this.ws !== "undefined") {
    this.ws.close();
  }
};
WS.prototype.uri = function() {
  var query = this.query || {};
  var schema = this.secure ? "wss" : "ws";
  var port = "";
  if (this.port && (schema === "wss" && Number(this.port) !== 443 || schema === "ws" && Number(this.port) !== 80)) {
    port = ":" + this.port;
  }
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }
  if (!this.supportsBinary) {
    query.b64 = 1;
  }
  query = parseqs$1.encode(query);
  if (query.length) {
    query = "?" + query;
  }
  var ipv6 = this.hostname.indexOf(":") !== -1;
  return schema + "://" + (ipv6 ? "[" + this.hostname + "]" : this.hostname) + port + this.path + query;
};
WS.prototype.check = function() {
  return !!WebSocketImpl && !("__initialize" in WebSocketImpl && this.name === WS.prototype.name);
};
var XMLHttpRequest$1 = xmlhttprequest;
var XHR = pollingXhr.exports;
var JSONP = pollingJsonp;
var websocket = websocket$1;
transports$1.polling = polling;
transports$1.websocket = websocket;
function polling(opts) {
  var xhr2;
  var xd = false;
  var xs = false;
  var jsonp = opts.jsonp !== false;
  if (typeof location !== "undefined") {
    var isSSL = location.protocol === "https:";
    var port = location.port;
    if (!port) {
      port = isSSL ? 443 : 80;
    }
    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }
  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr2 = new XMLHttpRequest$1(opts);
  if ("open" in xhr2 && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp)
      throw new Error("JSONP disabled");
    return new JSONP(opts);
  }
}
var indexOf$1 = [].indexOf;
var indexof = function(arr, obj) {
  if (indexOf$1)
    return arr.indexOf(obj);
  for (var i2 = 0; i2 < arr.length; ++i2) {
    if (arr[i2] === obj)
      return i2;
  }
  return -1;
};
var transports = transports$1;
var Emitter$1 = componentEmitter.exports;
var debug$1 = browser$1.exports("engine.io-client:socket");
var index = indexof;
var parser$1 = browser;
var parseuri2 = parseuri$2;
var parseqs = parseqs$3;
var socket$1 = Socket$1;
function Socket$1(uri, opts) {
  if (!(this instanceof Socket$1))
    return new Socket$1(uri, opts);
  opts = opts || {};
  if (uri && typeof uri === "object") {
    opts = uri;
    uri = null;
  }
  if (uri) {
    uri = parseuri2(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === "https" || uri.protocol === "wss";
    opts.port = uri.port;
    if (uri.query)
      opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri2(opts.host).host;
  }
  this.secure = opts.secure != null ? opts.secure : typeof location !== "undefined" && location.protocol === "https:";
  if (opts.hostname && !opts.port) {
    opts.port = this.secure ? "443" : "80";
  }
  this.agent = opts.agent || false;
  this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
  this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? 443 : 80);
  this.query = opts.query || {};
  if (typeof this.query === "string")
    this.query = parseqs.decode(this.query);
  this.upgrade = opts.upgrade !== false;
  this.path = (opts.path || "/engine.io").replace(/\/$/, "") + "/";
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = opts.jsonp !== false;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.withCredentials = opts.withCredentials !== false;
  this.timestampParam = opts.timestampParam || "t";
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ["polling", "websocket"];
  this.transportOptions = opts.transportOptions || {};
  this.readyState = "";
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = opts.perMessageDeflate !== false ? opts.perMessageDeflate || {} : false;
  if (this.perMessageDeflate === true)
    this.perMessageDeflate = {};
  if (this.perMessageDeflate && this.perMessageDeflate.threshold == null) {
    this.perMessageDeflate.threshold = 1024;
  }
  this.pfx = opts.pfx || void 0;
  this.key = opts.key || void 0;
  this.passphrase = opts.passphrase || void 0;
  this.cert = opts.cert || void 0;
  this.ca = opts.ca || void 0;
  this.ciphers = opts.ciphers || void 0;
  this.rejectUnauthorized = opts.rejectUnauthorized === void 0 ? true : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;
  this.isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
  if (typeof self === "undefined" || this.isReactNative) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }
    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;
  this.open();
}
Socket$1.priorWebsocketSuccess = false;
Emitter$1(Socket$1.prototype);
Socket$1.protocol = parser$1.protocol;
Socket$1.Socket = Socket$1;
Socket$1.Transport = transport;
Socket$1.transports = transports$1;
Socket$1.parser = browser;
Socket$1.prototype.createTransport = function(name) {
  debug$1('creating transport "%s"', name);
  var query = clone(this.query);
  query.EIO = parser$1.protocol;
  query.transport = name;
  var options = this.transportOptions[name] || {};
  if (this.id)
    query.sid = this.id;
  var transport2 = new transports[name]({
    query,
    socket: this,
    agent: options.agent || this.agent,
    hostname: options.hostname || this.hostname,
    port: options.port || this.port,
    secure: options.secure || this.secure,
    path: options.path || this.path,
    forceJSONP: options.forceJSONP || this.forceJSONP,
    jsonp: options.jsonp || this.jsonp,
    forceBase64: options.forceBase64 || this.forceBase64,
    enablesXDR: options.enablesXDR || this.enablesXDR,
    withCredentials: options.withCredentials || this.withCredentials,
    timestampRequests: options.timestampRequests || this.timestampRequests,
    timestampParam: options.timestampParam || this.timestampParam,
    policyPort: options.policyPort || this.policyPort,
    pfx: options.pfx || this.pfx,
    key: options.key || this.key,
    passphrase: options.passphrase || this.passphrase,
    cert: options.cert || this.cert,
    ca: options.ca || this.ca,
    ciphers: options.ciphers || this.ciphers,
    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
    extraHeaders: options.extraHeaders || this.extraHeaders,
    forceNode: options.forceNode || this.forceNode,
    localAddress: options.localAddress || this.localAddress,
    requestTimeout: options.requestTimeout || this.requestTimeout,
    protocols: options.protocols || void 0,
    isReactNative: this.isReactNative
  });
  return transport2;
};
function clone(obj) {
  var o = {};
  for (var i2 in obj) {
    if (obj.hasOwnProperty(i2)) {
      o[i2] = obj[i2];
    }
  }
  return o;
}
Socket$1.prototype.open = function() {
  var transport2;
  if (this.rememberUpgrade && Socket$1.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) {
    transport2 = "websocket";
  } else if (this.transports.length === 0) {
    var self2 = this;
    setTimeout(function() {
      self2.emit("error", "No transports available");
    }, 0);
    return;
  } else {
    transport2 = this.transports[0];
  }
  this.readyState = "opening";
  try {
    transport2 = this.createTransport(transport2);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }
  transport2.open();
  this.setTransport(transport2);
};
Socket$1.prototype.setTransport = function(transport2) {
  debug$1("setting transport %s", transport2.name);
  var self2 = this;
  if (this.transport) {
    debug$1("clearing existing transport %s", this.transport.name);
    this.transport.removeAllListeners();
  }
  this.transport = transport2;
  transport2.on("drain", function() {
    self2.onDrain();
  }).on("packet", function(packet) {
    self2.onPacket(packet);
  }).on("error", function(e) {
    self2.onError(e);
  }).on("close", function() {
    self2.onClose("transport close");
  });
};
Socket$1.prototype.probe = function(name) {
  debug$1('probing transport "%s"', name);
  var transport2 = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self2 = this;
  Socket$1.priorWebsocketSuccess = false;
  function onTransportOpen() {
    if (self2.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self2.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed)
      return;
    debug$1('probe transport "%s" opened', name);
    transport2.send([{ type: "ping", data: "probe" }]);
    transport2.once("packet", function(msg) {
      if (failed)
        return;
      if (msg.type === "pong" && msg.data === "probe") {
        debug$1('probe transport "%s" pong', name);
        self2.upgrading = true;
        self2.emit("upgrading", transport2);
        if (!transport2)
          return;
        Socket$1.priorWebsocketSuccess = transport2.name === "websocket";
        debug$1('pausing current transport "%s"', self2.transport.name);
        self2.transport.pause(function() {
          if (failed)
            return;
          if (self2.readyState === "closed")
            return;
          debug$1("changing transport and sending upgrade packet");
          cleanup();
          self2.setTransport(transport2);
          transport2.send([{ type: "upgrade" }]);
          self2.emit("upgrade", transport2);
          transport2 = null;
          self2.upgrading = false;
          self2.flush();
        });
      } else {
        debug$1('probe transport "%s" failed', name);
        var err = new Error("probe error");
        err.transport = transport2.name;
        self2.emit("upgradeError", err);
      }
    });
  }
  function freezeTransport() {
    if (failed)
      return;
    failed = true;
    cleanup();
    transport2.close();
    transport2 = null;
  }
  function onerror(err) {
    var error = new Error("probe error: " + err);
    error.transport = transport2.name;
    freezeTransport();
    debug$1('probe transport "%s" failed because of error: %s', name, err);
    self2.emit("upgradeError", error);
  }
  function onTransportClose() {
    onerror("transport closed");
  }
  function onclose() {
    onerror("socket closed");
  }
  function onupgrade(to) {
    if (transport2 && to.name !== transport2.name) {
      debug$1('"%s" works - aborting "%s"', to.name, transport2.name);
      freezeTransport();
    }
  }
  function cleanup() {
    transport2.removeListener("open", onTransportOpen);
    transport2.removeListener("error", onerror);
    transport2.removeListener("close", onTransportClose);
    self2.removeListener("close", onclose);
    self2.removeListener("upgrading", onupgrade);
  }
  transport2.once("open", onTransportOpen);
  transport2.once("error", onerror);
  transport2.once("close", onTransportClose);
  this.once("close", onclose);
  this.once("upgrading", onupgrade);
  transport2.open();
};
Socket$1.prototype.onOpen = function() {
  debug$1("socket open");
  this.readyState = "open";
  Socket$1.priorWebsocketSuccess = this.transport.name === "websocket";
  this.emit("open");
  this.flush();
  if (this.readyState === "open" && this.upgrade && this.transport.pause) {
    debug$1("starting upgrade probes");
    for (var i2 = 0, l = this.upgrades.length; i2 < l; i2++) {
      this.probe(this.upgrades[i2]);
    }
  }
};
Socket$1.prototype.onPacket = function(packet) {
  if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
    debug$1('socket receive: type "%s", data "%s"', packet.type, packet.data);
    this.emit("packet", packet);
    this.emit("heartbeat");
    switch (packet.type) {
      case "open":
        this.onHandshake(JSON.parse(packet.data));
        break;
      case "pong":
        this.setPing();
        this.emit("pong");
        break;
      case "error":
        var err = new Error("server error");
        err.code = packet.data;
        this.onError(err);
        break;
      case "message":
        this.emit("data", packet.data);
        this.emit("message", packet.data);
        break;
    }
  } else {
    debug$1('packet received with socket readyState "%s"', this.readyState);
  }
};
Socket$1.prototype.onHandshake = function(data2) {
  this.emit("handshake", data2);
  this.id = data2.sid;
  this.transport.query.sid = data2.sid;
  this.upgrades = this.filterUpgrades(data2.upgrades);
  this.pingInterval = data2.pingInterval;
  this.pingTimeout = data2.pingTimeout;
  this.onOpen();
  if (this.readyState === "closed")
    return;
  this.setPing();
  this.removeListener("heartbeat", this.onHeartbeat);
  this.on("heartbeat", this.onHeartbeat);
};
Socket$1.prototype.onHeartbeat = function(timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self2 = this;
  self2.pingTimeoutTimer = setTimeout(function() {
    if (self2.readyState === "closed")
      return;
    self2.onClose("ping timeout");
  }, timeout || self2.pingInterval + self2.pingTimeout);
};
Socket$1.prototype.setPing = function() {
  var self2 = this;
  clearTimeout(self2.pingIntervalTimer);
  self2.pingIntervalTimer = setTimeout(function() {
    debug$1("writing ping packet - expecting pong within %sms", self2.pingTimeout);
    self2.ping();
    self2.onHeartbeat(self2.pingTimeout);
  }, self2.pingInterval);
};
Socket$1.prototype.ping = function() {
  var self2 = this;
  this.sendPacket("ping", function() {
    self2.emit("ping");
  });
};
Socket$1.prototype.onDrain = function() {
  this.writeBuffer.splice(0, this.prevBufferLen);
  this.prevBufferLen = 0;
  if (this.writeBuffer.length === 0) {
    this.emit("drain");
  } else {
    this.flush();
  }
};
Socket$1.prototype.flush = function() {
  if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
    debug$1("flushing %d packets in socket", this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    this.prevBufferLen = this.writeBuffer.length;
    this.emit("flush");
  }
};
Socket$1.prototype.write = Socket$1.prototype.send = function(msg, options, fn) {
  this.sendPacket("message", msg, options, fn);
  return this;
};
Socket$1.prototype.sendPacket = function(type, data2, options, fn) {
  if (typeof data2 === "function") {
    fn = data2;
    data2 = void 0;
  }
  if (typeof options === "function") {
    fn = options;
    options = null;
  }
  if (this.readyState === "closing" || this.readyState === "closed") {
    return;
  }
  options = options || {};
  options.compress = options.compress !== false;
  var packet = {
    type,
    data: data2,
    options
  };
  this.emit("packetCreate", packet);
  this.writeBuffer.push(packet);
  if (fn)
    this.once("flush", fn);
  this.flush();
};
Socket$1.prototype.close = function() {
  if (this.readyState === "opening" || this.readyState === "open") {
    this.readyState = "closing";
    var self2 = this;
    if (this.writeBuffer.length) {
      this.once("drain", function() {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }
  function close() {
    self2.onClose("forced close");
    debug$1("socket closing - telling transport to close");
    self2.transport.close();
  }
  function cleanupAndClose() {
    self2.removeListener("upgrade", cleanupAndClose);
    self2.removeListener("upgradeError", cleanupAndClose);
    close();
  }
  function waitForUpgrade() {
    self2.once("upgrade", cleanupAndClose);
    self2.once("upgradeError", cleanupAndClose);
  }
  return this;
};
Socket$1.prototype.onError = function(err) {
  debug$1("socket error %j", err);
  Socket$1.priorWebsocketSuccess = false;
  this.emit("error", err);
  this.onClose("transport error", err);
};
Socket$1.prototype.onClose = function(reason, desc) {
  if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
    debug$1('socket close with reason: "%s"', reason);
    var self2 = this;
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);
    this.transport.removeAllListeners("close");
    this.transport.close();
    this.transport.removeAllListeners();
    this.readyState = "closed";
    this.id = null;
    this.emit("close", reason, desc);
    self2.writeBuffer = [];
    self2.prevBufferLen = 0;
  }
};
Socket$1.prototype.filterUpgrades = function(upgrades) {
  var filteredUpgrades = [];
  for (var i2 = 0, j = upgrades.length; i2 < j; i2++) {
    if (~index(this.transports, upgrades[i2]))
      filteredUpgrades.push(upgrades[i2]);
  }
  return filteredUpgrades;
};
lib.exports = socket$1;
lib.exports.parser = browser;
var socket = { exports: {} };
var toArray_1 = toArray;
function toArray(list, index2) {
  var array = [];
  index2 = index2 || 0;
  for (var i2 = index2 || 0; i2 < list.length; i2++) {
    array[i2 - index2] = list[i2];
  }
  return array;
}
var on_1 = on$1;
function on$1(obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function() {
      obj.removeListener(ev, fn);
    }
  };
}
var slice = [].slice;
var componentBind = function(obj, fn) {
  if (typeof fn == "string")
    fn = obj[fn];
  if (typeof fn != "function")
    throw new Error("bind() requires a function");
  var args = slice.call(arguments, 2);
  return function() {
    return fn.apply(obj, args.concat(slice.call(arguments)));
  };
};
(function(module, exports) {
  var parser2 = socket_ioParser;
  var Emitter2 = componentEmitter.exports;
  var toArray2 = toArray_1;
  var on2 = on_1;
  var bind4 = componentBind;
  var debug2 = browser$1.exports("socket.io-client:socket");
  var parseqs2 = parseqs$3;
  var hasBin = hasBinary2;
  module.exports = Socket2;
  var events = {
    connect: 1,
    connect_error: 1,
    connect_timeout: 1,
    connecting: 1,
    disconnect: 1,
    error: 1,
    reconnect: 1,
    reconnect_attempt: 1,
    reconnect_failed: 1,
    reconnect_error: 1,
    reconnecting: 1,
    ping: 1,
    pong: 1
  };
  var emit = Emitter2.prototype.emit;
  function Socket2(io2, nsp, opts) {
    this.io = io2;
    this.nsp = nsp;
    this.json = this;
    this.ids = 0;
    this.acks = {};
    this.receiveBuffer = [];
    this.sendBuffer = [];
    this.connected = false;
    this.disconnected = true;
    this.flags = {};
    if (opts && opts.query) {
      this.query = opts.query;
    }
    if (this.io.autoConnect)
      this.open();
  }
  Emitter2(Socket2.prototype);
  Socket2.prototype.subEvents = function() {
    if (this.subs)
      return;
    var io2 = this.io;
    this.subs = [
      on2(io2, "open", bind4(this, "onopen")),
      on2(io2, "packet", bind4(this, "onpacket")),
      on2(io2, "close", bind4(this, "onclose"))
    ];
  };
  Socket2.prototype.open = Socket2.prototype.connect = function() {
    if (this.connected)
      return this;
    this.subEvents();
    if (!this.io.reconnecting)
      this.io.open();
    if (this.io.readyState === "open")
      this.onopen();
    this.emit("connecting");
    return this;
  };
  Socket2.prototype.send = function() {
    var args = toArray2(arguments);
    args.unshift("message");
    this.emit.apply(this, args);
    return this;
  };
  Socket2.prototype.emit = function(ev) {
    if (events.hasOwnProperty(ev)) {
      emit.apply(this, arguments);
      return this;
    }
    var args = toArray2(arguments);
    var packet = {
      type: (this.flags.binary !== void 0 ? this.flags.binary : hasBin(args)) ? parser2.BINARY_EVENT : parser2.EVENT,
      data: args
    };
    packet.options = {};
    packet.options.compress = !this.flags || this.flags.compress !== false;
    if (typeof args[args.length - 1] === "function") {
      debug2("emitting packet with ack id %d", this.ids);
      this.acks[this.ids] = args.pop();
      packet.id = this.ids++;
    }
    if (this.connected) {
      this.packet(packet);
    } else {
      this.sendBuffer.push(packet);
    }
    this.flags = {};
    return this;
  };
  Socket2.prototype.packet = function(packet) {
    packet.nsp = this.nsp;
    this.io.packet(packet);
  };
  Socket2.prototype.onopen = function() {
    debug2("transport is open - connecting");
    if (this.nsp !== "/") {
      if (this.query) {
        var query = typeof this.query === "object" ? parseqs2.encode(this.query) : this.query;
        debug2("sending connect packet with query %s", query);
        this.packet({ type: parser2.CONNECT, query });
      } else {
        this.packet({ type: parser2.CONNECT });
      }
    }
  };
  Socket2.prototype.onclose = function(reason) {
    debug2("close (%s)", reason);
    this.connected = false;
    this.disconnected = true;
    delete this.id;
    this.emit("disconnect", reason);
  };
  Socket2.prototype.onpacket = function(packet) {
    var sameNamespace = packet.nsp === this.nsp;
    var rootNamespaceError = packet.type === parser2.ERROR && packet.nsp === "/";
    if (!sameNamespace && !rootNamespaceError)
      return;
    switch (packet.type) {
      case parser2.CONNECT:
        this.onconnect();
        break;
      case parser2.EVENT:
        this.onevent(packet);
        break;
      case parser2.BINARY_EVENT:
        this.onevent(packet);
        break;
      case parser2.ACK:
        this.onack(packet);
        break;
      case parser2.BINARY_ACK:
        this.onack(packet);
        break;
      case parser2.DISCONNECT:
        this.ondisconnect();
        break;
      case parser2.ERROR:
        this.emit("error", packet.data);
        break;
    }
  };
  Socket2.prototype.onevent = function(packet) {
    var args = packet.data || [];
    debug2("emitting event %j", args);
    if (packet.id != null) {
      debug2("attaching ack callback to event");
      args.push(this.ack(packet.id));
    }
    if (this.connected) {
      emit.apply(this, args);
    } else {
      this.receiveBuffer.push(args);
    }
  };
  Socket2.prototype.ack = function(id) {
    var self2 = this;
    var sent = false;
    return function() {
      if (sent)
        return;
      sent = true;
      var args = toArray2(arguments);
      debug2("sending ack %j", args);
      self2.packet({
        type: hasBin(args) ? parser2.BINARY_ACK : parser2.ACK,
        id,
        data: args
      });
    };
  };
  Socket2.prototype.onack = function(packet) {
    var ack = this.acks[packet.id];
    if (typeof ack === "function") {
      debug2("calling ack %s with %j", packet.id, packet.data);
      ack.apply(this, packet.data);
      delete this.acks[packet.id];
    } else {
      debug2("bad ack %s", packet.id);
    }
  };
  Socket2.prototype.onconnect = function() {
    this.connected = true;
    this.disconnected = false;
    this.emit("connect");
    this.emitBuffered();
  };
  Socket2.prototype.emitBuffered = function() {
    var i2;
    for (i2 = 0; i2 < this.receiveBuffer.length; i2++) {
      emit.apply(this, this.receiveBuffer[i2]);
    }
    this.receiveBuffer = [];
    for (i2 = 0; i2 < this.sendBuffer.length; i2++) {
      this.packet(this.sendBuffer[i2]);
    }
    this.sendBuffer = [];
  };
  Socket2.prototype.ondisconnect = function() {
    debug2("server disconnect (%s)", this.nsp);
    this.destroy();
    this.onclose("io server disconnect");
  };
  Socket2.prototype.destroy = function() {
    if (this.subs) {
      for (var i2 = 0; i2 < this.subs.length; i2++) {
        this.subs[i2].destroy();
      }
      this.subs = null;
    }
    this.io.destroy(this);
  };
  Socket2.prototype.close = Socket2.prototype.disconnect = function() {
    if (this.connected) {
      debug2("performing disconnect (%s)", this.nsp);
      this.packet({ type: parser2.DISCONNECT });
    }
    this.destroy();
    if (this.connected) {
      this.onclose("io client disconnect");
    }
    return this;
  };
  Socket2.prototype.compress = function(compress) {
    this.flags.compress = compress;
    return this;
  };
  Socket2.prototype.binary = function(binary2) {
    this.flags.binary = binary2;
    return this;
  };
})(socket);
var backo2 = Backoff$1;
function Backoff$1(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 1e4;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}
Backoff$1.prototype.duration = function() {
  var ms2 = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand = Math.random();
    var deviation = Math.floor(rand * this.jitter * ms2);
    ms2 = (Math.floor(rand * 10) & 1) == 0 ? ms2 - deviation : ms2 + deviation;
  }
  return Math.min(ms2, this.max) | 0;
};
Backoff$1.prototype.reset = function() {
  this.attempts = 0;
};
Backoff$1.prototype.setMin = function(min) {
  this.ms = min;
};
Backoff$1.prototype.setMax = function(max) {
  this.max = max;
};
Backoff$1.prototype.setJitter = function(jitter) {
  this.jitter = jitter;
};
var eio = lib.exports;
var Socket = socket.exports;
var Emitter = componentEmitter.exports;
var parser = socket_ioParser;
var on = on_1;
var bind3 = componentBind;
var debug = browser$1.exports("socket.io-client:manager");
var indexOf = indexof;
var Backoff = backo2;
var has = Object.prototype.hasOwnProperty;
var manager = Manager;
function Manager(uri, opts) {
  if (!(this instanceof Manager))
    return new Manager(uri, opts);
  if (uri && typeof uri === "object") {
    opts = uri;
    uri = void 0;
  }
  opts = opts || {};
  opts.path = opts.path || "/socket.io";
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1e3);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5e3);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(opts.timeout == null ? 2e4 : opts.timeout);
  this.readyState = "closed";
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  var _parser = opts.parser || parser;
  this.encoder = new _parser.Encoder();
  this.decoder = new _parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect)
    this.open();
}
Manager.prototype.emitAll = function() {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};
Manager.prototype.updateSocketIds = function() {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.generateId(nsp);
    }
  }
};
Manager.prototype.generateId = function(nsp) {
  return (nsp === "/" ? "" : nsp + "#") + this.engine.id;
};
Emitter(Manager.prototype);
Manager.prototype.reconnection = function(v) {
  if (!arguments.length)
    return this._reconnection;
  this._reconnection = !!v;
  return this;
};
Manager.prototype.reconnectionAttempts = function(v) {
  if (!arguments.length)
    return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};
Manager.prototype.reconnectionDelay = function(v) {
  if (!arguments.length)
    return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};
Manager.prototype.randomizationFactor = function(v) {
  if (!arguments.length)
    return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};
Manager.prototype.reconnectionDelayMax = function(v) {
  if (!arguments.length)
    return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};
Manager.prototype.timeout = function(v) {
  if (!arguments.length)
    return this._timeout;
  this._timeout = v;
  return this;
};
Manager.prototype.maybeReconnectOnOpen = function() {
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    this.reconnect();
  }
};
Manager.prototype.open = Manager.prototype.connect = function(fn, opts) {
  debug("readyState %s", this.readyState);
  if (~this.readyState.indexOf("open"))
    return this;
  debug("opening %s", this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket2 = this.engine;
  var self2 = this;
  this.readyState = "opening";
  this.skipReconnect = false;
  var openSub = on(socket2, "open", function() {
    self2.onopen();
    fn && fn();
  });
  var errorSub = on(socket2, "error", function(data2) {
    debug("connect_error");
    self2.cleanup();
    self2.readyState = "closed";
    self2.emitAll("connect_error", data2);
    if (fn) {
      var err = new Error("Connection error");
      err.data = data2;
      fn(err);
    } else {
      self2.maybeReconnectOnOpen();
    }
  });
  if (this._timeout !== false) {
    var timeout = this._timeout;
    debug("connect attempt will timeout after %d", timeout);
    if (timeout === 0) {
      openSub.destroy();
    }
    var timer = setTimeout(function() {
      debug("connect attempt timed out after %d", timeout);
      openSub.destroy();
      socket2.close();
      socket2.emit("error", "timeout");
      self2.emitAll("connect_timeout", timeout);
    }, timeout);
    this.subs.push({
      destroy: function() {
        clearTimeout(timer);
      }
    });
  }
  this.subs.push(openSub);
  this.subs.push(errorSub);
  return this;
};
Manager.prototype.onopen = function() {
  debug("open");
  this.cleanup();
  this.readyState = "open";
  this.emit("open");
  var socket2 = this.engine;
  this.subs.push(on(socket2, "data", bind3(this, "ondata")));
  this.subs.push(on(socket2, "ping", bind3(this, "onping")));
  this.subs.push(on(socket2, "pong", bind3(this, "onpong")));
  this.subs.push(on(socket2, "error", bind3(this, "onerror")));
  this.subs.push(on(socket2, "close", bind3(this, "onclose")));
  this.subs.push(on(this.decoder, "decoded", bind3(this, "ondecoded")));
};
Manager.prototype.onping = function() {
  this.lastPing = new Date();
  this.emitAll("ping");
};
Manager.prototype.onpong = function() {
  this.emitAll("pong", new Date() - this.lastPing);
};
Manager.prototype.ondata = function(data2) {
  this.decoder.add(data2);
};
Manager.prototype.ondecoded = function(packet) {
  this.emit("packet", packet);
};
Manager.prototype.onerror = function(err) {
  debug("error", err);
  this.emitAll("error", err);
};
Manager.prototype.socket = function(nsp, opts) {
  var socket2 = this.nsps[nsp];
  if (!socket2) {
    socket2 = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket2;
    var self2 = this;
    socket2.on("connecting", onConnecting);
    socket2.on("connect", function() {
      socket2.id = self2.generateId(nsp);
    });
    if (this.autoConnect) {
      onConnecting();
    }
  }
  function onConnecting() {
    if (!~indexOf(self2.connecting, socket2)) {
      self2.connecting.push(socket2);
    }
  }
  return socket2;
};
Manager.prototype.destroy = function(socket2) {
  var index2 = indexOf(this.connecting, socket2);
  if (~index2)
    this.connecting.splice(index2, 1);
  if (this.connecting.length)
    return;
  this.close();
};
Manager.prototype.packet = function(packet) {
  debug("writing packet %j", packet);
  var self2 = this;
  if (packet.query && packet.type === 0)
    packet.nsp += "?" + packet.query;
  if (!self2.encoding) {
    self2.encoding = true;
    this.encoder.encode(packet, function(encodedPackets) {
      for (var i2 = 0; i2 < encodedPackets.length; i2++) {
        self2.engine.write(encodedPackets[i2], packet.options);
      }
      self2.encoding = false;
      self2.processPacketQueue();
    });
  } else {
    self2.packetBuffer.push(packet);
  }
};
Manager.prototype.processPacketQueue = function() {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};
Manager.prototype.cleanup = function() {
  debug("cleanup");
  var subsLength = this.subs.length;
  for (var i2 = 0; i2 < subsLength; i2++) {
    var sub = this.subs.shift();
    sub.destroy();
  }
  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;
  this.decoder.destroy();
};
Manager.prototype.close = Manager.prototype.disconnect = function() {
  debug("disconnect");
  this.skipReconnect = true;
  this.reconnecting = false;
  if (this.readyState === "opening") {
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = "closed";
  if (this.engine)
    this.engine.close();
};
Manager.prototype.onclose = function(reason) {
  debug("onclose");
  this.cleanup();
  this.backoff.reset();
  this.readyState = "closed";
  this.emit("close", reason);
  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};
Manager.prototype.reconnect = function() {
  if (this.reconnecting || this.skipReconnect)
    return this;
  var self2 = this;
  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug("reconnect failed");
    this.backoff.reset();
    this.emitAll("reconnect_failed");
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug("will wait %dms before reconnect attempt", delay);
    this.reconnecting = true;
    var timer = setTimeout(function() {
      if (self2.skipReconnect)
        return;
      debug("attempting reconnect");
      self2.emitAll("reconnect_attempt", self2.backoff.attempts);
      self2.emitAll("reconnecting", self2.backoff.attempts);
      if (self2.skipReconnect)
        return;
      self2.open(function(err) {
        if (err) {
          debug("reconnect attempt error");
          self2.reconnecting = false;
          self2.reconnect();
          self2.emitAll("reconnect_error", err.data);
        } else {
          debug("reconnect success");
          self2.onreconnect();
        }
      });
    }, delay);
    this.subs.push({
      destroy: function() {
        clearTimeout(timer);
      }
    });
  }
};
Manager.prototype.onreconnect = function() {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll("reconnect", attempt);
};
(function(module, exports) {
  var url2 = url_1;
  var parser2 = socket_ioParser;
  var Manager2 = manager;
  var debug2 = browser$1.exports("socket.io-client");
  module.exports = exports = lookup;
  var cache2 = exports.managers = {};
  function lookup(uri, opts) {
    if (typeof uri === "object") {
      opts = uri;
      uri = void 0;
    }
    opts = opts || {};
    var parsed = url2(uri);
    var source2 = parsed.source;
    var id = parsed.id;
    var path = parsed.path;
    var sameNamespace = cache2[id] && path in cache2[id].nsps;
    var newConnection = opts.forceNew || opts["force new connection"] || opts.multiplex === false || sameNamespace;
    var io2;
    if (newConnection) {
      debug2("ignoring socket cache for %s", source2);
      io2 = Manager2(source2, opts);
    } else {
      if (!cache2[id]) {
        debug2("new io instance for %s", source2);
        cache2[id] = Manager2(source2, opts);
      }
      io2 = cache2[id];
    }
    if (parsed.query && !opts.query) {
      opts.query = parsed.query;
    }
    return io2.socket(parsed.path, opts);
  }
  exports.protocol = parser2.protocol;
  exports.connect = lookup;
  exports.Manager = manager;
  exports.Socket = socket.exports;
})(lib$1, lib$1.exports);
var io = lib$1.exports;
const useTWIMSocketSymbol = Symbol("useTWIMSocket");
function createSocket(url2, account, user) {
  return new Promise((resolve, reject) => {
    const installationId = account.id;
    const auth = {
      clientVersion: 1.1,
      installationId,
      userId: user.id,
      fname: user.firstName,
      lname: user.lastName,
      authToken: user.auth.token,
      timestamp: user.auth.timestamp
    };
    const socket2 = io.connect(url2, {
      path: `/socket.io/${installationId}`,
      timeout: 5e3,
      reconnection: false,
      forceNew: true,
      transports: ["websocket"]
    });
    function handleConnectionError() {
      done(new Error("useTWIMSocket: Failed to connect"));
    }
    function sendAuth() {
      socket2.emit("auth", auth);
    }
    function handleAuthResult({ authenticated, serverVersion }) {
      done(authenticated && serverVersion != null ? null : new Error("useTWIMSocket: Failed to authenticate"));
    }
    socket2.on("error", handleConnectionError);
    socket2.on("connect_error", handleConnectionError);
    socket2.on("disconnect", handleConnectionError);
    socket2.on("connect", sendAuth);
    socket2.on("authResult", handleAuthResult);
    function done(error) {
      socket2.off("error", handleConnectionError);
      socket2.off("connect_error", handleConnectionError);
      socket2.off("disconnect", handleConnectionError);
      socket2.off("connect", sendAuth);
      socket2.off("authResult", handleAuthResult);
      if (error) {
        socket2.disconnect();
        reject(error);
      } else {
        resolve(socket2);
      }
    }
  });
}
function provideTWIMSocket(socketUrl) {
  assertHasScope();
  const account = useCurrentAccount();
  const user = useCurrentUser();
  let attempt = 0;
  let timeout;
  const promise = shallowRef();
  const socket2 = shallowRef();
  function initSocket(localSocket) {
    socket2.value = localSocket;
    const localDisconnect = () => {
      localSocket.off("error", localDisconnect);
      localSocket.off("connect_error", localDisconnect);
      localSocket.off("disconnect", localDisconnect);
      localSocket.disconnect();
      if (socket2.value === localSocket) {
        socket2.value = void 0;
      }
    };
    localSocket.on("error", localDisconnect);
    localSocket.on("connect_error", localDisconnect);
    localSocket.on("disconnect", localDisconnect);
  }
  function disconnect() {
    clearTimeout(timeout);
    promise.value = void 0;
    if (socket2.value)
      socket2.value.disconnect();
    socket2.value = void 0;
  }
  function connect() {
    if (promise.value)
      return;
    if (socket2.value)
      return;
    if (!account.value)
      return;
    if (!user.value)
      return;
    const localPromise = createSocket(socketUrl(account.value), account.value, user.value);
    promise.value = localPromise;
    localPromise.then((localSocket) => {
      if (promise.value === localPromise) {
        promise.value = void 0;
        initSocket(localSocket);
      } else {
        localSocket.disconnect();
      }
    }).catch(() => {
      if (promise.value === localPromise) {
        promise.value = void 0;
      }
    });
  }
  watch([
    () => account.value && account.value.id,
    () => user.value && user.value.id
  ], () => {
    attempt = 0;
    disconnect();
    connect();
  });
  watch([socket2, promise], () => {
    if (promise.value)
      return;
    if (socket2.value)
      return;
    const delay = Math.min(attempt * 3e3, 6e4) + Math.random() * 5e3;
    attempt += 1;
    clearTimeout(timeout);
    timeout = setTimeout(connect, delay);
  });
  onUnmounted(disconnect);
  connect();
  provide(useTWIMSocketSymbol, socket2);
}
function useTWIMSocket() {
  return inject(useTWIMSocketSymbol);
}
export { assertHasScope, assertInComponent, createFilterState, exponentialBackOff, fileTypeGroups, provideAxios, provideBranding, provideCurrentAccount, provideCurrentUser, provideOptimisticUpdates, provideRealTimeUpdates, provideTWIMSocket, raf, rafCallback, setup, testInComponent, until, useAxios, useAxiosRequestInterceptor, useAxiosResponseInterceptor, useBackOff, useBoardColumnsLoader, useBranding, useBrandingLoader, useCategoriesLoader, useCompaniesLoader, useConvertCentValue, useCurrentAccount, useCurrentAccountLoader, useCurrentUser, useCurrentUserLoader, useCustomFieldsLoader, useDataViewActions, useDataViewsLoader, useDelayLoader, useFeaturesLoader, useFileActions, useFilesLoader, useFilters, useIntersectionRef, useItemLoader, useListLoader, useLocalRef, useMilestoneActions, useMilestonesLoader, useOptimisticUpdates, usePeopleLoader, usePortfolioActions, usePredecessorsLoader, usePreventLoaderFlash, useProfitabilityProjectsLoader, useProfitabilityUsersLoader, useProjectActions, useProjectBudgetActions, useProjectBudgetCountsLoader, useProjectBudgetExpenseActions, useProjectBudgetExpensesLoader, useProjectBudgetUsagesLoader, useProjectBudgetsLoader, useProjectLoader, useProjectRateLoader, useProjectsLoader, useProjectsRateLoader, useRealTimeUpdates, useRecentsLoader, useRemindersLoader, useS3Presign, useSharedBoardColumnsLoader, useTWIMSocket, useTagsLoader, useTaskActions, useTasklistsV1Loader as useTaskListsLoader, useTaskRecurringLoader, useTasklistBudgetActions, useTasklistBudgetLoader, useTasklistBudgetsLoader, useTasklistsV1Loader, useTasklistsLoader as useTasklistsV3Loader, useTasksLoader, useTimelogActions, useTimelogTotalsLoader, useTimelogsLoader, useUserRateActions, useUserRatesLoader, useUtilizationPeopleLoader };
